/* eslint-disable */
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  BigFloat: any;
  BigInt: any;
  Cursor: any;
  Date: any;
  Datetime: any;
  JSON: any;
  UUID: any;
};

/** PIO advertiser, agency, brand, partner, and holding-company reference data. */
export type Advertiser = {
  __typename?: 'Advertiser';
  /** Optional GAM/DCM company ID used to connect advertiser account records to ad-server entities. */
  adServerId?: Maybe<Scalars['String']>;
  archivedAt?: Maybe<Scalars['Datetime']>;
  /** Reads and enables pagination through a set of `Campaign`. */
  campaigns: CampaignsConnection;
  /** Reads and enables pagination through a set of `Campaign`. */
  campaignsByAgencyId: CampaignsConnection;
  /** Reads and enables pagination through a set of `Campaign`. */
  campaignsByBillToAdvertiserId: CampaignsConnection;
  /** Reads and enables pagination through a set of `Campaign`. */
  campaignsByBrandId: CampaignsConnection;
  /** Reads and enables pagination through a set of `Advertiser`. */
  childAdvertisers: AdvertisersConnection;
  createdAt: Scalars['Datetime'];
  externalPioId?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  name: Scalars['String'];
  /** Reads a single `Advertiser` that is related to this `Advertiser`. */
  parent?: Maybe<Advertiser>;
  /** Optional self-reference for agency, brand, partner, or holding-company hierarchy imported from PIO. */
  parentId?: Maybe<Scalars['UUID']>;
  type: AdvertiserType;
  updatedAt: Scalars['Datetime'];
};


/** PIO advertiser, agency, brand, partner, and holding-company reference data. */
export type AdvertiserCampaignsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<CampaignCondition>;
  filter?: InputMaybe<CampaignFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CampaignsOrderBy>>;
};


/** PIO advertiser, agency, brand, partner, and holding-company reference data. */
export type AdvertiserCampaignsByAgencyIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<CampaignCondition>;
  filter?: InputMaybe<CampaignFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CampaignsOrderBy>>;
};


/** PIO advertiser, agency, brand, partner, and holding-company reference data. */
export type AdvertiserCampaignsByBillToAdvertiserIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<CampaignCondition>;
  filter?: InputMaybe<CampaignFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CampaignsOrderBy>>;
};


/** PIO advertiser, agency, brand, partner, and holding-company reference data. */
export type AdvertiserCampaignsByBrandIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<CampaignCondition>;
  filter?: InputMaybe<CampaignFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CampaignsOrderBy>>;
};


/** PIO advertiser, agency, brand, partner, and holding-company reference data. */
export type AdvertiserChildAdvertisersArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<AdvertiserCondition>;
  filter?: InputMaybe<AdvertiserFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AdvertisersOrderBy>>;
};

/**
 * A condition to be used against `Advertiser` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type AdvertiserCondition = {
  /** Checks for equality with the object’s `adServerId` field. */
  adServerId?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `archivedAt` field. */
  archivedAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `externalPioId` field. */
  externalPioId?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `parentId` field. */
  parentId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `type` field. */
  type?: InputMaybe<AdvertiserType>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** A filter to be used against `Advertiser` object types. All fields are combined with a logical ‘and.’ */
export type AdvertiserFilter = {
  /** Filter by the object’s `adServerId` field. */
  adServerId?: InputMaybe<StringFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<AdvertiserFilter>>;
  /** Filter by the object’s `archivedAt` field. */
  archivedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `externalPioId` field. */
  externalPioId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<AdvertiserFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<AdvertiserFilter>>;
  /** Filter by the object’s `parentId` field. */
  parentId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `type` field. */
  type?: InputMaybe<AdvertiserTypeFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
};

/** An input for mutations affecting `Advertiser` */
export type AdvertiserInput = {
  /** Optional GAM/DCM company ID used to connect advertiser account records to ad-server entities. */
  adServerId?: InputMaybe<Scalars['String']>;
  archivedAt?: InputMaybe<Scalars['Datetime']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  externalPioId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  name: Scalars['String'];
  /** Optional self-reference for agency, brand, partner, or holding-company hierarchy imported from PIO. */
  parentId?: InputMaybe<Scalars['UUID']>;
  type: AdvertiserType;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** Represents an update to a `Advertiser`. Fields that are set will be updated. */
export type AdvertiserPatch = {
  /** Optional GAM/DCM company ID used to connect advertiser account records to ad-server entities. */
  adServerId?: InputMaybe<Scalars['String']>;
  archivedAt?: InputMaybe<Scalars['Datetime']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  externalPioId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  /** Optional self-reference for agency, brand, partner, or holding-company hierarchy imported from PIO. */
  parentId?: InputMaybe<Scalars['UUID']>;
  type?: InputMaybe<AdvertiserType>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

export enum AdvertiserType {
  Advertiser = 'ADVERTISER',
  Agency = 'AGENCY',
  Brand = 'BRAND',
  HoldingCompany = 'HOLDING_COMPANY',
  Partner = 'PARTNER'
}

/** A filter to be used against AdvertiserType fields. All fields are combined with a logical ‘and.’ */
export type AdvertiserTypeFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<AdvertiserType>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<AdvertiserType>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<AdvertiserType>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<AdvertiserType>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<AdvertiserType>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<AdvertiserType>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<AdvertiserType>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<AdvertiserType>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<AdvertiserType>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<AdvertiserType>>;
};

/** A connection to a list of `Advertiser` values. */
export type AdvertisersConnection = {
  __typename?: 'AdvertisersConnection';
  /** A list of edges which contains the `Advertiser` and cursor to aid in pagination. */
  edges: Array<AdvertisersEdge>;
  /** A list of `Advertiser` objects. */
  nodes: Array<Advertiser>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Advertiser` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Advertiser` edge in the connection. */
export type AdvertisersEdge = {
  __typename?: 'AdvertisersEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `Advertiser` at the end of the edge. */
  node: Advertiser;
};

/** Methods to use when ordering `Advertiser`. */
export enum AdvertisersOrderBy {
  AdServerIdAsc = 'AD_SERVER_ID_ASC',
  AdServerIdDesc = 'AD_SERVER_ID_DESC',
  ArchivedAtAsc = 'ARCHIVED_AT_ASC',
  ArchivedAtDesc = 'ARCHIVED_AT_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  ExternalPioIdAsc = 'EXTERNAL_PIO_ID_ASC',
  ExternalPioIdDesc = 'EXTERNAL_PIO_ID_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  Natural = 'NATURAL',
  ParentIdAsc = 'PARENT_ID_ASC',
  ParentIdDesc = 'PARENT_ID_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  TypeAsc = 'TYPE_ASC',
  TypeDesc = 'TYPE_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC'
}

/**
 * Banner targeting settings for a given Placements.IO line item.
 *
 * Permissions: csapp_admin has SELECT, INSERT, UPDATE, DELETE
 */
export type BannerTargeting = {
  __typename?: 'BannerTargeting';
  /** End of date range (Eastern Time) during which the targeting will be made available to Google Ad Manager. */
  endsAt: Scalars['Datetime'];
  id: Scalars['Int'];
  /** Reads a single `LineItem` that is related to this `BannerTargeting`. */
  lineItem?: Maybe<LineItem>;
  /** Native CSAdmin line item FK added for PIO migration parallel-run; placements_line_item_id remains for rollback. */
  lineItemId?: Maybe<Scalars['UUID']>;
  placementsCampaignId?: Maybe<Scalars['String']>;
  placementsLineItemId?: Maybe<Scalars['String']>;
  /** Beginning of date range (Eastern Time) during which the targeting will be made available to Google Ad Manager. */
  startsAt: Scalars['Datetime'];
  /** Reads a single `TargetList` that is related to this `BannerTargeting`. */
  targetList?: Maybe<TargetList>;
  /** ID of the target list that should be made available to Google Ad Manager for ad targeting. */
  targetListId: Scalars['Int'];
};

/**
 * A condition to be used against `BannerTargeting` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type BannerTargetingCondition = {
  /** Checks for equality with the object’s `endsAt` field. */
  endsAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `lineItemId` field. */
  lineItemId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `placementsCampaignId` field. */
  placementsCampaignId?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `placementsLineItemId` field. */
  placementsLineItemId?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `startsAt` field. */
  startsAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `targetListId` field. */
  targetListId?: InputMaybe<Scalars['Int']>;
};

/** A filter to be used against `BannerTargeting` object types. All fields are combined with a logical ‘and.’ */
export type BannerTargetingFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<BannerTargetingFilter>>;
  /** Filter by the object’s `endsAt` field. */
  endsAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `lineItemId` field. */
  lineItemId?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<BannerTargetingFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<BannerTargetingFilter>>;
  /** Filter by the object’s `placementsCampaignId` field. */
  placementsCampaignId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `placementsLineItemId` field. */
  placementsLineItemId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `startsAt` field. */
  startsAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `targetListId` field. */
  targetListId?: InputMaybe<IntFilter>;
};

/** An input for mutations affecting `BannerTargeting` */
export type BannerTargetingInput = {
  /** End of date range (Eastern Time) during which the targeting will be made available to Google Ad Manager. */
  endsAt: Scalars['Datetime'];
  id?: InputMaybe<Scalars['Int']>;
  /** Native CSAdmin line item FK added for PIO migration parallel-run; placements_line_item_id remains for rollback. */
  lineItemId?: InputMaybe<Scalars['UUID']>;
  placementsCampaignId?: InputMaybe<Scalars['String']>;
  placementsLineItemId?: InputMaybe<Scalars['String']>;
  /** Beginning of date range (Eastern Time) during which the targeting will be made available to Google Ad Manager. */
  startsAt: Scalars['Datetime'];
  /** ID of the target list that should be made available to Google Ad Manager for ad targeting. */
  targetListId: Scalars['Int'];
};

/** Represents an update to a `BannerTargeting`. Fields that are set will be updated. */
export type BannerTargetingPatch = {
  /** End of date range (Eastern Time) during which the targeting will be made available to Google Ad Manager. */
  endsAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['Int']>;
  /** Native CSAdmin line item FK added for PIO migration parallel-run; placements_line_item_id remains for rollback. */
  lineItemId?: InputMaybe<Scalars['UUID']>;
  placementsCampaignId?: InputMaybe<Scalars['String']>;
  placementsLineItemId?: InputMaybe<Scalars['String']>;
  /** Beginning of date range (Eastern Time) during which the targeting will be made available to Google Ad Manager. */
  startsAt?: InputMaybe<Scalars['Datetime']>;
  /** ID of the target list that should be made available to Google Ad Manager for ad targeting. */
  targetListId?: InputMaybe<Scalars['Int']>;
};

/** A connection to a list of `BannerTargeting` values. */
export type BannerTargetingsConnection = {
  __typename?: 'BannerTargetingsConnection';
  /** A list of edges which contains the `BannerTargeting` and cursor to aid in pagination. */
  edges: Array<BannerTargetingsEdge>;
  /** A list of `BannerTargeting` objects. */
  nodes: Array<BannerTargeting>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `BannerTargeting` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `BannerTargeting` edge in the connection. */
export type BannerTargetingsEdge = {
  __typename?: 'BannerTargetingsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `BannerTargeting` at the end of the edge. */
  node: BannerTargeting;
};

/** Methods to use when ordering `BannerTargeting`. */
export enum BannerTargetingsOrderBy {
  EndsAtAsc = 'ENDS_AT_ASC',
  EndsAtDesc = 'ENDS_AT_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  LineItemIdAsc = 'LINE_ITEM_ID_ASC',
  LineItemIdDesc = 'LINE_ITEM_ID_DESC',
  Natural = 'NATURAL',
  PlacementsCampaignIdAsc = 'PLACEMENTS_CAMPAIGN_ID_ASC',
  PlacementsCampaignIdDesc = 'PLACEMENTS_CAMPAIGN_ID_DESC',
  PlacementsLineItemIdAsc = 'PLACEMENTS_LINE_ITEM_ID_ASC',
  PlacementsLineItemIdDesc = 'PLACEMENTS_LINE_ITEM_ID_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  StartsAtAsc = 'STARTS_AT_ASC',
  StartsAtDesc = 'STARTS_AT_DESC',
  TargetListIdAsc = 'TARGET_LIST_ID_ASC',
  TargetListIdDesc = 'TARGET_LIST_ID_DESC'
}

/** A filter to be used against BigFloat fields. All fields are combined with a logical ‘and.’ */
export type BigFloatFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Scalars['BigFloat']>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Scalars['BigFloat']>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Scalars['BigFloat']>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Scalars['BigFloat']>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<Scalars['BigFloat']>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Scalars['BigFloat']>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Scalars['BigFloat']>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Scalars['BigFloat']>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Scalars['BigFloat']>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Scalars['BigFloat']>>;
};

/** A filter to be used against BigInt fields. All fields are combined with a logical ‘and.’ */
export type BigIntFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Scalars['BigInt']>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Scalars['BigInt']>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Scalars['BigInt']>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Scalars['BigInt']>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<Scalars['BigInt']>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Scalars['BigInt']>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Scalars['BigInt']>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Scalars['BigInt']>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Scalars['BigInt']>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Scalars['BigInt']>>;
};

/** A filter to be used against Boolean fields. All fields are combined with a logical ‘and.’ */
export type BooleanFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Scalars['Boolean']>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Scalars['Boolean']>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Scalars['Boolean']>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Scalars['Boolean']>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<Scalars['Boolean']>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Scalars['Boolean']>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Scalars['Boolean']>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Scalars['Boolean']>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Scalars['Boolean']>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Scalars['Boolean']>>;
};

/** PIO campaign records with preserved campaign numbers for CS navigation and downstream imports. */
export type Campaign = {
  __typename?: 'Campaign';
  /** Reads a single `Advertiser` that is related to this `Campaign`. */
  advertiser?: Maybe<Advertiser>;
  advertiserId?: Maybe<Scalars['UUID']>;
  /** Reads a single `Advertiser` that is related to this `Campaign`. */
  agency?: Maybe<Advertiser>;
  agencyId?: Maybe<Scalars['UUID']>;
  archivedAt?: Maybe<Scalars['Datetime']>;
  /** Reads a single `Advertiser` that is related to this `Campaign`. */
  billToAdvertiser?: Maybe<Advertiser>;
  billToAdvertiserId?: Maybe<Scalars['UUID']>;
  billingPeriod?: Maybe<Scalars['String']>;
  billingSchedule?: Maybe<Scalars['String']>;
  /** Reads a single `Advertiser` that is related to this `Campaign`. */
  brand?: Maybe<Advertiser>;
  brandId?: Maybe<Scalars['UUID']>;
  budget?: Maybe<Scalars['BigFloat']>;
  /** Four-digit PIO campaign number used by Client Services and preserved during import. */
  campaignNumber: Scalars['Int'];
  createdAt: Scalars['Datetime'];
  /** Campaign Manager 360 advertiser ID retained for campaign-level ad-server handoff. */
  dcmAdvertiserId?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  endDate?: Maybe<Scalars['Date']>;
  externalPioId?: Maybe<Scalars['String']>;
  /** Google Ad Manager order ID retained for campaign-level ad-server handoff. */
  gamOrderId?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** Reads and enables pagination through a set of `LineItem`. */
  lineItems: LineItemsConnection;
  name?: Maybe<Scalars['String']>;
  poNumber?: Maybe<Scalars['String']>;
  salespersonEmail?: Maybe<Scalars['String']>;
  /** Optional SharePoint contract URL; SharePoint remains the system of record for contracts. */
  sharepointContractUrl?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['Date']>;
  traffickerEmail?: Maybe<Scalars['String']>;
  updatedAt: Scalars['Datetime'];
};


/** PIO campaign records with preserved campaign numbers for CS navigation and downstream imports. */
export type CampaignLineItemsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<LineItemCondition>;
  filter?: InputMaybe<LineItemFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LineItemsOrderBy>>;
};

/**
 * A condition to be used against `Campaign` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type CampaignCondition = {
  /** Checks for equality with the object’s `advertiserId` field. */
  advertiserId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `agencyId` field. */
  agencyId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `archivedAt` field. */
  archivedAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `billToAdvertiserId` field. */
  billToAdvertiserId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `billingPeriod` field. */
  billingPeriod?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `billingSchedule` field. */
  billingSchedule?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `brandId` field. */
  brandId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `budget` field. */
  budget?: InputMaybe<Scalars['BigFloat']>;
  /** Checks for equality with the object’s `campaignNumber` field. */
  campaignNumber?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `dcmAdvertiserId` field. */
  dcmAdvertiserId?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `description` field. */
  description?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `endDate` field. */
  endDate?: InputMaybe<Scalars['Date']>;
  /** Checks for equality with the object’s `externalPioId` field. */
  externalPioId?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `gamOrderId` field. */
  gamOrderId?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `poNumber` field. */
  poNumber?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `salespersonEmail` field. */
  salespersonEmail?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `sharepointContractUrl` field. */
  sharepointContractUrl?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `startDate` field. */
  startDate?: InputMaybe<Scalars['Date']>;
  /** Checks for equality with the object’s `traffickerEmail` field. */
  traffickerEmail?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** A filter to be used against `Campaign` object types. All fields are combined with a logical ‘and.’ */
export type CampaignFilter = {
  /** Filter by the object’s `advertiserId` field. */
  advertiserId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `agencyId` field. */
  agencyId?: InputMaybe<UuidFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<CampaignFilter>>;
  /** Filter by the object’s `archivedAt` field. */
  archivedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `billToAdvertiserId` field. */
  billToAdvertiserId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `billingPeriod` field. */
  billingPeriod?: InputMaybe<StringFilter>;
  /** Filter by the object’s `billingSchedule` field. */
  billingSchedule?: InputMaybe<StringFilter>;
  /** Filter by the object’s `brandId` field. */
  brandId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `budget` field. */
  budget?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `campaignNumber` field. */
  campaignNumber?: InputMaybe<IntFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `dcmAdvertiserId` field. */
  dcmAdvertiserId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `description` field. */
  description?: InputMaybe<StringFilter>;
  /** Filter by the object’s `endDate` field. */
  endDate?: InputMaybe<DateFilter>;
  /** Filter by the object’s `externalPioId` field. */
  externalPioId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `gamOrderId` field. */
  gamOrderId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<CampaignFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<CampaignFilter>>;
  /** Filter by the object’s `poNumber` field. */
  poNumber?: InputMaybe<StringFilter>;
  /** Filter by the object’s `salespersonEmail` field. */
  salespersonEmail?: InputMaybe<StringFilter>;
  /** Filter by the object’s `sharepointContractUrl` field. */
  sharepointContractUrl?: InputMaybe<StringFilter>;
  /** Filter by the object’s `startDate` field. */
  startDate?: InputMaybe<DateFilter>;
  /** Filter by the object’s `traffickerEmail` field. */
  traffickerEmail?: InputMaybe<StringFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
};

/** An input for mutations affecting `Campaign` */
export type CampaignInput = {
  advertiserId?: InputMaybe<Scalars['UUID']>;
  agencyId?: InputMaybe<Scalars['UUID']>;
  archivedAt?: InputMaybe<Scalars['Datetime']>;
  billToAdvertiserId?: InputMaybe<Scalars['UUID']>;
  billingPeriod?: InputMaybe<Scalars['String']>;
  billingSchedule?: InputMaybe<Scalars['String']>;
  brandId?: InputMaybe<Scalars['UUID']>;
  budget?: InputMaybe<Scalars['BigFloat']>;
  /** Four-digit PIO campaign number used by Client Services and preserved during import. */
  campaignNumber?: InputMaybe<Scalars['Int']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Campaign Manager 360 advertiser ID retained for campaign-level ad-server handoff. */
  dcmAdvertiserId?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  endDate?: InputMaybe<Scalars['Date']>;
  externalPioId?: InputMaybe<Scalars['String']>;
  /** Google Ad Manager order ID retained for campaign-level ad-server handoff. */
  gamOrderId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  poNumber?: InputMaybe<Scalars['String']>;
  salespersonEmail?: InputMaybe<Scalars['String']>;
  /** Optional SharePoint contract URL; SharePoint remains the system of record for contracts. */
  sharepointContractUrl?: InputMaybe<Scalars['String']>;
  startDate?: InputMaybe<Scalars['Date']>;
  traffickerEmail?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** Table for managing the relationship between campaigns and labels. */
export type CampaignLabel = {
  __typename?: 'CampaignLabel';
  /** Reads a single `Label` that is related to this `CampaignLabel`. */
  label?: Maybe<Label>;
  labelId: Scalars['UUID'];
  placementsCampaignId: Scalars['String'];
};

/**
 * A condition to be used against `CampaignLabel` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type CampaignLabelCondition = {
  /** Checks for equality with the object’s `labelId` field. */
  labelId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `placementsCampaignId` field. */
  placementsCampaignId?: InputMaybe<Scalars['String']>;
};

/** A filter to be used against `CampaignLabel` object types. All fields are combined with a logical ‘and.’ */
export type CampaignLabelFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<CampaignLabelFilter>>;
  /** Filter by the object’s `labelId` field. */
  labelId?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<CampaignLabelFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<CampaignLabelFilter>>;
  /** Filter by the object’s `placementsCampaignId` field. */
  placementsCampaignId?: InputMaybe<StringFilter>;
};

/** An input for mutations affecting `CampaignLabel` */
export type CampaignLabelInput = {
  labelId: Scalars['UUID'];
  placementsCampaignId: Scalars['String'];
};

/** Represents an update to a `CampaignLabel`. Fields that are set will be updated. */
export type CampaignLabelPatch = {
  labelId?: InputMaybe<Scalars['UUID']>;
  placementsCampaignId?: InputMaybe<Scalars['String']>;
};

/** A connection to a list of `CampaignLabel` values. */
export type CampaignLabelsConnection = {
  __typename?: 'CampaignLabelsConnection';
  /** A list of edges which contains the `CampaignLabel` and cursor to aid in pagination. */
  edges: Array<CampaignLabelsEdge>;
  /** A list of `CampaignLabel` objects. */
  nodes: Array<CampaignLabel>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `CampaignLabel` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `CampaignLabel` edge in the connection. */
export type CampaignLabelsEdge = {
  __typename?: 'CampaignLabelsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `CampaignLabel` at the end of the edge. */
  node: CampaignLabel;
};

/** Methods to use when ordering `CampaignLabel`. */
export enum CampaignLabelsOrderBy {
  LabelIdAsc = 'LABEL_ID_ASC',
  LabelIdDesc = 'LABEL_ID_DESC',
  Natural = 'NATURAL',
  PlacementsCampaignIdAsc = 'PLACEMENTS_CAMPAIGN_ID_ASC',
  PlacementsCampaignIdDesc = 'PLACEMENTS_CAMPAIGN_ID_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC'
}

/** Represents an update to a `Campaign`. Fields that are set will be updated. */
export type CampaignPatch = {
  advertiserId?: InputMaybe<Scalars['UUID']>;
  agencyId?: InputMaybe<Scalars['UUID']>;
  archivedAt?: InputMaybe<Scalars['Datetime']>;
  billToAdvertiserId?: InputMaybe<Scalars['UUID']>;
  billingPeriod?: InputMaybe<Scalars['String']>;
  billingSchedule?: InputMaybe<Scalars['String']>;
  brandId?: InputMaybe<Scalars['UUID']>;
  budget?: InputMaybe<Scalars['BigFloat']>;
  /** Four-digit PIO campaign number used by Client Services and preserved during import. */
  campaignNumber?: InputMaybe<Scalars['Int']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Campaign Manager 360 advertiser ID retained for campaign-level ad-server handoff. */
  dcmAdvertiserId?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  endDate?: InputMaybe<Scalars['Date']>;
  externalPioId?: InputMaybe<Scalars['String']>;
  /** Google Ad Manager order ID retained for campaign-level ad-server handoff. */
  gamOrderId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  poNumber?: InputMaybe<Scalars['String']>;
  salespersonEmail?: InputMaybe<Scalars['String']>;
  /** Optional SharePoint contract URL; SharePoint remains the system of record for contracts. */
  sharepointContractUrl?: InputMaybe<Scalars['String']>;
  startDate?: InputMaybe<Scalars['Date']>;
  traffickerEmail?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** A connection to a list of `Campaign` values. */
export type CampaignsConnection = {
  __typename?: 'CampaignsConnection';
  /** A list of edges which contains the `Campaign` and cursor to aid in pagination. */
  edges: Array<CampaignsEdge>;
  /** A list of `Campaign` objects. */
  nodes: Array<Campaign>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Campaign` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Campaign` edge in the connection. */
export type CampaignsEdge = {
  __typename?: 'CampaignsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `Campaign` at the end of the edge. */
  node: Campaign;
};

/** Methods to use when ordering `Campaign`. */
export enum CampaignsOrderBy {
  AdvertiserIdAsc = 'ADVERTISER_ID_ASC',
  AdvertiserIdDesc = 'ADVERTISER_ID_DESC',
  AgencyIdAsc = 'AGENCY_ID_ASC',
  AgencyIdDesc = 'AGENCY_ID_DESC',
  ArchivedAtAsc = 'ARCHIVED_AT_ASC',
  ArchivedAtDesc = 'ARCHIVED_AT_DESC',
  BillingPeriodAsc = 'BILLING_PERIOD_ASC',
  BillingPeriodDesc = 'BILLING_PERIOD_DESC',
  BillingScheduleAsc = 'BILLING_SCHEDULE_ASC',
  BillingScheduleDesc = 'BILLING_SCHEDULE_DESC',
  BillToAdvertiserIdAsc = 'BILL_TO_ADVERTISER_ID_ASC',
  BillToAdvertiserIdDesc = 'BILL_TO_ADVERTISER_ID_DESC',
  BrandIdAsc = 'BRAND_ID_ASC',
  BrandIdDesc = 'BRAND_ID_DESC',
  BudgetAsc = 'BUDGET_ASC',
  BudgetDesc = 'BUDGET_DESC',
  CampaignNumberAsc = 'CAMPAIGN_NUMBER_ASC',
  CampaignNumberDesc = 'CAMPAIGN_NUMBER_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  DcmAdvertiserIdAsc = 'DCM_ADVERTISER_ID_ASC',
  DcmAdvertiserIdDesc = 'DCM_ADVERTISER_ID_DESC',
  DescriptionAsc = 'DESCRIPTION_ASC',
  DescriptionDesc = 'DESCRIPTION_DESC',
  EndDateAsc = 'END_DATE_ASC',
  EndDateDesc = 'END_DATE_DESC',
  ExternalPioIdAsc = 'EXTERNAL_PIO_ID_ASC',
  ExternalPioIdDesc = 'EXTERNAL_PIO_ID_DESC',
  GamOrderIdAsc = 'GAM_ORDER_ID_ASC',
  GamOrderIdDesc = 'GAM_ORDER_ID_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  Natural = 'NATURAL',
  PoNumberAsc = 'PO_NUMBER_ASC',
  PoNumberDesc = 'PO_NUMBER_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  SalespersonEmailAsc = 'SALESPERSON_EMAIL_ASC',
  SalespersonEmailDesc = 'SALESPERSON_EMAIL_DESC',
  SharepointContractUrlAsc = 'SHAREPOINT_CONTRACT_URL_ASC',
  SharepointContractUrlDesc = 'SHAREPOINT_CONTRACT_URL_DESC',
  StartDateAsc = 'START_DATE_ASC',
  StartDateDesc = 'START_DATE_DESC',
  TraffickerEmailAsc = 'TRAFFICKER_EMAIL_ASC',
  TraffickerEmailDesc = 'TRAFFICKER_EMAIL_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC'
}

/** All input for the `clearFmaViews` mutation. */
export type ClearFmaViewsInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  targetAjsAnonymousId?: InputMaybe<Scalars['String']>;
  targetNpi?: InputMaybe<Scalars['Int']>;
  targetUid?: InputMaybe<Scalars['String']>;
};

/** The output of our `clearFmaViews` mutation. */
export type ClearFmaViewsPayload = {
  __typename?: 'ClearFmaViewsPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedCounts?: Maybe<Array<Maybe<Scalars['BigInt']>>>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** Clicks creatives. */
export type ClicksCreative = {
  __typename?: 'ClicksCreative';
  /** Sponsor/Company/Brand name for the Click. Optional. */
  companyName: Scalars['String'];
  /** If true, display the job number together with the Click. */
  displayJobNumber: Scalars['Boolean'];
  /** End date and time when this Click should stop being displayed. Note that already delivered Clicks (i.e. links in email) should continue to work after this date, this is just a cutoff for new displays. */
  endsAt: Scalars['Datetime'];
  hasActivityData?: Maybe<Scalars['Boolean']>;
  hideOnDaysList?: Maybe<Array<Maybe<DayOfWeekType>>>;
  /** ID for the creative. */
  id: Scalars['Int'];
  isApproved?: Maybe<Scalars['Boolean']>;
  /** The optional job number ID (a string) that is sometimes displayed with the Click. */
  jobNumber?: Maybe<Scalars['String']>;
  /** Reads a single `LineItem` that is related to this `ClicksCreative`. */
  lineItem?: Maybe<LineItem>;
  /** Native CSAdmin line item FK added for PIO migration parallel-run; placements_line_item_id remains for rollback. */
  lineItemId?: Maybe<Scalars['UUID']>;
  /** Descriptive name for the creative - "Flight / Segment Name" */
  name: Scalars['String'];
  placementsCampaignId?: Maybe<Scalars['String']>;
  /** ID identifying the Placements Line Item that this creative is for. */
  placementsLineItemId?: Maybe<Scalars['String']>;
  priority: Scalars['Int'];
  professionIdsList?: Maybe<Array<Maybe<Scalars['Int']>>>;
  /** Reads and enables pagination through a set of `Profession`. */
  professions: ProfessionsConnection;
  /** Reads and enables pagination through a set of `Specialty`. */
  specialties: SpecialtiesConnection;
  specialtyIdsList?: Maybe<Array<Maybe<Scalars['Int']>>>;
  /** Start date and time when this Click should start to be displayed. */
  startsAt: Scalars['Datetime'];
  targetListIdsList?: Maybe<Array<Maybe<Scalars['Int']>>>;
  /** Reads and enables pagination through a set of `TargetList`. */
  targetLists: TargetListsConnection;
  targetingType?: Maybe<ClicksCreativeTargetingType>;
  /** Text of the click - this is the actual clickable text that is displayed */
  title: Scalars['String'];
  /** Destination URL to redirect to if the Click is clicked. */
  url: Scalars['String'];
};


/** Clicks creatives. */
export type ClicksCreativeHideOnDaysListArgs = {
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


/** Clicks creatives. */
export type ClicksCreativeProfessionIdsListArgs = {
  filter?: InputMaybe<IntFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


/** Clicks creatives. */
export type ClicksCreativeProfessionsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  filter?: InputMaybe<ProfessionFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


/** Clicks creatives. */
export type ClicksCreativeSpecialtiesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  filter?: InputMaybe<SpecialtyFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


/** Clicks creatives. */
export type ClicksCreativeSpecialtyIdsListArgs = {
  filter?: InputMaybe<IntFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


/** Clicks creatives. */
export type ClicksCreativeTargetListIdsListArgs = {
  filter?: InputMaybe<IntFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


/** Clicks creatives. */
export type ClicksCreativeTargetListsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  filter?: InputMaybe<TargetListFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

/**
 * A condition to be used against `ClicksCreative` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type ClicksCreativeCondition = {
  /** Checks for equality with the object’s `companyName` field. */
  companyName?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `displayJobNumber` field. */
  displayJobNumber?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `endsAt` field. */
  endsAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `isApproved` field. */
  isApproved?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `jobNumber` field. */
  jobNumber?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `lineItemId` field. */
  lineItemId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `placementsCampaignId` field. */
  placementsCampaignId?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `placementsLineItemId` field. */
  placementsLineItemId?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `priority` field. */
  priority?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `startsAt` field. */
  startsAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `targetingType` field. */
  targetingType?: InputMaybe<ClicksCreativeTargetingType>;
  /** Checks for equality with the object’s `title` field. */
  title?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `url` field. */
  url?: InputMaybe<Scalars['String']>;
};

/** A filter to be used against `ClicksCreative` object types. All fields are combined with a logical ‘and.’ */
export type ClicksCreativeFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ClicksCreativeFilter>>;
  /** Filter by the object’s `companyName` field. */
  companyName?: InputMaybe<StringFilter>;
  /** Filter by the object’s `displayJobNumber` field. */
  displayJobNumber?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `endsAt` field. */
  endsAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `hasActivityData` field. */
  hasActivityData?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `isApproved` field. */
  isApproved?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `jobNumber` field. */
  jobNumber?: InputMaybe<StringFilter>;
  /** Filter by the object’s `lineItemId` field. */
  lineItemId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ClicksCreativeFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ClicksCreativeFilter>>;
  /** Filter by the object’s `placementsCampaignId` field. */
  placementsCampaignId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `placementsLineItemId` field. */
  placementsLineItemId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `priority` field. */
  priority?: InputMaybe<IntFilter>;
  /** Filter by the object’s `startsAt` field. */
  startsAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `targetingType` field. */
  targetingType?: InputMaybe<ClicksCreativeTargetingTypeFilter>;
  /** Filter by the object’s `title` field. */
  title?: InputMaybe<StringFilter>;
  /** Filter by the object’s `url` field. */
  url?: InputMaybe<StringFilter>;
};

/** An input for mutations affecting `ClicksCreative` */
export type ClicksCreativeInput = {
  /** Sponsor/Company/Brand name for the Click. Optional. */
  companyName: Scalars['String'];
  /** If true, display the job number together with the Click. */
  displayJobNumber?: InputMaybe<Scalars['Boolean']>;
  /** End date and time when this Click should stop being displayed. Note that already delivered Clicks (i.e. links in email) should continue to work after this date, this is just a cutoff for new displays. */
  endsAt: Scalars['Datetime'];
  /** ID for the creative. */
  id?: InputMaybe<Scalars['Int']>;
  isApproved?: InputMaybe<Scalars['Boolean']>;
  /** The optional job number ID (a string) that is sometimes displayed with the Click. */
  jobNumber?: InputMaybe<Scalars['String']>;
  /** Native CSAdmin line item FK added for PIO migration parallel-run; placements_line_item_id remains for rollback. */
  lineItemId?: InputMaybe<Scalars['UUID']>;
  /** Descriptive name for the creative - "Flight / Segment Name" */
  name: Scalars['String'];
  placementsCampaignId?: InputMaybe<Scalars['String']>;
  /** ID identifying the Placements Line Item that this creative is for. */
  placementsLineItemId?: InputMaybe<Scalars['String']>;
  priority?: InputMaybe<Scalars['Int']>;
  /** Start date and time when this Click should start to be displayed. */
  startsAt: Scalars['Datetime'];
  targetingType?: InputMaybe<ClicksCreativeTargetingType>;
  /** Text of the click - this is the actual clickable text that is displayed */
  title: Scalars['String'];
  /** Destination URL to redirect to if the Click is clicked. */
  url: Scalars['String'];
};

/** Represents an update to a `ClicksCreative`. Fields that are set will be updated. */
export type ClicksCreativePatch = {
  /** Sponsor/Company/Brand name for the Click. Optional. */
  companyName?: InputMaybe<Scalars['String']>;
  /** If true, display the job number together with the Click. */
  displayJobNumber?: InputMaybe<Scalars['Boolean']>;
  /** End date and time when this Click should stop being displayed. Note that already delivered Clicks (i.e. links in email) should continue to work after this date, this is just a cutoff for new displays. */
  endsAt?: InputMaybe<Scalars['Datetime']>;
  /** ID for the creative. */
  id?: InputMaybe<Scalars['Int']>;
  isApproved?: InputMaybe<Scalars['Boolean']>;
  /** The optional job number ID (a string) that is sometimes displayed with the Click. */
  jobNumber?: InputMaybe<Scalars['String']>;
  /** Native CSAdmin line item FK added for PIO migration parallel-run; placements_line_item_id remains for rollback. */
  lineItemId?: InputMaybe<Scalars['UUID']>;
  /** Descriptive name for the creative - "Flight / Segment Name" */
  name?: InputMaybe<Scalars['String']>;
  placementsCampaignId?: InputMaybe<Scalars['String']>;
  /** ID identifying the Placements Line Item that this creative is for. */
  placementsLineItemId?: InputMaybe<Scalars['String']>;
  priority?: InputMaybe<Scalars['Int']>;
  /** Start date and time when this Click should start to be displayed. */
  startsAt?: InputMaybe<Scalars['Datetime']>;
  targetingType?: InputMaybe<ClicksCreativeTargetingType>;
  /** Text of the click - this is the actual clickable text that is displayed */
  title?: InputMaybe<Scalars['String']>;
  /** Destination URL to redirect to if the Click is clicked. */
  url?: InputMaybe<Scalars['String']>;
};

export enum ClicksCreativeTargetingType {
  RunOfSpecialty = 'RUN_OF_SPECIALTY',
  TargetList = 'TARGET_LIST'
}

/** A filter to be used against ClicksCreativeTargetingType fields. All fields are combined with a logical ‘and.’ */
export type ClicksCreativeTargetingTypeFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<ClicksCreativeTargetingType>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<ClicksCreativeTargetingType>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<ClicksCreativeTargetingType>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<ClicksCreativeTargetingType>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<ClicksCreativeTargetingType>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<ClicksCreativeTargetingType>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<ClicksCreativeTargetingType>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<ClicksCreativeTargetingType>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<ClicksCreativeTargetingType>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<ClicksCreativeTargetingType>>;
};

/** A connection to a list of `ClicksCreative` values. */
export type ClicksCreativesConnection = {
  __typename?: 'ClicksCreativesConnection';
  /** A list of edges which contains the `ClicksCreative` and cursor to aid in pagination. */
  edges: Array<ClicksCreativesEdge>;
  /** A list of `ClicksCreative` objects. */
  nodes: Array<ClicksCreative>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ClicksCreative` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `ClicksCreative` edge in the connection. */
export type ClicksCreativesEdge = {
  __typename?: 'ClicksCreativesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `ClicksCreative` at the end of the edge. */
  node: ClicksCreative;
};

/** Methods to use when ordering `ClicksCreative`. */
export enum ClicksCreativesOrderBy {
  CompanyNameAsc = 'COMPANY_NAME_ASC',
  CompanyNameDesc = 'COMPANY_NAME_DESC',
  DisplayJobNumberAsc = 'DISPLAY_JOB_NUMBER_ASC',
  DisplayJobNumberDesc = 'DISPLAY_JOB_NUMBER_DESC',
  EndsAtAsc = 'ENDS_AT_ASC',
  EndsAtDesc = 'ENDS_AT_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  IsApprovedAsc = 'IS_APPROVED_ASC',
  IsApprovedDesc = 'IS_APPROVED_DESC',
  JobNumberAsc = 'JOB_NUMBER_ASC',
  JobNumberDesc = 'JOB_NUMBER_DESC',
  LineItemIdAsc = 'LINE_ITEM_ID_ASC',
  LineItemIdDesc = 'LINE_ITEM_ID_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  Natural = 'NATURAL',
  PlacementsCampaignIdAsc = 'PLACEMENTS_CAMPAIGN_ID_ASC',
  PlacementsCampaignIdDesc = 'PLACEMENTS_CAMPAIGN_ID_DESC',
  PlacementsLineItemIdAsc = 'PLACEMENTS_LINE_ITEM_ID_ASC',
  PlacementsLineItemIdDesc = 'PLACEMENTS_LINE_ITEM_ID_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  PriorityAsc = 'PRIORITY_ASC',
  PriorityDesc = 'PRIORITY_DESC',
  StartsAtAsc = 'STARTS_AT_ASC',
  StartsAtDesc = 'STARTS_AT_DESC',
  TargetingTypeAsc = 'TARGETING_TYPE_ASC',
  TargetingTypeDesc = 'TARGETING_TYPE_DESC',
  TitleAsc = 'TITLE_ASC',
  TitleDesc = 'TITLE_DESC',
  UrlAsc = 'URL_ASC',
  UrlDesc = 'URL_DESC'
}

/** All input for the create `Advertiser` mutation. */
export type CreateAdvertiserInput = {
  /** The `Advertiser` to be created by this mutation. */
  advertiser: AdvertiserInput;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** The output of our create `Advertiser` mutation. */
export type CreateAdvertiserPayload = {
  __typename?: 'CreateAdvertiserPayload';
  /** The `Advertiser` that was created by this mutation. */
  advertiser?: Maybe<Advertiser>;
  /** An edge for our `Advertiser`. May be used by Relay 1. */
  advertiserEdge?: Maybe<AdvertisersEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Advertiser` that is related to this `Advertiser`. */
  parent?: Maybe<Advertiser>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `Advertiser` mutation. */
export type CreateAdvertiserPayloadAdvertiserEdgeArgs = {
  orderBy?: InputMaybe<Array<AdvertisersOrderBy>>;
};

/** All input for the create `BannerTargeting` mutation. */
export type CreateBannerTargetingInput = {
  /** The `BannerTargeting` to be created by this mutation. */
  bannerTargeting: BannerTargetingInput;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** The output of our create `BannerTargeting` mutation. */
export type CreateBannerTargetingPayload = {
  __typename?: 'CreateBannerTargetingPayload';
  /** The `BannerTargeting` that was created by this mutation. */
  bannerTargeting?: Maybe<BannerTargeting>;
  /** An edge for our `BannerTargeting`. May be used by Relay 1. */
  bannerTargetingEdge?: Maybe<BannerTargetingsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `LineItem` that is related to this `BannerTargeting`. */
  lineItem?: Maybe<LineItem>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `TargetList` that is related to this `BannerTargeting`. */
  targetList?: Maybe<TargetList>;
};


/** The output of our create `BannerTargeting` mutation. */
export type CreateBannerTargetingPayloadBannerTargetingEdgeArgs = {
  orderBy?: InputMaybe<Array<BannerTargetingsOrderBy>>;
};

/** All input for the create `Campaign` mutation. */
export type CreateCampaignInput = {
  /** The `Campaign` to be created by this mutation. */
  campaign: CampaignInput;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** All input for the create `CampaignLabel` mutation. */
export type CreateCampaignLabelInput = {
  /** The `CampaignLabel` to be created by this mutation. */
  campaignLabel: CampaignLabelInput;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** The output of our create `CampaignLabel` mutation. */
export type CreateCampaignLabelPayload = {
  __typename?: 'CreateCampaignLabelPayload';
  /** The `CampaignLabel` that was created by this mutation. */
  campaignLabel?: Maybe<CampaignLabel>;
  /** An edge for our `CampaignLabel`. May be used by Relay 1. */
  campaignLabelEdge?: Maybe<CampaignLabelsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Label` that is related to this `CampaignLabel`. */
  label?: Maybe<Label>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `CampaignLabel` mutation. */
export type CreateCampaignLabelPayloadCampaignLabelEdgeArgs = {
  orderBy?: InputMaybe<Array<CampaignLabelsOrderBy>>;
};

/** The output of our create `Campaign` mutation. */
export type CreateCampaignPayload = {
  __typename?: 'CreateCampaignPayload';
  /** Reads a single `Advertiser` that is related to this `Campaign`. */
  advertiser?: Maybe<Advertiser>;
  /** Reads a single `Advertiser` that is related to this `Campaign`. */
  agency?: Maybe<Advertiser>;
  /** Reads a single `Advertiser` that is related to this `Campaign`. */
  billToAdvertiser?: Maybe<Advertiser>;
  /** Reads a single `Advertiser` that is related to this `Campaign`. */
  brand?: Maybe<Advertiser>;
  /** The `Campaign` that was created by this mutation. */
  campaign?: Maybe<Campaign>;
  /** An edge for our `Campaign`. May be used by Relay 1. */
  campaignEdge?: Maybe<CampaignsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `Campaign` mutation. */
export type CreateCampaignPayloadCampaignEdgeArgs = {
  orderBy?: InputMaybe<Array<CampaignsOrderBy>>;
};

/** All input for the create `ClicksCreative` mutation. */
export type CreateClicksCreativeInput = {
  /** The `ClicksCreative` to be created by this mutation. */
  clicksCreative: ClicksCreativeInput;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** The output of our create `ClicksCreative` mutation. */
export type CreateClicksCreativePayload = {
  __typename?: 'CreateClicksCreativePayload';
  /** The `ClicksCreative` that was created by this mutation. */
  clicksCreative?: Maybe<ClicksCreative>;
  /** An edge for our `ClicksCreative`. May be used by Relay 1. */
  clicksCreativeEdge?: Maybe<ClicksCreativesEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `LineItem` that is related to this `ClicksCreative`. */
  lineItem?: Maybe<LineItem>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `ClicksCreative` mutation. */
export type CreateClicksCreativePayloadClicksCreativeEdgeArgs = {
  orderBy?: InputMaybe<Array<ClicksCreativesOrderBy>>;
};

/** All input for the create `EndemicDriver` mutation. */
export type CreateEndemicDriverInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `EndemicDriver` to be created by this mutation. */
  endemicDriver: EndemicDriverInput;
};

/** The output of our create `EndemicDriver` mutation. */
export type CreateEndemicDriverPayload = {
  __typename?: 'CreateEndemicDriverPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `EndemicDriver` that was created by this mutation. */
  endemicDriver?: Maybe<EndemicDriver>;
  /** An edge for our `EndemicDriver`. May be used by Relay 1. */
  endemicDriverEdge?: Maybe<EndemicDriversEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `EndemicDriver` mutation. */
export type CreateEndemicDriverPayloadEndemicDriverEdgeArgs = {
  orderBy?: InputMaybe<Array<EndemicDriversOrderBy>>;
};

/** All input for the create `EndemicDriverTargetList` mutation. */
export type CreateEndemicDriverTargetListInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `EndemicDriverTargetList` to be created by this mutation. */
  endemicDriverTargetList: EndemicDriverTargetListInput;
};

/** The output of our create `EndemicDriverTargetList` mutation. */
export type CreateEndemicDriverTargetListPayload = {
  __typename?: 'CreateEndemicDriverTargetListPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `EndemicDriver` that is related to this `EndemicDriverTargetList`. */
  endemicDriver?: Maybe<EndemicDriver>;
  /** The `EndemicDriverTargetList` that was created by this mutation. */
  endemicDriverTargetList?: Maybe<EndemicDriverTargetList>;
  /** An edge for our `EndemicDriverTargetList`. May be used by Relay 1. */
  endemicDriverTargetListEdge?: Maybe<EndemicDriverTargetListsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `TargetList` that is related to this `EndemicDriverTargetList`. */
  targetList?: Maybe<TargetList>;
};


/** The output of our create `EndemicDriverTargetList` mutation. */
export type CreateEndemicDriverTargetListPayloadEndemicDriverTargetListEdgeArgs = {
  orderBy?: InputMaybe<Array<EndemicDriverTargetListsOrderBy>>;
};

/** All input for the create `EndemicDriverTopicTag` mutation. */
export type CreateEndemicDriverTopicTagInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `EndemicDriverTopicTag` to be created by this mutation. */
  endemicDriverTopicTag: EndemicDriverTopicTagInput;
};

/** The output of our create `EndemicDriverTopicTag` mutation. */
export type CreateEndemicDriverTopicTagPayload = {
  __typename?: 'CreateEndemicDriverTopicTagPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `EndemicDriver` that is related to this `EndemicDriverTopicTag`. */
  endemicDriver?: Maybe<EndemicDriver>;
  /** The `EndemicDriverTopicTag` that was created by this mutation. */
  endemicDriverTopicTag?: Maybe<EndemicDriverTopicTag>;
  /** An edge for our `EndemicDriverTopicTag`. May be used by Relay 1. */
  endemicDriverTopicTagEdge?: Maybe<EndemicDriverTopicTagsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `TopicTag` that is related to this `EndemicDriverTopicTag`. */
  topicTag?: Maybe<TopicTag>;
};


/** The output of our create `EndemicDriverTopicTag` mutation. */
export type CreateEndemicDriverTopicTagPayloadEndemicDriverTopicTagEdgeArgs = {
  orderBy?: InputMaybe<Array<EndemicDriverTopicTagsOrderBy>>;
};

/** All input for the create `FmaCreative` mutation. */
export type CreateFmaCreativeInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `FmaCreative` to be created by this mutation. */
  fmaCreative: FmaCreativeInput;
};

/** The output of our create `FmaCreative` mutation. */
export type CreateFmaCreativePayload = {
  __typename?: 'CreateFmaCreativePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `FmaCreative` that was created by this mutation. */
  fmaCreative?: Maybe<FmaCreative>;
  /** An edge for our `FmaCreative`. May be used by Relay 1. */
  fmaCreativeEdge?: Maybe<FmaCreativesEdge>;
  /** Reads a single `LineItem` that is related to this `FmaCreative`. */
  lineItem?: Maybe<LineItem>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `FmaCreative` mutation. */
export type CreateFmaCreativePayloadFmaCreativeEdgeArgs = {
  orderBy?: InputMaybe<Array<FmaCreativesOrderBy>>;
};

/** All input for the create `Label` mutation. */
export type CreateLabelInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `Label` to be created by this mutation. */
  label: LabelInput;
};

/** The output of our create `Label` mutation. */
export type CreateLabelPayload = {
  __typename?: 'CreateLabelPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `Label` that was created by this mutation. */
  label?: Maybe<Label>;
  /** An edge for our `Label`. May be used by Relay 1. */
  labelEdge?: Maybe<LabelsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `Label` mutation. */
export type CreateLabelPayloadLabelEdgeArgs = {
  orderBy?: InputMaybe<Array<LabelsOrderBy>>;
};

/** All input for the create `LeadGenCampaign` mutation. */
export type CreateLeadGenCampaignInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `LeadGenCampaign` to be created by this mutation. */
  leadGenCampaign: LeadGenCampaignInput;
};

/** The output of our create `LeadGenCampaign` mutation. */
export type CreateLeadGenCampaignPayload = {
  __typename?: 'CreateLeadGenCampaignPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `LeadGenCampaign` that was created by this mutation. */
  leadGenCampaign?: Maybe<LeadGenCampaign>;
  /** An edge for our `LeadGenCampaign`. May be used by Relay 1. */
  leadGenCampaignEdge?: Maybe<LeadGenCampaignsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `LeadGenCampaign` mutation. */
export type CreateLeadGenCampaignPayloadLeadGenCampaignEdgeArgs = {
  orderBy?: InputMaybe<Array<LeadGenCampaignsOrderBy>>;
};

/** All input for the create `LeadGenView` mutation. */
export type CreateLeadGenViewInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `LeadGenView` to be created by this mutation. */
  leadGenView: LeadGenViewInput;
};

/** The output of our create `LeadGenView` mutation. */
export type CreateLeadGenViewPayload = {
  __typename?: 'CreateLeadGenViewPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `LeadGenCampaign` that is related to this `LeadGenView`. */
  leadGenCampaign?: Maybe<LeadGenCampaign>;
  /** The `LeadGenView` that was created by this mutation. */
  leadGenView?: Maybe<LeadGenView>;
  /** An edge for our `LeadGenView`. May be used by Relay 1. */
  leadGenViewEdge?: Maybe<LeadGenViewsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `LeadGenView` mutation. */
export type CreateLeadGenViewPayloadLeadGenViewEdgeArgs = {
  orderBy?: InputMaybe<Array<LeadGenViewsOrderBy>>;
};

/** All input for the create `LineItemDelivery` mutation. */
export type CreateLineItemDeliveryInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `LineItemDelivery` to be created by this mutation. */
  lineItemDelivery: LineItemDeliveryInput;
};

/** The output of our create `LineItemDelivery` mutation. */
export type CreateLineItemDeliveryPayload = {
  __typename?: 'CreateLineItemDeliveryPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `LineItem` that is related to this `LineItemDelivery`. */
  lineItem?: Maybe<LineItem>;
  /** The `LineItemDelivery` that was created by this mutation. */
  lineItemDelivery?: Maybe<LineItemDelivery>;
  /** An edge for our `LineItemDelivery`. May be used by Relay 1. */
  lineItemDeliveryEdge?: Maybe<LineItemDeliveriesEdge>;
  /** Reads a single `PioUser` that is related to this `LineItemDelivery`. */
  pioUserByReportedBy?: Maybe<PioUser>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `LineItemDelivery` mutation. */
export type CreateLineItemDeliveryPayloadLineItemDeliveryEdgeArgs = {
  orderBy?: InputMaybe<Array<LineItemDeliveriesOrderBy>>;
};

/** All input for the create `LineItem` mutation. */
export type CreateLineItemInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `LineItem` to be created by this mutation. */
  lineItem: LineItemInput;
};

/** All input for the create `LineItemLabel` mutation. */
export type CreateLineItemLabelInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `LineItemLabel` to be created by this mutation. */
  lineItemLabel: LineItemLabelInput;
};

/** The output of our create `LineItemLabel` mutation. */
export type CreateLineItemLabelPayload = {
  __typename?: 'CreateLineItemLabelPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Label` that is related to this `LineItemLabel`. */
  label?: Maybe<Label>;
  /** Reads a single `LineItem` that is related to this `LineItemLabel`. */
  lineItem?: Maybe<LineItem>;
  /** The `LineItemLabel` that was created by this mutation. */
  lineItemLabel?: Maybe<LineItemLabel>;
  /** An edge for our `LineItemLabel`. May be used by Relay 1. */
  lineItemLabelEdge?: Maybe<LineItemLabelsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `LineItemLabel` mutation. */
export type CreateLineItemLabelPayloadLineItemLabelEdgeArgs = {
  orderBy?: InputMaybe<Array<LineItemLabelsOrderBy>>;
};

/** The output of our create `LineItem` mutation. */
export type CreateLineItemPayload = {
  __typename?: 'CreateLineItemPayload';
  /** Reads a single `Campaign` that is related to this `LineItem`. */
  campaign?: Maybe<Campaign>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `LineItem` that is related to this `LineItem`. */
  copiedFromLineItem?: Maybe<LineItem>;
  /** The `LineItem` that was created by this mutation. */
  lineItem?: Maybe<LineItem>;
  /** An edge for our `LineItem`. May be used by Relay 1. */
  lineItemEdge?: Maybe<LineItemsEdge>;
  /** Reads a single `PioUser` that is related to this `LineItem`. */
  pioUserByReviewedBy?: Maybe<PioUser>;
  /** Reads a single `Product` that is related to this `LineItem`. */
  product?: Maybe<Product>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `LineItem` mutation. */
export type CreateLineItemPayloadLineItemEdgeArgs = {
  orderBy?: InputMaybe<Array<LineItemsOrderBy>>;
};

/** All input for the create `Product` mutation. */
export type CreateProductInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `Product` to be created by this mutation. */
  product: ProductInput;
};

/** The output of our create `Product` mutation. */
export type CreateProductPayload = {
  __typename?: 'CreateProductPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `Product` that was created by this mutation. */
  product?: Maybe<Product>;
  /** An edge for our `Product`. May be used by Relay 1. */
  productEdge?: Maybe<ProductsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `Product` mutation. */
export type CreateProductPayloadProductEdgeArgs = {
  orderBy?: InputMaybe<Array<ProductsOrderBy>>;
};

/** All input for the create `Profession` mutation. */
export type CreateProfessionInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `Profession` to be created by this mutation. */
  profession: ProfessionInput;
};

/** The output of our create `Profession` mutation. */
export type CreateProfessionPayload = {
  __typename?: 'CreateProfessionPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `Profession` that was created by this mutation. */
  profession?: Maybe<Profession>;
  /** An edge for our `Profession`. May be used by Relay 1. */
  professionEdge?: Maybe<ProfessionsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `Profession` mutation. */
export type CreateProfessionPayloadProfessionEdgeArgs = {
  orderBy?: InputMaybe<Array<ProfessionsOrderBy>>;
};

/** All input for the create `SpecialtyGroup` mutation. */
export type CreateSpecialtyGroupInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `SpecialtyGroup` to be created by this mutation. */
  specialtyGroup: SpecialtyGroupInput;
};

/** The output of our create `SpecialtyGroup` mutation. */
export type CreateSpecialtyGroupPayload = {
  __typename?: 'CreateSpecialtyGroupPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `SpecialtyGroup` that was created by this mutation. */
  specialtyGroup?: Maybe<SpecialtyGroup>;
  /** An edge for our `SpecialtyGroup`. May be used by Relay 1. */
  specialtyGroupEdge?: Maybe<SpecialtyGroupsEdge>;
};


/** The output of our create `SpecialtyGroup` mutation. */
export type CreateSpecialtyGroupPayloadSpecialtyGroupEdgeArgs = {
  orderBy?: InputMaybe<Array<SpecialtyGroupsOrderBy>>;
};

/** All input for the create `Specialty` mutation. */
export type CreateSpecialtyInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `Specialty` to be created by this mutation. */
  specialty: SpecialtyInput;
};

/** The output of our create `Specialty` mutation. */
export type CreateSpecialtyPayload = {
  __typename?: 'CreateSpecialtyPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `Specialty` that was created by this mutation. */
  specialty?: Maybe<Specialty>;
  /** An edge for our `Specialty`. May be used by Relay 1. */
  specialtyEdge?: Maybe<SpecialtiesEdge>;
};


/** The output of our create `Specialty` mutation. */
export type CreateSpecialtyPayloadSpecialtyEdgeArgs = {
  orderBy?: InputMaybe<Array<SpecialtiesOrderBy>>;
};

/** All input for the create `SponsoredContentTeaser` mutation. */
export type CreateSponsoredContentTeaserInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `SponsoredContentTeaser` to be created by this mutation. */
  sponsoredContentTeaser: SponsoredContentTeaserInput;
};

/** The output of our create `SponsoredContentTeaser` mutation. */
export type CreateSponsoredContentTeaserPayload = {
  __typename?: 'CreateSponsoredContentTeaserPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `LineItem` that is related to this `SponsoredContentTeaser`. */
  lineItem?: Maybe<LineItem>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `SponsoredContentTeaser` that was created by this mutation. */
  sponsoredContentTeaser?: Maybe<SponsoredContentTeaser>;
  /** An edge for our `SponsoredContentTeaser`. May be used by Relay 1. */
  sponsoredContentTeaserEdge?: Maybe<SponsoredContentTeasersEdge>;
};


/** The output of our create `SponsoredContentTeaser` mutation. */
export type CreateSponsoredContentTeaserPayloadSponsoredContentTeaserEdgeArgs = {
  orderBy?: InputMaybe<Array<SponsoredContentTeasersOrderBy>>;
};

/** All input for the create `SponsoredContentTeaserProfession` mutation. */
export type CreateSponsoredContentTeaserProfessionInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `SponsoredContentTeaserProfession` to be created by this mutation. */
  sponsoredContentTeaserProfession: SponsoredContentTeaserProfessionInput;
};

/** The output of our create `SponsoredContentTeaserProfession` mutation. */
export type CreateSponsoredContentTeaserProfessionPayload = {
  __typename?: 'CreateSponsoredContentTeaserProfessionPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Profession` that is related to this `SponsoredContentTeaserProfession`. */
  profession?: Maybe<Profession>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `SponsoredContentTeaser` that is related to this `SponsoredContentTeaserProfession`. */
  sponsoredContentTeaser?: Maybe<SponsoredContentTeaser>;
  /** The `SponsoredContentTeaserProfession` that was created by this mutation. */
  sponsoredContentTeaserProfession?: Maybe<SponsoredContentTeaserProfession>;
  /** An edge for our `SponsoredContentTeaserProfession`. May be used by Relay 1. */
  sponsoredContentTeaserProfessionEdge?: Maybe<SponsoredContentTeaserProfessionsEdge>;
};


/** The output of our create `SponsoredContentTeaserProfession` mutation. */
export type CreateSponsoredContentTeaserProfessionPayloadSponsoredContentTeaserProfessionEdgeArgs = {
  orderBy?: InputMaybe<Array<SponsoredContentTeaserProfessionsOrderBy>>;
};

/** All input for the create `SponsoredContentTeaserSpecialty` mutation. */
export type CreateSponsoredContentTeaserSpecialtyInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `SponsoredContentTeaserSpecialty` to be created by this mutation. */
  sponsoredContentTeaserSpecialty: SponsoredContentTeaserSpecialtyInput;
};

/** The output of our create `SponsoredContentTeaserSpecialty` mutation. */
export type CreateSponsoredContentTeaserSpecialtyPayload = {
  __typename?: 'CreateSponsoredContentTeaserSpecialtyPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Specialty` that is related to this `SponsoredContentTeaserSpecialty`. */
  specialty?: Maybe<Specialty>;
  /** Reads a single `SponsoredContentTeaser` that is related to this `SponsoredContentTeaserSpecialty`. */
  sponsoredContentTeaser?: Maybe<SponsoredContentTeaser>;
  /** The `SponsoredContentTeaserSpecialty` that was created by this mutation. */
  sponsoredContentTeaserSpecialty?: Maybe<SponsoredContentTeaserSpecialty>;
  /** An edge for our `SponsoredContentTeaserSpecialty`. May be used by Relay 1. */
  sponsoredContentTeaserSpecialtyEdge?: Maybe<SponsoredContentTeaserSpecialtiesEdge>;
};


/** The output of our create `SponsoredContentTeaserSpecialty` mutation. */
export type CreateSponsoredContentTeaserSpecialtyPayloadSponsoredContentTeaserSpecialtyEdgeArgs = {
  orderBy?: InputMaybe<Array<SponsoredContentTeaserSpecialtiesOrderBy>>;
};

/** All input for the create `SponsoredContentTeaserTargetList` mutation. */
export type CreateSponsoredContentTeaserTargetListInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `SponsoredContentTeaserTargetList` to be created by this mutation. */
  sponsoredContentTeaserTargetList: SponsoredContentTeaserTargetListInput;
};

/** The output of our create `SponsoredContentTeaserTargetList` mutation. */
export type CreateSponsoredContentTeaserTargetListPayload = {
  __typename?: 'CreateSponsoredContentTeaserTargetListPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `SponsoredContentTeaser` that is related to this `SponsoredContentTeaserTargetList`. */
  sponsoredContentTeaser?: Maybe<SponsoredContentTeaser>;
  /** The `SponsoredContentTeaserTargetList` that was created by this mutation. */
  sponsoredContentTeaserTargetList?: Maybe<SponsoredContentTeaserTargetList>;
  /** An edge for our `SponsoredContentTeaserTargetList`. May be used by Relay 1. */
  sponsoredContentTeaserTargetListEdge?: Maybe<SponsoredContentTeaserTargetListsEdge>;
  /** Reads a single `TargetList` that is related to this `SponsoredContentTeaserTargetList`. */
  targetList?: Maybe<TargetList>;
};


/** The output of our create `SponsoredContentTeaserTargetList` mutation. */
export type CreateSponsoredContentTeaserTargetListPayloadSponsoredContentTeaserTargetListEdgeArgs = {
  orderBy?: InputMaybe<Array<SponsoredContentTeaserTargetListsOrderBy>>;
};

/** All input for the create `TargetList` mutation. */
export type CreateTargetListInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `TargetList` to be created by this mutation. */
  targetList: TargetListInput;
};

/** The output of our create `TargetList` mutation. */
export type CreateTargetListPayload = {
  __typename?: 'CreateTargetListPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `TargetList` that was created by this mutation. */
  targetList?: Maybe<TargetList>;
  /** An edge for our `TargetList`. May be used by Relay 1. */
  targetListEdge?: Maybe<TargetListsEdge>;
};


/** The output of our create `TargetList` mutation. */
export type CreateTargetListPayloadTargetListEdgeArgs = {
  orderBy?: InputMaybe<Array<TargetListsOrderBy>>;
};

/** All input for the create `TopicTag` mutation. */
export type CreateTopicTagInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `TopicTag` to be created by this mutation. */
  topicTag: TopicTagInput;
};

/** The output of our create `TopicTag` mutation. */
export type CreateTopicTagPayload = {
  __typename?: 'CreateTopicTagPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `TopicTag` that was created by this mutation. */
  topicTag?: Maybe<TopicTag>;
  /** An edge for our `TopicTag`. May be used by Relay 1. */
  topicTagEdge?: Maybe<TopicTagsEdge>;
};


/** The output of our create `TopicTag` mutation. */
export type CreateTopicTagPayloadTopicTagEdgeArgs = {
  orderBy?: InputMaybe<Array<TopicTagsOrderBy>>;
};

/** A filter to be used against Date fields. All fields are combined with a logical ‘and.’ */
export type DateFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Scalars['Date']>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Scalars['Date']>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Scalars['Date']>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Scalars['Date']>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<Scalars['Date']>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Scalars['Date']>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Scalars['Date']>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Scalars['Date']>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Scalars['Date']>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Scalars['Date']>>;
};

/** A filter to be used against Datetime fields. All fields are combined with a logical ‘and.’ */
export type DatetimeFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Scalars['Datetime']>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Scalars['Datetime']>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Scalars['Datetime']>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Scalars['Datetime']>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<Scalars['Datetime']>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Scalars['Datetime']>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Scalars['Datetime']>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Scalars['Datetime']>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Scalars['Datetime']>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Scalars['Datetime']>>;
};

export enum DayOfWeekType {
  Friday = 'FRIDAY',
  Monday = 'MONDAY',
  Saturday = 'SATURDAY',
  Sunday = 'SUNDAY',
  Thursday = 'THURSDAY',
  Tuesday = 'TUESDAY',
  Wednesday = 'WEDNESDAY'
}

/** All input for the `deleteAdvertiser` mutation. */
export type DeleteAdvertiserInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** The output of our delete `Advertiser` mutation. */
export type DeleteAdvertiserPayload = {
  __typename?: 'DeleteAdvertiserPayload';
  /** The `Advertiser` that was deleted by this mutation. */
  advertiser?: Maybe<Advertiser>;
  /** An edge for our `Advertiser`. May be used by Relay 1. */
  advertiserEdge?: Maybe<AdvertisersEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedAdvertiserNodeId?: Maybe<Scalars['ID']>;
  /** Reads a single `Advertiser` that is related to this `Advertiser`. */
  parent?: Maybe<Advertiser>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `Advertiser` mutation. */
export type DeleteAdvertiserPayloadAdvertiserEdgeArgs = {
  orderBy?: InputMaybe<Array<AdvertisersOrderBy>>;
};

/** All input for the `deleteBannerTargeting` mutation. */
export type DeleteBannerTargetingInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
};

/** The output of our delete `BannerTargeting` mutation. */
export type DeleteBannerTargetingPayload = {
  __typename?: 'DeleteBannerTargetingPayload';
  /** The `BannerTargeting` that was deleted by this mutation. */
  bannerTargeting?: Maybe<BannerTargeting>;
  /** An edge for our `BannerTargeting`. May be used by Relay 1. */
  bannerTargetingEdge?: Maybe<BannerTargetingsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedBannerTargetingNodeId?: Maybe<Scalars['ID']>;
  /** Reads a single `LineItem` that is related to this `BannerTargeting`. */
  lineItem?: Maybe<LineItem>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `TargetList` that is related to this `BannerTargeting`. */
  targetList?: Maybe<TargetList>;
};


/** The output of our delete `BannerTargeting` mutation. */
export type DeleteBannerTargetingPayloadBannerTargetingEdgeArgs = {
  orderBy?: InputMaybe<Array<BannerTargetingsOrderBy>>;
};

/** All input for the `deleteCampaignByCampaignNumber` mutation. */
export type DeleteCampaignByCampaignNumberInput = {
  /** Four-digit PIO campaign number used by Client Services and preserved during import. */
  campaignNumber: Scalars['Int'];
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** All input for the `deleteCampaignByExternalPioId` mutation. */
export type DeleteCampaignByExternalPioIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  externalPioId: Scalars['String'];
};

/** All input for the `deleteCampaign` mutation. */
export type DeleteCampaignInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** All input for the `deleteCampaignLabel` mutation. */
export type DeleteCampaignLabelInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  labelId: Scalars['UUID'];
  placementsCampaignId: Scalars['String'];
};

/** The output of our delete `CampaignLabel` mutation. */
export type DeleteCampaignLabelPayload = {
  __typename?: 'DeleteCampaignLabelPayload';
  /** The `CampaignLabel` that was deleted by this mutation. */
  campaignLabel?: Maybe<CampaignLabel>;
  /** An edge for our `CampaignLabel`. May be used by Relay 1. */
  campaignLabelEdge?: Maybe<CampaignLabelsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedCampaignLabelNodeId?: Maybe<Scalars['ID']>;
  /** Reads a single `Label` that is related to this `CampaignLabel`. */
  label?: Maybe<Label>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `CampaignLabel` mutation. */
export type DeleteCampaignLabelPayloadCampaignLabelEdgeArgs = {
  orderBy?: InputMaybe<Array<CampaignLabelsOrderBy>>;
};

/** The output of our delete `Campaign` mutation. */
export type DeleteCampaignPayload = {
  __typename?: 'DeleteCampaignPayload';
  /** Reads a single `Advertiser` that is related to this `Campaign`. */
  advertiser?: Maybe<Advertiser>;
  /** Reads a single `Advertiser` that is related to this `Campaign`. */
  agency?: Maybe<Advertiser>;
  /** Reads a single `Advertiser` that is related to this `Campaign`. */
  billToAdvertiser?: Maybe<Advertiser>;
  /** Reads a single `Advertiser` that is related to this `Campaign`. */
  brand?: Maybe<Advertiser>;
  /** The `Campaign` that was deleted by this mutation. */
  campaign?: Maybe<Campaign>;
  /** An edge for our `Campaign`. May be used by Relay 1. */
  campaignEdge?: Maybe<CampaignsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedCampaignNodeId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `Campaign` mutation. */
export type DeleteCampaignPayloadCampaignEdgeArgs = {
  orderBy?: InputMaybe<Array<CampaignsOrderBy>>;
};

/** All input for the `deleteClicksCreative` mutation. */
export type DeleteClicksCreativeInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** ID for the creative. */
  id: Scalars['Int'];
};

/** The output of our delete `ClicksCreative` mutation. */
export type DeleteClicksCreativePayload = {
  __typename?: 'DeleteClicksCreativePayload';
  /** The `ClicksCreative` that was deleted by this mutation. */
  clicksCreative?: Maybe<ClicksCreative>;
  /** An edge for our `ClicksCreative`. May be used by Relay 1. */
  clicksCreativeEdge?: Maybe<ClicksCreativesEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedClicksCreativeNodeId?: Maybe<Scalars['ID']>;
  /** Reads a single `LineItem` that is related to this `ClicksCreative`. */
  lineItem?: Maybe<LineItem>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `ClicksCreative` mutation. */
export type DeleteClicksCreativePayloadClicksCreativeEdgeArgs = {
  orderBy?: InputMaybe<Array<ClicksCreativesOrderBy>>;
};

/** All input for the `deleteEndemicDriver` mutation. */
export type DeleteEndemicDriverInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** ID for the endemic driver. */
  id: Scalars['Int'];
};

/** The output of our delete `EndemicDriver` mutation. */
export type DeleteEndemicDriverPayload = {
  __typename?: 'DeleteEndemicDriverPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedEndemicDriverNodeId?: Maybe<Scalars['ID']>;
  /** The `EndemicDriver` that was deleted by this mutation. */
  endemicDriver?: Maybe<EndemicDriver>;
  /** An edge for our `EndemicDriver`. May be used by Relay 1. */
  endemicDriverEdge?: Maybe<EndemicDriversEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `EndemicDriver` mutation. */
export type DeleteEndemicDriverPayloadEndemicDriverEdgeArgs = {
  orderBy?: InputMaybe<Array<EndemicDriversOrderBy>>;
};

/** All input for the `deleteEndemicDriverTargetList` mutation. */
export type DeleteEndemicDriverTargetListInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  endemicDriverId: Scalars['Int'];
  targetListId: Scalars['Int'];
};

/** The output of our delete `EndemicDriverTargetList` mutation. */
export type DeleteEndemicDriverTargetListPayload = {
  __typename?: 'DeleteEndemicDriverTargetListPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedEndemicDriverTargetListNodeId?: Maybe<Scalars['ID']>;
  /** Reads a single `EndemicDriver` that is related to this `EndemicDriverTargetList`. */
  endemicDriver?: Maybe<EndemicDriver>;
  /** The `EndemicDriverTargetList` that was deleted by this mutation. */
  endemicDriverTargetList?: Maybe<EndemicDriverTargetList>;
  /** An edge for our `EndemicDriverTargetList`. May be used by Relay 1. */
  endemicDriverTargetListEdge?: Maybe<EndemicDriverTargetListsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `TargetList` that is related to this `EndemicDriverTargetList`. */
  targetList?: Maybe<TargetList>;
};


/** The output of our delete `EndemicDriverTargetList` mutation. */
export type DeleteEndemicDriverTargetListPayloadEndemicDriverTargetListEdgeArgs = {
  orderBy?: InputMaybe<Array<EndemicDriverTargetListsOrderBy>>;
};

/** All input for the `deleteEndemicDriverTopicTag` mutation. */
export type DeleteEndemicDriverTopicTagInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  endemicDriverId: Scalars['Int'];
  topicTagId: Scalars['String'];
};

/** The output of our delete `EndemicDriverTopicTag` mutation. */
export type DeleteEndemicDriverTopicTagPayload = {
  __typename?: 'DeleteEndemicDriverTopicTagPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedEndemicDriverTopicTagNodeId?: Maybe<Scalars['ID']>;
  /** Reads a single `EndemicDriver` that is related to this `EndemicDriverTopicTag`. */
  endemicDriver?: Maybe<EndemicDriver>;
  /** The `EndemicDriverTopicTag` that was deleted by this mutation. */
  endemicDriverTopicTag?: Maybe<EndemicDriverTopicTag>;
  /** An edge for our `EndemicDriverTopicTag`. May be used by Relay 1. */
  endemicDriverTopicTagEdge?: Maybe<EndemicDriverTopicTagsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `TopicTag` that is related to this `EndemicDriverTopicTag`. */
  topicTag?: Maybe<TopicTag>;
};


/** The output of our delete `EndemicDriverTopicTag` mutation. */
export type DeleteEndemicDriverTopicTagPayloadEndemicDriverTopicTagEdgeArgs = {
  orderBy?: InputMaybe<Array<EndemicDriverTopicTagsOrderBy>>;
};

/** All input for the `deleteFmaCreative` mutation. */
export type DeleteFmaCreativeInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** ID for the creative. */
  id: Scalars['Int'];
};

/** The output of our delete `FmaCreative` mutation. */
export type DeleteFmaCreativePayload = {
  __typename?: 'DeleteFmaCreativePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedFmaCreativeNodeId?: Maybe<Scalars['ID']>;
  /** The `FmaCreative` that was deleted by this mutation. */
  fmaCreative?: Maybe<FmaCreative>;
  /** An edge for our `FmaCreative`. May be used by Relay 1. */
  fmaCreativeEdge?: Maybe<FmaCreativesEdge>;
  /** Reads a single `LineItem` that is related to this `FmaCreative`. */
  lineItem?: Maybe<LineItem>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `FmaCreative` mutation. */
export type DeleteFmaCreativePayloadFmaCreativeEdgeArgs = {
  orderBy?: InputMaybe<Array<FmaCreativesOrderBy>>;
};

/** All input for the `deleteLabelByName` mutation. */
export type DeleteLabelByNameInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
};

/** All input for the `deleteLabel` mutation. */
export type DeleteLabelInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** The output of our delete `Label` mutation. */
export type DeleteLabelPayload = {
  __typename?: 'DeleteLabelPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedLabelNodeId?: Maybe<Scalars['ID']>;
  /** The `Label` that was deleted by this mutation. */
  label?: Maybe<Label>;
  /** An edge for our `Label`. May be used by Relay 1. */
  labelEdge?: Maybe<LabelsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `Label` mutation. */
export type DeleteLabelPayloadLabelEdgeArgs = {
  orderBy?: InputMaybe<Array<LabelsOrderBy>>;
};

/** All input for the `deleteLeadGenCampaign` mutation. */
export type DeleteLeadGenCampaignInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
};

/** The output of our delete `LeadGenCampaign` mutation. */
export type DeleteLeadGenCampaignPayload = {
  __typename?: 'DeleteLeadGenCampaignPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedLeadGenCampaignNodeId?: Maybe<Scalars['ID']>;
  /** The `LeadGenCampaign` that was deleted by this mutation. */
  leadGenCampaign?: Maybe<LeadGenCampaign>;
  /** An edge for our `LeadGenCampaign`. May be used by Relay 1. */
  leadGenCampaignEdge?: Maybe<LeadGenCampaignsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `LeadGenCampaign` mutation. */
export type DeleteLeadGenCampaignPayloadLeadGenCampaignEdgeArgs = {
  orderBy?: InputMaybe<Array<LeadGenCampaignsOrderBy>>;
};

/** All input for the `deleteLeadGenViewByLeadGenCampaignIdAndBrowserInstanceId` mutation. */
export type DeleteLeadGenViewByLeadGenCampaignIdAndBrowserInstanceIdInput = {
  browserInstanceId: Scalars['String'];
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  leadGenCampaignId: Scalars['Int'];
};

/** All input for the `deleteLeadGenView` mutation. */
export type DeleteLeadGenViewInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
};

/** The output of our delete `LeadGenView` mutation. */
export type DeleteLeadGenViewPayload = {
  __typename?: 'DeleteLeadGenViewPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedLeadGenViewNodeId?: Maybe<Scalars['ID']>;
  /** Reads a single `LeadGenCampaign` that is related to this `LeadGenView`. */
  leadGenCampaign?: Maybe<LeadGenCampaign>;
  /** The `LeadGenView` that was deleted by this mutation. */
  leadGenView?: Maybe<LeadGenView>;
  /** An edge for our `LeadGenView`. May be used by Relay 1. */
  leadGenViewEdge?: Maybe<LeadGenViewsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `LeadGenView` mutation. */
export type DeleteLeadGenViewPayloadLeadGenViewEdgeArgs = {
  orderBy?: InputMaybe<Array<LeadGenViewsOrderBy>>;
};

/** All input for the `deleteLineItemByCampaignIdAndLineItemNumber` mutation. */
export type DeleteLineItemByCampaignIdAndLineItemNumberInput = {
  campaignId: Scalars['UUID'];
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** PIO line item number preserved during import; unique within each campaign because PIO line-item numbers are campaign-scoped. */
  lineItemNumber: Scalars['Int'];
};

/** All input for the `deleteLineItemByExternalPioId` mutation. */
export type DeleteLineItemByExternalPioIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  externalPioId: Scalars['String'];
};

/** All input for the `deleteLineItemDeliveryByLineItemIdAndPeriodStartAndPeriodEndAndSource` mutation. */
export type DeleteLineItemDeliveryByLineItemIdAndPeriodStartAndPeriodEndAndSourceInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  lineItemId: Scalars['UUID'];
  periodEnd: Scalars['Date'];
  periodStart: Scalars['Date'];
  /** Source of the reported monthly delivery numbers: client_dcm, gam, or manual. */
  source: LineItemDeliverySource;
};

/** All input for the `deleteLineItemDelivery` mutation. */
export type DeleteLineItemDeliveryInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** The output of our delete `LineItemDelivery` mutation. */
export type DeleteLineItemDeliveryPayload = {
  __typename?: 'DeleteLineItemDeliveryPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedLineItemDeliveryNodeId?: Maybe<Scalars['ID']>;
  /** Reads a single `LineItem` that is related to this `LineItemDelivery`. */
  lineItem?: Maybe<LineItem>;
  /** The `LineItemDelivery` that was deleted by this mutation. */
  lineItemDelivery?: Maybe<LineItemDelivery>;
  /** An edge for our `LineItemDelivery`. May be used by Relay 1. */
  lineItemDeliveryEdge?: Maybe<LineItemDeliveriesEdge>;
  /** Reads a single `PioUser` that is related to this `LineItemDelivery`. */
  pioUserByReportedBy?: Maybe<PioUser>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `LineItemDelivery` mutation. */
export type DeleteLineItemDeliveryPayloadLineItemDeliveryEdgeArgs = {
  orderBy?: InputMaybe<Array<LineItemDeliveriesOrderBy>>;
};

/** All input for the `deleteLineItem` mutation. */
export type DeleteLineItemInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** All input for the `deleteLineItemLabel` mutation. */
export type DeleteLineItemLabelInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  labelId: Scalars['UUID'];
  placementsLineItemId: Scalars['String'];
};

/** The output of our delete `LineItemLabel` mutation. */
export type DeleteLineItemLabelPayload = {
  __typename?: 'DeleteLineItemLabelPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedLineItemLabelNodeId?: Maybe<Scalars['ID']>;
  /** Reads a single `Label` that is related to this `LineItemLabel`. */
  label?: Maybe<Label>;
  /** Reads a single `LineItem` that is related to this `LineItemLabel`. */
  lineItem?: Maybe<LineItem>;
  /** The `LineItemLabel` that was deleted by this mutation. */
  lineItemLabel?: Maybe<LineItemLabel>;
  /** An edge for our `LineItemLabel`. May be used by Relay 1. */
  lineItemLabelEdge?: Maybe<LineItemLabelsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `LineItemLabel` mutation. */
export type DeleteLineItemLabelPayloadLineItemLabelEdgeArgs = {
  orderBy?: InputMaybe<Array<LineItemLabelsOrderBy>>;
};

/** The output of our delete `LineItem` mutation. */
export type DeleteLineItemPayload = {
  __typename?: 'DeleteLineItemPayload';
  /** Reads a single `Campaign` that is related to this `LineItem`. */
  campaign?: Maybe<Campaign>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `LineItem` that is related to this `LineItem`. */
  copiedFromLineItem?: Maybe<LineItem>;
  deletedLineItemNodeId?: Maybe<Scalars['ID']>;
  /** The `LineItem` that was deleted by this mutation. */
  lineItem?: Maybe<LineItem>;
  /** An edge for our `LineItem`. May be used by Relay 1. */
  lineItemEdge?: Maybe<LineItemsEdge>;
  /** Reads a single `PioUser` that is related to this `LineItem`. */
  pioUserByReviewedBy?: Maybe<PioUser>;
  /** Reads a single `Product` that is related to this `LineItem`. */
  product?: Maybe<Product>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `LineItem` mutation. */
export type DeleteLineItemPayloadLineItemEdgeArgs = {
  orderBy?: InputMaybe<Array<LineItemsOrderBy>>;
};

/** All input for the `deleteProduct` mutation. */
export type DeleteProductInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** The output of our delete `Product` mutation. */
export type DeleteProductPayload = {
  __typename?: 'DeleteProductPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedProductNodeId?: Maybe<Scalars['ID']>;
  /** The `Product` that was deleted by this mutation. */
  product?: Maybe<Product>;
  /** An edge for our `Product`. May be used by Relay 1. */
  productEdge?: Maybe<ProductsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `Product` mutation. */
export type DeleteProductPayloadProductEdgeArgs = {
  orderBy?: InputMaybe<Array<ProductsOrderBy>>;
};

/** All input for the `deleteProfession` mutation. */
export type DeleteProfessionInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
};

/** The output of our delete `Profession` mutation. */
export type DeleteProfessionPayload = {
  __typename?: 'DeleteProfessionPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedProfessionNodeId?: Maybe<Scalars['ID']>;
  /** The `Profession` that was deleted by this mutation. */
  profession?: Maybe<Profession>;
  /** An edge for our `Profession`. May be used by Relay 1. */
  professionEdge?: Maybe<ProfessionsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `Profession` mutation. */
export type DeleteProfessionPayloadProfessionEdgeArgs = {
  orderBy?: InputMaybe<Array<ProfessionsOrderBy>>;
};

/** All input for the `deleteSpecialtyGroup` mutation. */
export type DeleteSpecialtyGroupInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** The output of our delete `SpecialtyGroup` mutation. */
export type DeleteSpecialtyGroupPayload = {
  __typename?: 'DeleteSpecialtyGroupPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedSpecialtyGroupNodeId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `SpecialtyGroup` that was deleted by this mutation. */
  specialtyGroup?: Maybe<SpecialtyGroup>;
  /** An edge for our `SpecialtyGroup`. May be used by Relay 1. */
  specialtyGroupEdge?: Maybe<SpecialtyGroupsEdge>;
};


/** The output of our delete `SpecialtyGroup` mutation. */
export type DeleteSpecialtyGroupPayloadSpecialtyGroupEdgeArgs = {
  orderBy?: InputMaybe<Array<SpecialtyGroupsOrderBy>>;
};

/** All input for the `deleteSpecialty` mutation. */
export type DeleteSpecialtyInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
};

/** The output of our delete `Specialty` mutation. */
export type DeleteSpecialtyPayload = {
  __typename?: 'DeleteSpecialtyPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedSpecialtyNodeId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `Specialty` that was deleted by this mutation. */
  specialty?: Maybe<Specialty>;
  /** An edge for our `Specialty`. May be used by Relay 1. */
  specialtyEdge?: Maybe<SpecialtiesEdge>;
};


/** The output of our delete `Specialty` mutation. */
export type DeleteSpecialtyPayloadSpecialtyEdgeArgs = {
  orderBy?: InputMaybe<Array<SpecialtiesOrderBy>>;
};

/** All input for the `deleteSponsoredContentTeaser` mutation. */
export type DeleteSponsoredContentTeaserInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
};

/** The output of our delete `SponsoredContentTeaser` mutation. */
export type DeleteSponsoredContentTeaserPayload = {
  __typename?: 'DeleteSponsoredContentTeaserPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedSponsoredContentTeaserNodeId?: Maybe<Scalars['ID']>;
  /** Reads a single `LineItem` that is related to this `SponsoredContentTeaser`. */
  lineItem?: Maybe<LineItem>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `SponsoredContentTeaser` that was deleted by this mutation. */
  sponsoredContentTeaser?: Maybe<SponsoredContentTeaser>;
  /** An edge for our `SponsoredContentTeaser`. May be used by Relay 1. */
  sponsoredContentTeaserEdge?: Maybe<SponsoredContentTeasersEdge>;
};


/** The output of our delete `SponsoredContentTeaser` mutation. */
export type DeleteSponsoredContentTeaserPayloadSponsoredContentTeaserEdgeArgs = {
  orderBy?: InputMaybe<Array<SponsoredContentTeasersOrderBy>>;
};

/** All input for the `deleteSponsoredContentTeaserProfession` mutation. */
export type DeleteSponsoredContentTeaserProfessionInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  professionId: Scalars['Int'];
  sponsoredContentTeaserId: Scalars['Int'];
};

/** The output of our delete `SponsoredContentTeaserProfession` mutation. */
export type DeleteSponsoredContentTeaserProfessionPayload = {
  __typename?: 'DeleteSponsoredContentTeaserProfessionPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedSponsoredContentTeaserProfessionNodeId?: Maybe<Scalars['ID']>;
  /** Reads a single `Profession` that is related to this `SponsoredContentTeaserProfession`. */
  profession?: Maybe<Profession>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `SponsoredContentTeaser` that is related to this `SponsoredContentTeaserProfession`. */
  sponsoredContentTeaser?: Maybe<SponsoredContentTeaser>;
  /** The `SponsoredContentTeaserProfession` that was deleted by this mutation. */
  sponsoredContentTeaserProfession?: Maybe<SponsoredContentTeaserProfession>;
  /** An edge for our `SponsoredContentTeaserProfession`. May be used by Relay 1. */
  sponsoredContentTeaserProfessionEdge?: Maybe<SponsoredContentTeaserProfessionsEdge>;
};


/** The output of our delete `SponsoredContentTeaserProfession` mutation. */
export type DeleteSponsoredContentTeaserProfessionPayloadSponsoredContentTeaserProfessionEdgeArgs = {
  orderBy?: InputMaybe<Array<SponsoredContentTeaserProfessionsOrderBy>>;
};

/** All input for the `deleteSponsoredContentTeaserSpecialty` mutation. */
export type DeleteSponsoredContentTeaserSpecialtyInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  specialtyId: Scalars['Int'];
  sponsoredContentTeaserId: Scalars['Int'];
};

/** The output of our delete `SponsoredContentTeaserSpecialty` mutation. */
export type DeleteSponsoredContentTeaserSpecialtyPayload = {
  __typename?: 'DeleteSponsoredContentTeaserSpecialtyPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedSponsoredContentTeaserSpecialtyNodeId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Specialty` that is related to this `SponsoredContentTeaserSpecialty`. */
  specialty?: Maybe<Specialty>;
  /** Reads a single `SponsoredContentTeaser` that is related to this `SponsoredContentTeaserSpecialty`. */
  sponsoredContentTeaser?: Maybe<SponsoredContentTeaser>;
  /** The `SponsoredContentTeaserSpecialty` that was deleted by this mutation. */
  sponsoredContentTeaserSpecialty?: Maybe<SponsoredContentTeaserSpecialty>;
  /** An edge for our `SponsoredContentTeaserSpecialty`. May be used by Relay 1. */
  sponsoredContentTeaserSpecialtyEdge?: Maybe<SponsoredContentTeaserSpecialtiesEdge>;
};


/** The output of our delete `SponsoredContentTeaserSpecialty` mutation. */
export type DeleteSponsoredContentTeaserSpecialtyPayloadSponsoredContentTeaserSpecialtyEdgeArgs = {
  orderBy?: InputMaybe<Array<SponsoredContentTeaserSpecialtiesOrderBy>>;
};

/** All input for the `deleteSponsoredContentTeaserTargetList` mutation. */
export type DeleteSponsoredContentTeaserTargetListInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  sponsoredContentTeaserId: Scalars['Int'];
  targetListId: Scalars['Int'];
};

/** The output of our delete `SponsoredContentTeaserTargetList` mutation. */
export type DeleteSponsoredContentTeaserTargetListPayload = {
  __typename?: 'DeleteSponsoredContentTeaserTargetListPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedSponsoredContentTeaserTargetListNodeId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `SponsoredContentTeaser` that is related to this `SponsoredContentTeaserTargetList`. */
  sponsoredContentTeaser?: Maybe<SponsoredContentTeaser>;
  /** The `SponsoredContentTeaserTargetList` that was deleted by this mutation. */
  sponsoredContentTeaserTargetList?: Maybe<SponsoredContentTeaserTargetList>;
  /** An edge for our `SponsoredContentTeaserTargetList`. May be used by Relay 1. */
  sponsoredContentTeaserTargetListEdge?: Maybe<SponsoredContentTeaserTargetListsEdge>;
  /** Reads a single `TargetList` that is related to this `SponsoredContentTeaserTargetList`. */
  targetList?: Maybe<TargetList>;
};


/** The output of our delete `SponsoredContentTeaserTargetList` mutation. */
export type DeleteSponsoredContentTeaserTargetListPayloadSponsoredContentTeaserTargetListEdgeArgs = {
  orderBy?: InputMaybe<Array<SponsoredContentTeaserTargetListsOrderBy>>;
};

/** All input for the `deleteTargetList` mutation. */
export type DeleteTargetListInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** ID for the target group. */
  id: Scalars['Int'];
};

/** The output of our delete `TargetList` mutation. */
export type DeleteTargetListPayload = {
  __typename?: 'DeleteTargetListPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedTargetListNodeId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `TargetList` that was deleted by this mutation. */
  targetList?: Maybe<TargetList>;
  /** An edge for our `TargetList`. May be used by Relay 1. */
  targetListEdge?: Maybe<TargetListsEdge>;
};


/** The output of our delete `TargetList` mutation. */
export type DeleteTargetListPayloadTargetListEdgeArgs = {
  orderBy?: InputMaybe<Array<TargetListsOrderBy>>;
};

/** All input for the `deleteTopicTag` mutation. */
export type DeleteTopicTagInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
};

/** The output of our delete `TopicTag` mutation. */
export type DeleteTopicTagPayload = {
  __typename?: 'DeleteTopicTagPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedTopicTagNodeId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `TopicTag` that was deleted by this mutation. */
  topicTag?: Maybe<TopicTag>;
  /** An edge for our `TopicTag`. May be used by Relay 1. */
  topicTagEdge?: Maybe<TopicTagsEdge>;
};


/** The output of our delete `TopicTag` mutation. */
export type DeleteTopicTagPayloadTopicTagEdgeArgs = {
  orderBy?: InputMaybe<Array<TopicTagsOrderBy>>;
};

/** All input for the `duplicateClicksCreative` mutation. */
export type DuplicateClicksCreativeInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  existingId: Scalars['Int'];
};

/** The output of our `duplicateClicksCreative` mutation. */
export type DuplicateClicksCreativePayload = {
  __typename?: 'DuplicateClicksCreativePayload';
  clicksCreative?: Maybe<ClicksCreative>;
  /** An edge for our `ClicksCreative`. May be used by Relay 1. */
  clicksCreativeEdge?: Maybe<ClicksCreativesEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `LineItem` that is related to this `ClicksCreative`. */
  lineItem?: Maybe<LineItem>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our `duplicateClicksCreative` mutation. */
export type DuplicateClicksCreativePayloadClicksCreativeEdgeArgs = {
  orderBy?: InputMaybe<Array<ClicksCreativesOrderBy>>;
};

/** All input for the `duplicateFmaCreative` mutation. */
export type DuplicateFmaCreativeInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  existingId: Scalars['Int'];
};

/** The output of our `duplicateFmaCreative` mutation. */
export type DuplicateFmaCreativePayload = {
  __typename?: 'DuplicateFmaCreativePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  fmaCreative?: Maybe<FmaCreative>;
  /** An edge for our `FmaCreative`. May be used by Relay 1. */
  fmaCreativeEdge?: Maybe<FmaCreativesEdge>;
  /** Reads a single `LineItem` that is related to this `FmaCreative`. */
  lineItem?: Maybe<LineItem>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our `duplicateFmaCreative` mutation. */
export type DuplicateFmaCreativePayloadFmaCreativeEdgeArgs = {
  orderBy?: InputMaybe<Array<FmaCreativesOrderBy>>;
};

export type EndemicDriver = {
  __typename?: 'EndemicDriver';
  contentfulId: Scalars['String'];
  driverContentType: Scalars['String'];
  /** Reads and enables pagination through a set of `EndemicDriverTargetList`. */
  endemicDriverTargetLists: EndemicDriverTargetListsConnection;
  /** Reads and enables pagination through a set of `EndemicDriverTopicTag`. */
  endemicDriverTopicTags: EndemicDriverTopicTagsConnection;
  endsAt: Scalars['Datetime'];
  /** ID for the endemic driver. */
  id: Scalars['Int'];
  isApproved: Scalars['Boolean'];
  name: Scalars['String'];
  priority: Scalars['Int'];
  professionIdsList?: Maybe<Array<Maybe<Scalars['Int']>>>;
  /** Reads and enables pagination through a set of `Profession`. */
  professionsList?: Maybe<Array<Profession>>;
  /** Reads and enables pagination through a set of `Specialty`. */
  specialtiesList?: Maybe<Array<Specialty>>;
  specialtyIdsList?: Maybe<Array<Maybe<Scalars['Int']>>>;
  startsAt: Scalars['Datetime'];
  /** Reads and enables pagination through a set of `TargetList`. */
  targetListsList?: Maybe<Array<TargetList>>;
  topicTagIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Reads and enables pagination through a set of `TopicTag`. */
  topicTagsList?: Maybe<Array<TopicTag>>;
};


export type EndemicDriverEndemicDriverTargetListsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<EndemicDriverTargetListCondition>;
  filter?: InputMaybe<EndemicDriverTargetListFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EndemicDriverTargetListsOrderBy>>;
};


export type EndemicDriverEndemicDriverTopicTagsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<EndemicDriverTopicTagCondition>;
  filter?: InputMaybe<EndemicDriverTopicTagFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EndemicDriverTopicTagsOrderBy>>;
};


export type EndemicDriverProfessionIdsListArgs = {
  filter?: InputMaybe<IntFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type EndemicDriverProfessionsListArgs = {
  filter?: InputMaybe<ProfessionFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type EndemicDriverSpecialtiesListArgs = {
  filter?: InputMaybe<SpecialtyFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type EndemicDriverSpecialtyIdsListArgs = {
  filter?: InputMaybe<IntFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type EndemicDriverTargetListsListArgs = {
  filter?: InputMaybe<TargetListFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type EndemicDriverTopicTagsListArgs = {
  filter?: InputMaybe<TopicTagFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

/**
 * A condition to be used against `EndemicDriver` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type EndemicDriverCondition = {
  /** Checks for equality with the object’s `contentfulId` field. */
  contentfulId?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `driverContentType` field. */
  driverContentType?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `endsAt` field. */
  endsAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `isApproved` field. */
  isApproved?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `priority` field. */
  priority?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `startsAt` field. */
  startsAt?: InputMaybe<Scalars['Datetime']>;
};

/** A filter to be used against `EndemicDriver` object types. All fields are combined with a logical ‘and.’ */
export type EndemicDriverFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<EndemicDriverFilter>>;
  /** Filter by the object’s `contentfulId` field. */
  contentfulId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `driverContentType` field. */
  driverContentType?: InputMaybe<StringFilter>;
  /** Filter by the object’s `endsAt` field. */
  endsAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `isApproved` field. */
  isApproved?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<EndemicDriverFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<EndemicDriverFilter>>;
  /** Filter by the object’s `priority` field. */
  priority?: InputMaybe<IntFilter>;
  /** Filter by the object’s `startsAt` field. */
  startsAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `topicTagIds` field. */
  topicTagIds?: InputMaybe<StringListFilter>;
};

/** An input for mutations affecting `EndemicDriver` */
export type EndemicDriverInput = {
  contentfulId: Scalars['String'];
  driverContentType: Scalars['String'];
  endsAt: Scalars['Datetime'];
  /** ID for the endemic driver. */
  id?: InputMaybe<Scalars['Int']>;
  isApproved?: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
  priority: Scalars['Int'];
  startsAt: Scalars['Datetime'];
};

/** Represents an update to a `EndemicDriver`. Fields that are set will be updated. */
export type EndemicDriverPatch = {
  contentfulId?: InputMaybe<Scalars['String']>;
  driverContentType?: InputMaybe<Scalars['String']>;
  endsAt?: InputMaybe<Scalars['Datetime']>;
  /** ID for the endemic driver. */
  id?: InputMaybe<Scalars['Int']>;
  isApproved?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  priority?: InputMaybe<Scalars['Int']>;
  startsAt?: InputMaybe<Scalars['Datetime']>;
};

export type EndemicDriverTargetList = {
  __typename?: 'EndemicDriverTargetList';
  createdAt: Scalars['Datetime'];
  /** Reads a single `EndemicDriver` that is related to this `EndemicDriverTargetList`. */
  endemicDriver?: Maybe<EndemicDriver>;
  endemicDriverId: Scalars['Int'];
  /** Reads a single `TargetList` that is related to this `EndemicDriverTargetList`. */
  targetList?: Maybe<TargetList>;
  targetListId: Scalars['Int'];
};

/**
 * A condition to be used against `EndemicDriverTargetList` object types. All
 * fields are tested for equality and combined with a logical ‘and.’
 */
export type EndemicDriverTargetListCondition = {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `endemicDriverId` field. */
  endemicDriverId?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `targetListId` field. */
  targetListId?: InputMaybe<Scalars['Int']>;
};

/** A filter to be used against `EndemicDriverTargetList` object types. All fields are combined with a logical ‘and.’ */
export type EndemicDriverTargetListFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<EndemicDriverTargetListFilter>>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `endemicDriverId` field. */
  endemicDriverId?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<EndemicDriverTargetListFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<EndemicDriverTargetListFilter>>;
  /** Filter by the object’s `targetListId` field. */
  targetListId?: InputMaybe<IntFilter>;
};

/** An input for mutations affecting `EndemicDriverTargetList` */
export type EndemicDriverTargetListInput = {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  endemicDriverId: Scalars['Int'];
  targetListId: Scalars['Int'];
};

/** Represents an update to a `EndemicDriverTargetList`. Fields that are set will be updated. */
export type EndemicDriverTargetListPatch = {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  endemicDriverId?: InputMaybe<Scalars['Int']>;
  targetListId?: InputMaybe<Scalars['Int']>;
};

/** A connection to a list of `EndemicDriverTargetList` values. */
export type EndemicDriverTargetListsConnection = {
  __typename?: 'EndemicDriverTargetListsConnection';
  /** A list of edges which contains the `EndemicDriverTargetList` and cursor to aid in pagination. */
  edges: Array<EndemicDriverTargetListsEdge>;
  /** A list of `EndemicDriverTargetList` objects. */
  nodes: Array<EndemicDriverTargetList>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `EndemicDriverTargetList` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `EndemicDriverTargetList` edge in the connection. */
export type EndemicDriverTargetListsEdge = {
  __typename?: 'EndemicDriverTargetListsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `EndemicDriverTargetList` at the end of the edge. */
  node: EndemicDriverTargetList;
};

/** Methods to use when ordering `EndemicDriverTargetList`. */
export enum EndemicDriverTargetListsOrderBy {
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  EndemicDriverIdAsc = 'ENDEMIC_DRIVER_ID_ASC',
  EndemicDriverIdDesc = 'ENDEMIC_DRIVER_ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  TargetListIdAsc = 'TARGET_LIST_ID_ASC',
  TargetListIdDesc = 'TARGET_LIST_ID_DESC'
}

export type EndemicDriverTopicTag = {
  __typename?: 'EndemicDriverTopicTag';
  createdAt: Scalars['Datetime'];
  /** Reads a single `EndemicDriver` that is related to this `EndemicDriverTopicTag`. */
  endemicDriver?: Maybe<EndemicDriver>;
  endemicDriverId: Scalars['Int'];
  /** Reads a single `TopicTag` that is related to this `EndemicDriverTopicTag`. */
  topicTag?: Maybe<TopicTag>;
  topicTagId: Scalars['String'];
};

/**
 * A condition to be used against `EndemicDriverTopicTag` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type EndemicDriverTopicTagCondition = {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `endemicDriverId` field. */
  endemicDriverId?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `topicTagId` field. */
  topicTagId?: InputMaybe<Scalars['String']>;
};

/** A filter to be used against `EndemicDriverTopicTag` object types. All fields are combined with a logical ‘and.’ */
export type EndemicDriverTopicTagFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<EndemicDriverTopicTagFilter>>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `endemicDriverId` field. */
  endemicDriverId?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<EndemicDriverTopicTagFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<EndemicDriverTopicTagFilter>>;
  /** Filter by the object’s `topicTagId` field. */
  topicTagId?: InputMaybe<StringFilter>;
};

/** An input for mutations affecting `EndemicDriverTopicTag` */
export type EndemicDriverTopicTagInput = {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  endemicDriverId: Scalars['Int'];
  topicTagId: Scalars['String'];
};

/** Represents an update to a `EndemicDriverTopicTag`. Fields that are set will be updated. */
export type EndemicDriverTopicTagPatch = {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  endemicDriverId?: InputMaybe<Scalars['Int']>;
  topicTagId?: InputMaybe<Scalars['String']>;
};

/** A connection to a list of `EndemicDriverTopicTag` values. */
export type EndemicDriverTopicTagsConnection = {
  __typename?: 'EndemicDriverTopicTagsConnection';
  /** A list of edges which contains the `EndemicDriverTopicTag` and cursor to aid in pagination. */
  edges: Array<EndemicDriverTopicTagsEdge>;
  /** A list of `EndemicDriverTopicTag` objects. */
  nodes: Array<EndemicDriverTopicTag>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `EndemicDriverTopicTag` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `EndemicDriverTopicTag` edge in the connection. */
export type EndemicDriverTopicTagsEdge = {
  __typename?: 'EndemicDriverTopicTagsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `EndemicDriverTopicTag` at the end of the edge. */
  node: EndemicDriverTopicTag;
};

/** Methods to use when ordering `EndemicDriverTopicTag`. */
export enum EndemicDriverTopicTagsOrderBy {
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  EndemicDriverIdAsc = 'ENDEMIC_DRIVER_ID_ASC',
  EndemicDriverIdDesc = 'ENDEMIC_DRIVER_ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  TopicTagIdAsc = 'TOPIC_TAG_ID_ASC',
  TopicTagIdDesc = 'TOPIC_TAG_ID_DESC'
}

/** A connection to a list of `EndemicDriver` values. */
export type EndemicDriversConnection = {
  __typename?: 'EndemicDriversConnection';
  /** A list of edges which contains the `EndemicDriver` and cursor to aid in pagination. */
  edges: Array<EndemicDriversEdge>;
  /** A list of `EndemicDriver` objects. */
  nodes: Array<EndemicDriver>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `EndemicDriver` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `EndemicDriver` edge in the connection. */
export type EndemicDriversEdge = {
  __typename?: 'EndemicDriversEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `EndemicDriver` at the end of the edge. */
  node: EndemicDriver;
};

/** Methods to use when ordering `EndemicDriver`. */
export enum EndemicDriversOrderBy {
  ContentfulIdAsc = 'CONTENTFUL_ID_ASC',
  ContentfulIdDesc = 'CONTENTFUL_ID_DESC',
  DriverContentTypeAsc = 'DRIVER_CONTENT_TYPE_ASC',
  DriverContentTypeDesc = 'DRIVER_CONTENT_TYPE_DESC',
  EndsAtAsc = 'ENDS_AT_ASC',
  EndsAtDesc = 'ENDS_AT_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  IsApprovedAsc = 'IS_APPROVED_ASC',
  IsApprovedDesc = 'IS_APPROVED_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  PriorityAsc = 'PRIORITY_ASC',
  PriorityDesc = 'PRIORITY_DESC',
  StartsAtAsc = 'STARTS_AT_ASC',
  StartsAtDesc = 'STARTS_AT_DESC'
}

/** FMA creatives. */
export type FmaCreative = {
  __typename?: 'FmaCreative';
  /** HTML body for the FMA - this is the HTML that is displayed in the modal. */
  bodyHtml: Scalars['String'];
  /** Sponsor/Company/Brand name for the alert. Optional. */
  companyName?: Maybe<Scalars['String']>;
  /** Contentful entry ID for the FMA microsurvey (one per FMA). */
  contentfulFmaMicrosurveyId?: Maybe<Scalars['String']>;
  enableCountdownCloseButton: Scalars['Boolean'];
  /** End date and time when this FMA should stop being displayed. */
  endsAt: Scalars['Datetime'];
  /** Reads and enables pagination through a set of `FmaView`. */
  fmaViews: FmaViewsConnection;
  hasActivityData?: Maybe<Scalars['Boolean']>;
  /** ID for the creative. */
  id: Scalars['Int'];
  isApproved?: Maybe<Scalars['Boolean']>;
  /** HTML that is displayed for the ISI of the FMA. */
  isiHtml?: Maybe<Scalars['String']>;
  /** The optional job number ID (a string) that is sometimes displayed with the alert. */
  jobNumber?: Maybe<Scalars['String']>;
  /** Reads a single `LineItem` that is related to this `FmaCreative`. */
  lineItem?: Maybe<LineItem>;
  /** Native CSAdmin line item FK added for PIO migration parallel-run; placements_line_item_id remains for rollback. */
  lineItemId?: Maybe<Scalars['UUID']>;
  /** Descriptive name for the creative - "Flight / Segment Name" */
  name: Scalars['String'];
  placementsCampaignId?: Maybe<Scalars['String']>;
  /** ID identifying the Placements Line Item that this creative is for. */
  placementsLineItemId?: Maybe<Scalars['String']>;
  priority: Scalars['Int'];
  /** Optional URL to use as destination for "Show Me More Info" button in the alert (aka "Touchpoint 2" URL) */
  showMoreInfoUrl?: Maybe<Scalars['String']>;
  /** Start date and time when this FMA should start to be displayed. */
  startsAt: Scalars['Datetime'];
  targetListIdsList?: Maybe<Array<Maybe<Scalars['Int']>>>;
  /** Reads and enables pagination through a set of `TargetList`. */
  targetLists: TargetListsConnection;
  /** Optional title for the alert. May instead be included directly in body HTML */
  title?: Maybe<Scalars['String']>;
  /** Number of views permitted for this FMA to be displayed to a targeted user per week. Defaults to 1. */
  viewsPerWeek: Scalars['Int'];
};


/** FMA creatives. */
export type FmaCreativeFmaViewsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<FmaViewCondition>;
  filter?: InputMaybe<FmaViewFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<FmaViewsOrderBy>>;
};


/** FMA creatives. */
export type FmaCreativeTargetListIdsListArgs = {
  filter?: InputMaybe<IntFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


/** FMA creatives. */
export type FmaCreativeTargetListsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  filter?: InputMaybe<TargetListFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

/**
 * A condition to be used against `FmaCreative` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type FmaCreativeCondition = {
  /** Checks for equality with the object’s `bodyHtml` field. */
  bodyHtml?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `companyName` field. */
  companyName?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `contentfulFmaMicrosurveyId` field. */
  contentfulFmaMicrosurveyId?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `enableCountdownCloseButton` field. */
  enableCountdownCloseButton?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `endsAt` field. */
  endsAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `isApproved` field. */
  isApproved?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `isiHtml` field. */
  isiHtml?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `jobNumber` field. */
  jobNumber?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `lineItemId` field. */
  lineItemId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `placementsCampaignId` field. */
  placementsCampaignId?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `placementsLineItemId` field. */
  placementsLineItemId?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `priority` field. */
  priority?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `showMoreInfoUrl` field. */
  showMoreInfoUrl?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `startsAt` field. */
  startsAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `title` field. */
  title?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `viewsPerWeek` field. */
  viewsPerWeek?: InputMaybe<Scalars['Int']>;
};

/** A filter to be used against `FmaCreative` object types. All fields are combined with a logical ‘and.’ */
export type FmaCreativeFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<FmaCreativeFilter>>;
  /** Filter by the object’s `bodyHtml` field. */
  bodyHtml?: InputMaybe<StringFilter>;
  /** Filter by the object’s `companyName` field. */
  companyName?: InputMaybe<StringFilter>;
  /** Filter by the object’s `contentfulFmaMicrosurveyId` field. */
  contentfulFmaMicrosurveyId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `enableCountdownCloseButton` field. */
  enableCountdownCloseButton?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `endsAt` field. */
  endsAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `hasActivityData` field. */
  hasActivityData?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `isApproved` field. */
  isApproved?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `isiHtml` field. */
  isiHtml?: InputMaybe<StringFilter>;
  /** Filter by the object’s `jobNumber` field. */
  jobNumber?: InputMaybe<StringFilter>;
  /** Filter by the object’s `lineItemId` field. */
  lineItemId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<FmaCreativeFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<FmaCreativeFilter>>;
  /** Filter by the object’s `placementsCampaignId` field. */
  placementsCampaignId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `placementsLineItemId` field. */
  placementsLineItemId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `priority` field. */
  priority?: InputMaybe<IntFilter>;
  /** Filter by the object’s `showMoreInfoUrl` field. */
  showMoreInfoUrl?: InputMaybe<StringFilter>;
  /** Filter by the object’s `startsAt` field. */
  startsAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `title` field. */
  title?: InputMaybe<StringFilter>;
  /** Filter by the object’s `viewsPerWeek` field. */
  viewsPerWeek?: InputMaybe<IntFilter>;
};

/** An input for mutations affecting `FmaCreative` */
export type FmaCreativeInput = {
  /** HTML body for the FMA - this is the HTML that is displayed in the modal. */
  bodyHtml: Scalars['String'];
  /** Sponsor/Company/Brand name for the alert. Optional. */
  companyName?: InputMaybe<Scalars['String']>;
  /** Contentful entry ID for the FMA microsurvey (one per FMA). */
  contentfulFmaMicrosurveyId?: InputMaybe<Scalars['String']>;
  enableCountdownCloseButton?: InputMaybe<Scalars['Boolean']>;
  /** End date and time when this FMA should stop being displayed. */
  endsAt: Scalars['Datetime'];
  /** ID for the creative. */
  id?: InputMaybe<Scalars['Int']>;
  isApproved?: InputMaybe<Scalars['Boolean']>;
  /** HTML that is displayed for the ISI of the FMA. */
  isiHtml?: InputMaybe<Scalars['String']>;
  /** The optional job number ID (a string) that is sometimes displayed with the alert. */
  jobNumber?: InputMaybe<Scalars['String']>;
  /** Native CSAdmin line item FK added for PIO migration parallel-run; placements_line_item_id remains for rollback. */
  lineItemId?: InputMaybe<Scalars['UUID']>;
  /** Descriptive name for the creative - "Flight / Segment Name" */
  name: Scalars['String'];
  placementsCampaignId?: InputMaybe<Scalars['String']>;
  /** ID identifying the Placements Line Item that this creative is for. */
  placementsLineItemId?: InputMaybe<Scalars['String']>;
  priority?: InputMaybe<Scalars['Int']>;
  /** Optional URL to use as destination for "Show Me More Info" button in the alert (aka "Touchpoint 2" URL) */
  showMoreInfoUrl?: InputMaybe<Scalars['String']>;
  /** Start date and time when this FMA should start to be displayed. */
  startsAt: Scalars['Datetime'];
  /** Optional title for the alert. May instead be included directly in body HTML */
  title?: InputMaybe<Scalars['String']>;
  /** Number of views permitted for this FMA to be displayed to a targeted user per week. Defaults to 1. */
  viewsPerWeek?: InputMaybe<Scalars['Int']>;
};

/** Represents an update to a `FmaCreative`. Fields that are set will be updated. */
export type FmaCreativePatch = {
  /** HTML body for the FMA - this is the HTML that is displayed in the modal. */
  bodyHtml?: InputMaybe<Scalars['String']>;
  /** Sponsor/Company/Brand name for the alert. Optional. */
  companyName?: InputMaybe<Scalars['String']>;
  /** Contentful entry ID for the FMA microsurvey (one per FMA). */
  contentfulFmaMicrosurveyId?: InputMaybe<Scalars['String']>;
  enableCountdownCloseButton?: InputMaybe<Scalars['Boolean']>;
  /** End date and time when this FMA should stop being displayed. */
  endsAt?: InputMaybe<Scalars['Datetime']>;
  /** ID for the creative. */
  id?: InputMaybe<Scalars['Int']>;
  isApproved?: InputMaybe<Scalars['Boolean']>;
  /** HTML that is displayed for the ISI of the FMA. */
  isiHtml?: InputMaybe<Scalars['String']>;
  /** The optional job number ID (a string) that is sometimes displayed with the alert. */
  jobNumber?: InputMaybe<Scalars['String']>;
  /** Native CSAdmin line item FK added for PIO migration parallel-run; placements_line_item_id remains for rollback. */
  lineItemId?: InputMaybe<Scalars['UUID']>;
  /** Descriptive name for the creative - "Flight / Segment Name" */
  name?: InputMaybe<Scalars['String']>;
  placementsCampaignId?: InputMaybe<Scalars['String']>;
  /** ID identifying the Placements Line Item that this creative is for. */
  placementsLineItemId?: InputMaybe<Scalars['String']>;
  priority?: InputMaybe<Scalars['Int']>;
  /** Optional URL to use as destination for "Show Me More Info" button in the alert (aka "Touchpoint 2" URL) */
  showMoreInfoUrl?: InputMaybe<Scalars['String']>;
  /** Start date and time when this FMA should start to be displayed. */
  startsAt?: InputMaybe<Scalars['Datetime']>;
  /** Optional title for the alert. May instead be included directly in body HTML */
  title?: InputMaybe<Scalars['String']>;
  /** Number of views permitted for this FMA to be displayed to a targeted user per week. Defaults to 1. */
  viewsPerWeek?: InputMaybe<Scalars['Int']>;
};

/** A connection to a list of `FmaCreative` values. */
export type FmaCreativesConnection = {
  __typename?: 'FmaCreativesConnection';
  /** A list of edges which contains the `FmaCreative` and cursor to aid in pagination. */
  edges: Array<FmaCreativesEdge>;
  /** A list of `FmaCreative` objects. */
  nodes: Array<FmaCreative>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `FmaCreative` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `FmaCreative` edge in the connection. */
export type FmaCreativesEdge = {
  __typename?: 'FmaCreativesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `FmaCreative` at the end of the edge. */
  node: FmaCreative;
};

/** Methods to use when ordering `FmaCreative`. */
export enum FmaCreativesOrderBy {
  BodyHtmlAsc = 'BODY_HTML_ASC',
  BodyHtmlDesc = 'BODY_HTML_DESC',
  CompanyNameAsc = 'COMPANY_NAME_ASC',
  CompanyNameDesc = 'COMPANY_NAME_DESC',
  ContentfulFmaMicrosurveyIdAsc = 'CONTENTFUL_FMA_MICROSURVEY_ID_ASC',
  ContentfulFmaMicrosurveyIdDesc = 'CONTENTFUL_FMA_MICROSURVEY_ID_DESC',
  EnableCountdownCloseButtonAsc = 'ENABLE_COUNTDOWN_CLOSE_BUTTON_ASC',
  EnableCountdownCloseButtonDesc = 'ENABLE_COUNTDOWN_CLOSE_BUTTON_DESC',
  EndsAtAsc = 'ENDS_AT_ASC',
  EndsAtDesc = 'ENDS_AT_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  IsiHtmlAsc = 'ISI_HTML_ASC',
  IsiHtmlDesc = 'ISI_HTML_DESC',
  IsApprovedAsc = 'IS_APPROVED_ASC',
  IsApprovedDesc = 'IS_APPROVED_DESC',
  JobNumberAsc = 'JOB_NUMBER_ASC',
  JobNumberDesc = 'JOB_NUMBER_DESC',
  LineItemIdAsc = 'LINE_ITEM_ID_ASC',
  LineItemIdDesc = 'LINE_ITEM_ID_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  Natural = 'NATURAL',
  PlacementsCampaignIdAsc = 'PLACEMENTS_CAMPAIGN_ID_ASC',
  PlacementsCampaignIdDesc = 'PLACEMENTS_CAMPAIGN_ID_DESC',
  PlacementsLineItemIdAsc = 'PLACEMENTS_LINE_ITEM_ID_ASC',
  PlacementsLineItemIdDesc = 'PLACEMENTS_LINE_ITEM_ID_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  PriorityAsc = 'PRIORITY_ASC',
  PriorityDesc = 'PRIORITY_DESC',
  ShowMoreInfoUrlAsc = 'SHOW_MORE_INFO_URL_ASC',
  ShowMoreInfoUrlDesc = 'SHOW_MORE_INFO_URL_DESC',
  StartsAtAsc = 'STARTS_AT_ASC',
  StartsAtDesc = 'STARTS_AT_DESC',
  TitleAsc = 'TITLE_ASC',
  TitleDesc = 'TITLE_DESC',
  ViewsPerWeekAsc = 'VIEWS_PER_WEEK_ASC',
  ViewsPerWeekDesc = 'VIEWS_PER_WEEK_DESC'
}

/** FMA view events. NPI is optional to support anonymous user tracking via ajs_anonymous_id. */
export type FmaView = {
  __typename?: 'FmaView';
  /** Analytics.js anonymous ID for tracking anonymous users and cross-session identity resolution */
  ajsAnonymousId?: Maybe<Scalars['String']>;
  /** Reads a single `FmaCreative` that is related to this `FmaView`. */
  fmaCreative?: Maybe<FmaCreative>;
  /** Viewed FMA creative ID */
  fmaCreativeId: Scalars['Int'];
  ipAddress?: Maybe<Scalars['String']>;
  /** Viewer NPI */
  npi?: Maybe<Scalars['Int']>;
  queryParams?: Maybe<Scalars['String']>;
  /** Viewer Firebase user ID if logged in */
  uid?: Maybe<Scalars['String']>;
  userAgent?: Maybe<Scalars['String']>;
  /** Event timestamp */
  viewedAt: Scalars['Datetime'];
};

/** A condition to be used against `FmaView` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type FmaViewCondition = {
  /** Checks for equality with the object’s `ajsAnonymousId` field. */
  ajsAnonymousId?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `fmaCreativeId` field. */
  fmaCreativeId?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `ipAddress` field. */
  ipAddress?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `npi` field. */
  npi?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `queryParams` field. */
  queryParams?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `uid` field. */
  uid?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `userAgent` field. */
  userAgent?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `viewedAt` field. */
  viewedAt?: InputMaybe<Scalars['Datetime']>;
};

/** A filter to be used against `FmaView` object types. All fields are combined with a logical ‘and.’ */
export type FmaViewFilter = {
  /** Filter by the object’s `ajsAnonymousId` field. */
  ajsAnonymousId?: InputMaybe<StringFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<FmaViewFilter>>;
  /** Filter by the object’s `fmaCreativeId` field. */
  fmaCreativeId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `ipAddress` field. */
  ipAddress?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<FmaViewFilter>;
  /** Filter by the object’s `npi` field. */
  npi?: InputMaybe<IntFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<FmaViewFilter>>;
  /** Filter by the object’s `queryParams` field. */
  queryParams?: InputMaybe<StringFilter>;
  /** Filter by the object’s `uid` field. */
  uid?: InputMaybe<StringFilter>;
  /** Filter by the object’s `userAgent` field. */
  userAgent?: InputMaybe<StringFilter>;
  /** Filter by the object’s `viewedAt` field. */
  viewedAt?: InputMaybe<DatetimeFilter>;
};

/** A connection to a list of `FmaView` values. */
export type FmaViewsConnection = {
  __typename?: 'FmaViewsConnection';
  /** A list of edges which contains the `FmaView` and cursor to aid in pagination. */
  edges: Array<FmaViewsEdge>;
  /** A list of `FmaView` objects. */
  nodes: Array<FmaView>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `FmaView` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `FmaView` edge in the connection. */
export type FmaViewsEdge = {
  __typename?: 'FmaViewsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `FmaView` at the end of the edge. */
  node: FmaView;
};

/** Methods to use when ordering `FmaView`. */
export enum FmaViewsOrderBy {
  AjsAnonymousIdAsc = 'AJS_ANONYMOUS_ID_ASC',
  AjsAnonymousIdDesc = 'AJS_ANONYMOUS_ID_DESC',
  FmaCreativeIdAsc = 'FMA_CREATIVE_ID_ASC',
  FmaCreativeIdDesc = 'FMA_CREATIVE_ID_DESC',
  IpAddressAsc = 'IP_ADDRESS_ASC',
  IpAddressDesc = 'IP_ADDRESS_DESC',
  Natural = 'NATURAL',
  NpiAsc = 'NPI_ASC',
  NpiDesc = 'NPI_DESC',
  QueryParamsAsc = 'QUERY_PARAMS_ASC',
  QueryParamsDesc = 'QUERY_PARAMS_DESC',
  UidAsc = 'UID_ASC',
  UidDesc = 'UID_DESC',
  UserAgentAsc = 'USER_AGENT_ASC',
  UserAgentDesc = 'USER_AGENT_DESC',
  ViewedAtAsc = 'VIEWED_AT_ASC',
  ViewedAtDesc = 'VIEWED_AT_DESC'
}

/** A filter to be used against Int fields. All fields are combined with a logical ‘and.’ */
export type IntFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Scalars['Int']>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Scalars['Int']>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Scalars['Int']>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Scalars['Int']>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<Scalars['Int']>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Scalars['Int']>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Scalars['Int']>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Scalars['Int']>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Scalars['Int']>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Scalars['Int']>>;
};

/** A filter to be used against JSON fields. All fields are combined with a logical ‘and.’ */
export type JsonFilter = {
  /** Contained by the specified JSON. */
  containedBy?: InputMaybe<Scalars['JSON']>;
  /** Contains the specified JSON. */
  contains?: InputMaybe<Scalars['JSON']>;
  /** Contains all of the specified keys. */
  containsAllKeys?: InputMaybe<Array<Scalars['String']>>;
  /** Contains any of the specified keys. */
  containsAnyKeys?: InputMaybe<Array<Scalars['String']>>;
  /** Contains the specified key. */
  containsKey?: InputMaybe<Scalars['String']>;
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Scalars['JSON']>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Scalars['JSON']>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Scalars['JSON']>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Scalars['JSON']>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<Scalars['JSON']>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Scalars['JSON']>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Scalars['JSON']>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Scalars['JSON']>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Scalars['JSON']>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Scalars['JSON']>>;
};

/** Table for storing unique labels to implement the Competitive Separation feature. */
export type Label = {
  __typename?: 'Label';
  /** Reads and enables pagination through a set of `CampaignLabel`. */
  campaignLabels: CampaignLabelsConnection;
  createdAt: Scalars['Datetime'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  isArchived: Scalars['Boolean'];
  /** Reads and enables pagination through a set of `LineItemLabel`. */
  lineItemLabels: LineItemLabelsConnection;
  name: Scalars['String'];
  updatedAt: Scalars['Datetime'];
  updatedBy?: Maybe<Scalars['String']>;
};


/** Table for storing unique labels to implement the Competitive Separation feature. */
export type LabelCampaignLabelsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<CampaignLabelCondition>;
  filter?: InputMaybe<CampaignLabelFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CampaignLabelsOrderBy>>;
};


/** Table for storing unique labels to implement the Competitive Separation feature. */
export type LabelLineItemLabelsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<LineItemLabelCondition>;
  filter?: InputMaybe<LineItemLabelFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LineItemLabelsOrderBy>>;
};

/** A condition to be used against `Label` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type LabelCondition = {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `description` field. */
  description?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `isArchived` field. */
  isArchived?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `updatedBy` field. */
  updatedBy?: InputMaybe<Scalars['String']>;
};

/** A filter to be used against `Label` object types. All fields are combined with a logical ‘and.’ */
export type LabelFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<LabelFilter>>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `description` field. */
  description?: InputMaybe<StringFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `isArchived` field. */
  isArchived?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<LabelFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<LabelFilter>>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `updatedBy` field. */
  updatedBy?: InputMaybe<StringFilter>;
};

/** An input for mutations affecting `Label` */
export type LabelInput = {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  isArchived?: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  updatedBy?: InputMaybe<Scalars['String']>;
};

/** Represents an update to a `Label`. Fields that are set will be updated. */
export type LabelPatch = {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  isArchived?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  updatedBy?: InputMaybe<Scalars['String']>;
};

/** A connection to a list of `Label` values. */
export type LabelsConnection = {
  __typename?: 'LabelsConnection';
  /** A list of edges which contains the `Label` and cursor to aid in pagination. */
  edges: Array<LabelsEdge>;
  /** A list of `Label` objects. */
  nodes: Array<Label>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Label` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Label` edge in the connection. */
export type LabelsEdge = {
  __typename?: 'LabelsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `Label` at the end of the edge. */
  node: Label;
};

/** Methods to use when ordering `Label`. */
export enum LabelsOrderBy {
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  DescriptionAsc = 'DESCRIPTION_ASC',
  DescriptionDesc = 'DESCRIPTION_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  IsArchivedAsc = 'IS_ARCHIVED_ASC',
  IsArchivedDesc = 'IS_ARCHIVED_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC',
  UpdatedByAsc = 'UPDATED_BY_ASC',
  UpdatedByDesc = 'UPDATED_BY_DESC'
}

/** Lead generation campaigns for internal NPI targeting (not associated with placements) */
export type LeadGenCampaign = {
  __typename?: 'LeadGenCampaign';
  createdAt?: Maybe<Scalars['Datetime']>;
  createdBy?: Maybe<Scalars['String']>;
  endsAt: Scalars['Datetime'];
  id: Scalars['Int'];
  /** Whether the campaign is approved and can be shown to users */
  isApproved?: Maybe<Scalars['Boolean']>;
  isEligible?: Maybe<Scalars['Boolean']>;
  /** Reads and enables pagination through a set of `LeadGenView`. */
  leadGenViews: LeadGenViewsConnection;
  maxViewsPerNpi?: Maybe<Scalars['Int']>;
  maxViewsPerSession?: Maybe<Scalars['Int']>;
  name: Scalars['String'];
  priority?: Maybe<Scalars['Int']>;
  startsAt: Scalars['Datetime'];
  stats?: Maybe<LeadGenCampaignStat>;
  targetListIdsList?: Maybe<Array<Maybe<Scalars['Int']>>>;
  /** Reads and enables pagination through a set of `TargetList`. */
  targetListsList?: Maybe<Array<TargetList>>;
  updatedAt?: Maybe<Scalars['Datetime']>;
  updatedBy?: Maybe<Scalars['String']>;
};


/** Lead generation campaigns for internal NPI targeting (not associated with placements) */
export type LeadGenCampaignIsEligibleArgs = {
  npi?: InputMaybe<Scalars['BigInt']>;
};


/** Lead generation campaigns for internal NPI targeting (not associated with placements) */
export type LeadGenCampaignLeadGenViewsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<LeadGenViewCondition>;
  filter?: InputMaybe<LeadGenViewFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LeadGenViewsOrderBy>>;
};


/** Lead generation campaigns for internal NPI targeting (not associated with placements) */
export type LeadGenCampaignTargetListIdsListArgs = {
  filter?: InputMaybe<IntFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


/** Lead generation campaigns for internal NPI targeting (not associated with placements) */
export type LeadGenCampaignTargetListsListArgs = {
  filter?: InputMaybe<TargetListFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

/**
 * A condition to be used against `LeadGenCampaign` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type LeadGenCampaignCondition = {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `createdBy` field. */
  createdBy?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `endsAt` field. */
  endsAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `isApproved` field. */
  isApproved?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `maxViewsPerNpi` field. */
  maxViewsPerNpi?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `maxViewsPerSession` field. */
  maxViewsPerSession?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `priority` field. */
  priority?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `startsAt` field. */
  startsAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `updatedBy` field. */
  updatedBy?: InputMaybe<Scalars['String']>;
};

/** A filter to be used against `LeadGenCampaign` object types. All fields are combined with a logical ‘and.’ */
export type LeadGenCampaignFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<LeadGenCampaignFilter>>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `createdBy` field. */
  createdBy?: InputMaybe<StringFilter>;
  /** Filter by the object’s `endsAt` field. */
  endsAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `isApproved` field. */
  isApproved?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `maxViewsPerNpi` field. */
  maxViewsPerNpi?: InputMaybe<IntFilter>;
  /** Filter by the object’s `maxViewsPerSession` field. */
  maxViewsPerSession?: InputMaybe<IntFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<LeadGenCampaignFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<LeadGenCampaignFilter>>;
  /** Filter by the object’s `priority` field. */
  priority?: InputMaybe<IntFilter>;
  /** Filter by the object’s `startsAt` field. */
  startsAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `updatedBy` field. */
  updatedBy?: InputMaybe<StringFilter>;
};

/** An input for mutations affecting `LeadGenCampaign` */
export type LeadGenCampaignInput = {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  createdBy?: InputMaybe<Scalars['String']>;
  endsAt: Scalars['Datetime'];
  id?: InputMaybe<Scalars['Int']>;
  /** Whether the campaign is approved and can be shown to users */
  isApproved?: InputMaybe<Scalars['Boolean']>;
  maxViewsPerNpi?: InputMaybe<Scalars['Int']>;
  maxViewsPerSession?: InputMaybe<Scalars['Int']>;
  name: Scalars['String'];
  priority?: InputMaybe<Scalars['Int']>;
  startsAt: Scalars['Datetime'];
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  updatedBy?: InputMaybe<Scalars['String']>;
};

/** Represents an update to a `LeadGenCampaign`. Fields that are set will be updated. */
export type LeadGenCampaignPatch = {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  createdBy?: InputMaybe<Scalars['String']>;
  endsAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['Int']>;
  /** Whether the campaign is approved and can be shown to users */
  isApproved?: InputMaybe<Scalars['Boolean']>;
  maxViewsPerNpi?: InputMaybe<Scalars['Int']>;
  maxViewsPerSession?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  priority?: InputMaybe<Scalars['Int']>;
  startsAt?: InputMaybe<Scalars['Datetime']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  updatedBy?: InputMaybe<Scalars['String']>;
};

export type LeadGenCampaignStat = {
  __typename?: 'LeadGenCampaignStat';
  campaignId?: Maybe<Scalars['Int']>;
  campaignName?: Maybe<Scalars['String']>;
  conversionRate?: Maybe<Scalars['BigFloat']>;
  conversions?: Maybe<Scalars['BigInt']>;
  firstView?: Maybe<Scalars['Datetime']>;
  lastView?: Maybe<Scalars['Datetime']>;
  totalViews?: Maybe<Scalars['BigInt']>;
  uniqueBrowserInstances?: Maybe<Scalars['BigInt']>;
  uniqueViewers?: Maybe<Scalars['BigInt']>;
};

/**
 * A condition to be used against `LeadGenCampaignStat` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type LeadGenCampaignStatCondition = {
  /** Checks for equality with the object’s `campaignId` field. */
  campaignId?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `campaignName` field. */
  campaignName?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `conversionRate` field. */
  conversionRate?: InputMaybe<Scalars['BigFloat']>;
  /** Checks for equality with the object’s `conversions` field. */
  conversions?: InputMaybe<Scalars['BigInt']>;
  /** Checks for equality with the object’s `firstView` field. */
  firstView?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `lastView` field. */
  lastView?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `totalViews` field. */
  totalViews?: InputMaybe<Scalars['BigInt']>;
  /** Checks for equality with the object’s `uniqueBrowserInstances` field. */
  uniqueBrowserInstances?: InputMaybe<Scalars['BigInt']>;
  /** Checks for equality with the object’s `uniqueViewers` field. */
  uniqueViewers?: InputMaybe<Scalars['BigInt']>;
};

/** A filter to be used against `LeadGenCampaignStat` object types. All fields are combined with a logical ‘and.’ */
export type LeadGenCampaignStatFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<LeadGenCampaignStatFilter>>;
  /** Filter by the object’s `campaignId` field. */
  campaignId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `campaignName` field. */
  campaignName?: InputMaybe<StringFilter>;
  /** Filter by the object’s `conversionRate` field. */
  conversionRate?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `conversions` field. */
  conversions?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `firstView` field. */
  firstView?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `lastView` field. */
  lastView?: InputMaybe<DatetimeFilter>;
  /** Negates the expression. */
  not?: InputMaybe<LeadGenCampaignStatFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<LeadGenCampaignStatFilter>>;
  /** Filter by the object’s `totalViews` field. */
  totalViews?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `uniqueBrowserInstances` field. */
  uniqueBrowserInstances?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `uniqueViewers` field. */
  uniqueViewers?: InputMaybe<BigIntFilter>;
};

/** A connection to a list of `LeadGenCampaignStat` values. */
export type LeadGenCampaignStatsConnection = {
  __typename?: 'LeadGenCampaignStatsConnection';
  /** A list of edges which contains the `LeadGenCampaignStat` and cursor to aid in pagination. */
  edges: Array<LeadGenCampaignStatsEdge>;
  /** A list of `LeadGenCampaignStat` objects. */
  nodes: Array<LeadGenCampaignStat>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `LeadGenCampaignStat` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `LeadGenCampaignStat` edge in the connection. */
export type LeadGenCampaignStatsEdge = {
  __typename?: 'LeadGenCampaignStatsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `LeadGenCampaignStat` at the end of the edge. */
  node: LeadGenCampaignStat;
};

/** Methods to use when ordering `LeadGenCampaignStat`. */
export enum LeadGenCampaignStatsOrderBy {
  CampaignIdAsc = 'CAMPAIGN_ID_ASC',
  CampaignIdDesc = 'CAMPAIGN_ID_DESC',
  CampaignNameAsc = 'CAMPAIGN_NAME_ASC',
  CampaignNameDesc = 'CAMPAIGN_NAME_DESC',
  ConversionsAsc = 'CONVERSIONS_ASC',
  ConversionsDesc = 'CONVERSIONS_DESC',
  ConversionRateAsc = 'CONVERSION_RATE_ASC',
  ConversionRateDesc = 'CONVERSION_RATE_DESC',
  FirstViewAsc = 'FIRST_VIEW_ASC',
  FirstViewDesc = 'FIRST_VIEW_DESC',
  LastViewAsc = 'LAST_VIEW_ASC',
  LastViewDesc = 'LAST_VIEW_DESC',
  Natural = 'NATURAL',
  TotalViewsAsc = 'TOTAL_VIEWS_ASC',
  TotalViewsDesc = 'TOTAL_VIEWS_DESC',
  UniqueBrowserInstancesAsc = 'UNIQUE_BROWSER_INSTANCES_ASC',
  UniqueBrowserInstancesDesc = 'UNIQUE_BROWSER_INSTANCES_DESC',
  UniqueViewersAsc = 'UNIQUE_VIEWERS_ASC',
  UniqueViewersDesc = 'UNIQUE_VIEWERS_DESC'
}

/** A connection to a list of `LeadGenCampaign` values. */
export type LeadGenCampaignsConnection = {
  __typename?: 'LeadGenCampaignsConnection';
  /** A list of edges which contains the `LeadGenCampaign` and cursor to aid in pagination. */
  edges: Array<LeadGenCampaignsEdge>;
  /** A list of `LeadGenCampaign` objects. */
  nodes: Array<LeadGenCampaign>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `LeadGenCampaign` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `LeadGenCampaign` edge in the connection. */
export type LeadGenCampaignsEdge = {
  __typename?: 'LeadGenCampaignsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `LeadGenCampaign` at the end of the edge. */
  node: LeadGenCampaign;
};

/** Methods to use when ordering `LeadGenCampaign`. */
export enum LeadGenCampaignsOrderBy {
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  CreatedByAsc = 'CREATED_BY_ASC',
  CreatedByDesc = 'CREATED_BY_DESC',
  EndsAtAsc = 'ENDS_AT_ASC',
  EndsAtDesc = 'ENDS_AT_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  IsApprovedAsc = 'IS_APPROVED_ASC',
  IsApprovedDesc = 'IS_APPROVED_DESC',
  MaxViewsPerNpiAsc = 'MAX_VIEWS_PER_NPI_ASC',
  MaxViewsPerNpiDesc = 'MAX_VIEWS_PER_NPI_DESC',
  MaxViewsPerSessionAsc = 'MAX_VIEWS_PER_SESSION_ASC',
  MaxViewsPerSessionDesc = 'MAX_VIEWS_PER_SESSION_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  PriorityAsc = 'PRIORITY_ASC',
  PriorityDesc = 'PRIORITY_DESC',
  StartsAtAsc = 'STARTS_AT_ASC',
  StartsAtDesc = 'STARTS_AT_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC',
  UpdatedByAsc = 'UPDATED_BY_ASC',
  UpdatedByDesc = 'UPDATED_BY_DESC'
}

/** Tracks individual views and conversions for lead gen campaigns */
export type LeadGenView = {
  __typename?: 'LeadGenView';
  ajsAnonymousId?: Maybe<Scalars['String']>;
  browserInstanceId: Scalars['String'];
  converted?: Maybe<Scalars['Boolean']>;
  convertedAt?: Maybe<Scalars['Datetime']>;
  id: Scalars['Int'];
  /** Reads a single `LeadGenCampaign` that is related to this `LeadGenView`. */
  leadGenCampaign?: Maybe<LeadGenCampaign>;
  leadGenCampaignId: Scalars['Int'];
  npi: Scalars['BigInt'];
  referrer?: Maybe<Scalars['String']>;
  uid?: Maybe<Scalars['String']>;
  userAgent?: Maybe<Scalars['String']>;
  viewedAt?: Maybe<Scalars['Datetime']>;
};

/**
 * A condition to be used against `LeadGenView` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type LeadGenViewCondition = {
  /** Checks for equality with the object’s `ajsAnonymousId` field. */
  ajsAnonymousId?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `browserInstanceId` field. */
  browserInstanceId?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `converted` field. */
  converted?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `convertedAt` field. */
  convertedAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `leadGenCampaignId` field. */
  leadGenCampaignId?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `npi` field. */
  npi?: InputMaybe<Scalars['BigInt']>;
  /** Checks for equality with the object’s `referrer` field. */
  referrer?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `uid` field. */
  uid?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `userAgent` field. */
  userAgent?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `viewedAt` field. */
  viewedAt?: InputMaybe<Scalars['Datetime']>;
};

/** A filter to be used against `LeadGenView` object types. All fields are combined with a logical ‘and.’ */
export type LeadGenViewFilter = {
  /** Filter by the object’s `ajsAnonymousId` field. */
  ajsAnonymousId?: InputMaybe<StringFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<LeadGenViewFilter>>;
  /** Filter by the object’s `browserInstanceId` field. */
  browserInstanceId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `converted` field. */
  converted?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `convertedAt` field. */
  convertedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `leadGenCampaignId` field. */
  leadGenCampaignId?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<LeadGenViewFilter>;
  /** Filter by the object’s `npi` field. */
  npi?: InputMaybe<BigIntFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<LeadGenViewFilter>>;
  /** Filter by the object’s `referrer` field. */
  referrer?: InputMaybe<StringFilter>;
  /** Filter by the object’s `uid` field. */
  uid?: InputMaybe<StringFilter>;
  /** Filter by the object’s `userAgent` field. */
  userAgent?: InputMaybe<StringFilter>;
  /** Filter by the object’s `viewedAt` field. */
  viewedAt?: InputMaybe<DatetimeFilter>;
};

/** An input for mutations affecting `LeadGenView` */
export type LeadGenViewInput = {
  ajsAnonymousId?: InputMaybe<Scalars['String']>;
  browserInstanceId: Scalars['String'];
  converted?: InputMaybe<Scalars['Boolean']>;
  convertedAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['Int']>;
  leadGenCampaignId: Scalars['Int'];
  npi: Scalars['BigInt'];
  referrer?: InputMaybe<Scalars['String']>;
  uid?: InputMaybe<Scalars['String']>;
  userAgent?: InputMaybe<Scalars['String']>;
  viewedAt?: InputMaybe<Scalars['Datetime']>;
};

/** Represents an update to a `LeadGenView`. Fields that are set will be updated. */
export type LeadGenViewPatch = {
  ajsAnonymousId?: InputMaybe<Scalars['String']>;
  browserInstanceId?: InputMaybe<Scalars['String']>;
  converted?: InputMaybe<Scalars['Boolean']>;
  convertedAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['Int']>;
  leadGenCampaignId?: InputMaybe<Scalars['Int']>;
  npi?: InputMaybe<Scalars['BigInt']>;
  referrer?: InputMaybe<Scalars['String']>;
  uid?: InputMaybe<Scalars['String']>;
  userAgent?: InputMaybe<Scalars['String']>;
  viewedAt?: InputMaybe<Scalars['Datetime']>;
};

/** A connection to a list of `LeadGenView` values. */
export type LeadGenViewsConnection = {
  __typename?: 'LeadGenViewsConnection';
  /** A list of edges which contains the `LeadGenView` and cursor to aid in pagination. */
  edges: Array<LeadGenViewsEdge>;
  /** A list of `LeadGenView` objects. */
  nodes: Array<LeadGenView>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `LeadGenView` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `LeadGenView` edge in the connection. */
export type LeadGenViewsEdge = {
  __typename?: 'LeadGenViewsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `LeadGenView` at the end of the edge. */
  node: LeadGenView;
};

/** Methods to use when ordering `LeadGenView`. */
export enum LeadGenViewsOrderBy {
  AjsAnonymousIdAsc = 'AJS_ANONYMOUS_ID_ASC',
  AjsAnonymousIdDesc = 'AJS_ANONYMOUS_ID_DESC',
  BrowserInstanceIdAsc = 'BROWSER_INSTANCE_ID_ASC',
  BrowserInstanceIdDesc = 'BROWSER_INSTANCE_ID_DESC',
  ConvertedAsc = 'CONVERTED_ASC',
  ConvertedAtAsc = 'CONVERTED_AT_ASC',
  ConvertedAtDesc = 'CONVERTED_AT_DESC',
  ConvertedDesc = 'CONVERTED_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  LeadGenCampaignIdAsc = 'LEAD_GEN_CAMPAIGN_ID_ASC',
  LeadGenCampaignIdDesc = 'LEAD_GEN_CAMPAIGN_ID_DESC',
  Natural = 'NATURAL',
  NpiAsc = 'NPI_ASC',
  NpiDesc = 'NPI_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  ReferrerAsc = 'REFERRER_ASC',
  ReferrerDesc = 'REFERRER_DESC',
  UidAsc = 'UID_ASC',
  UidDesc = 'UID_DESC',
  UserAgentAsc = 'USER_AGENT_ASC',
  UserAgentDesc = 'USER_AGENT_DESC',
  ViewedAtAsc = 'VIEWED_AT_ASC',
  ViewedAtDesc = 'VIEWED_AT_DESC'
}

/** PIO line item records with preserved line item numbers and retained in-use custom fields. */
export type LineItem = {
  __typename?: 'LineItem';
  adServer?: Maybe<Scalars['String']>;
  adServerId?: Maybe<Scalars['String']>;
  /** Advertiser ID inherited from the line item campaign for CSAdmin list filtering. */
  advertiserId?: Maybe<Scalars['UUID']>;
  archivedAt?: Maybe<Scalars['Datetime']>;
  /** Reads and enables pagination through a set of `BannerTargeting`. */
  bannerTargetings: BannerTargetingsConnection;
  /** Reads a single `Campaign` that is related to this `LineItem`. */
  campaign?: Maybe<Campaign>;
  campaignId: Scalars['UUID'];
  /** Reads and enables pagination through a set of `ClicksCreative`. */
  clicksCreatives: ClicksCreativesConnection;
  /** Contracted quantity imported from PIO Sponsorship Quantity custom field for sponsorship lines, otherwise native PIO contracted-units. */
  contractedUnits?: Maybe<Scalars['BigFloat']>;
  /** Reads a single `LineItem` that is related to this `LineItem`. */
  copiedFromLineItem?: Maybe<LineItem>;
  /** Optional lineage pointer used by the duplicate line item workflow. */
  copiedFromLineItemId?: Maybe<Scalars['UUID']>;
  costBasis?: Maybe<Scalars['String']>;
  costPerUnit?: Maybe<Scalars['BigFloat']>;
  createdAt: Scalars['Datetime'];
  currencyCode?: Maybe<Scalars['String']>;
  deliveryRateType?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  endDate?: Maybe<Scalars['Date']>;
  externalPioId?: Maybe<Scalars['String']>;
  /** Reads and enables pagination through a set of `FmaCreative`. */
  fmaCreatives: FmaCreativesConnection;
  /** Google Ad Manager line item ID populated by the later GAM shell workflow. */
  gamLineItemId?: Maybe<Scalars['String']>;
  goal?: Maybe<Scalars['BigFloat']>;
  goalType?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  invoiceAmount?: Maybe<Scalars['BigFloat']>;
  /** Normalized invoice status such as in_progress or ready_for_finance; unknown PIO values remain representable as text. */
  invoiceStatus?: Maybe<Scalars['String']>;
  invoiceUnits?: Maybe<Scalars['BigFloat']>;
  itemType?: Maybe<Scalars['String']>;
  /** Reads and enables pagination through a set of `LineItemDelivery`. */
  lineItemDeliveries: LineItemDeliveriesConnection;
  /** Reads and enables pagination through a set of `LineItemLabel`. */
  lineItemLabels: LineItemLabelsConnection;
  /** PIO line item number preserved during import; unique within each campaign because PIO line-item numbers are campaign-scoped. */
  lineItemNumber: Scalars['Int'];
  /** Reads and enables pagination through a set of `LineItem`. */
  lineItemsByCopiedFromLineItemId: LineItemsConnection;
  name?: Maybe<Scalars['String']>;
  /** Reads a single `PioUser` that is related to this `LineItem`. */
  pioUserByReviewedBy?: Maybe<PioUser>;
  priority?: Maybe<Scalars['String']>;
  /** Reads a single `Product` that is related to this `LineItem`. */
  product?: Maybe<Product>;
  productId?: Maybe<Scalars['UUID']>;
  revenue?: Maybe<Scalars['BigFloat']>;
  revenueUnits?: Maybe<Scalars['BigFloat']>;
  /** Nullable reviewer FK replacing the old PIO approval workflow; NULL means self-reviewed. */
  reviewedBy?: Maybe<Scalars['UUID']>;
  specialty?: Maybe<Scalars['String']>;
  /** Reads and enables pagination through a set of `SponsoredContentTeaser`. */
  sponsoredContentTeasers: SponsoredContentTeasersConnection;
  startDate?: Maybe<Scalars['Date']>;
  status?: Maybe<Scalars['String']>;
  /** Targeting metadata imported from PIO and retained as JSON until targeting editing is in scope. */
  targeting?: Maybe<Scalars['JSON']>;
  updatedAt: Scalars['Datetime'];
};


/** PIO line item records with preserved line item numbers and retained in-use custom fields. */
export type LineItemBannerTargetingsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<BannerTargetingCondition>;
  filter?: InputMaybe<BannerTargetingFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<BannerTargetingsOrderBy>>;
};


/** PIO line item records with preserved line item numbers and retained in-use custom fields. */
export type LineItemClicksCreativesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ClicksCreativeCondition>;
  filter?: InputMaybe<ClicksCreativeFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ClicksCreativesOrderBy>>;
};


/** PIO line item records with preserved line item numbers and retained in-use custom fields. */
export type LineItemFmaCreativesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<FmaCreativeCondition>;
  filter?: InputMaybe<FmaCreativeFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<FmaCreativesOrderBy>>;
};


/** PIO line item records with preserved line item numbers and retained in-use custom fields. */
export type LineItemLineItemDeliveriesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<LineItemDeliveryCondition>;
  filter?: InputMaybe<LineItemDeliveryFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LineItemDeliveriesOrderBy>>;
};


/** PIO line item records with preserved line item numbers and retained in-use custom fields. */
export type LineItemLineItemLabelsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<LineItemLabelCondition>;
  filter?: InputMaybe<LineItemLabelFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LineItemLabelsOrderBy>>;
};


/** PIO line item records with preserved line item numbers and retained in-use custom fields. */
export type LineItemLineItemsByCopiedFromLineItemIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<LineItemCondition>;
  filter?: InputMaybe<LineItemFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LineItemsOrderBy>>;
};


/** PIO line item records with preserved line item numbers and retained in-use custom fields. */
export type LineItemSponsoredContentTeasersArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<SponsoredContentTeaserCondition>;
  filter?: InputMaybe<SponsoredContentTeaserFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<SponsoredContentTeasersOrderBy>>;
};

/**
 * A condition to be used against `LineItem` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type LineItemCondition = {
  /** Checks for equality with the object’s `adServer` field. */
  adServer?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `adServerId` field. */
  adServerId?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `advertiserId` field. */
  advertiserId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `archivedAt` field. */
  archivedAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `campaignId` field. */
  campaignId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `contractedUnits` field. */
  contractedUnits?: InputMaybe<Scalars['BigFloat']>;
  /** Checks for equality with the object’s `copiedFromLineItemId` field. */
  copiedFromLineItemId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `costBasis` field. */
  costBasis?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `costPerUnit` field. */
  costPerUnit?: InputMaybe<Scalars['BigFloat']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `currencyCode` field. */
  currencyCode?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `deliveryRateType` field. */
  deliveryRateType?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `description` field. */
  description?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `endDate` field. */
  endDate?: InputMaybe<Scalars['Date']>;
  /** Checks for equality with the object’s `externalPioId` field. */
  externalPioId?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `gamLineItemId` field. */
  gamLineItemId?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `goal` field. */
  goal?: InputMaybe<Scalars['BigFloat']>;
  /** Checks for equality with the object’s `goalType` field. */
  goalType?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `invoiceAmount` field. */
  invoiceAmount?: InputMaybe<Scalars['BigFloat']>;
  /** Checks for equality with the object’s `invoiceStatus` field. */
  invoiceStatus?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `invoiceUnits` field. */
  invoiceUnits?: InputMaybe<Scalars['BigFloat']>;
  /** Checks for equality with the object’s `itemType` field. */
  itemType?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `lineItemNumber` field. */
  lineItemNumber?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `priority` field. */
  priority?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `productId` field. */
  productId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `revenue` field. */
  revenue?: InputMaybe<Scalars['BigFloat']>;
  /** Checks for equality with the object’s `revenueUnits` field. */
  revenueUnits?: InputMaybe<Scalars['BigFloat']>;
  /** Checks for equality with the object’s `reviewedBy` field. */
  reviewedBy?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `specialty` field. */
  specialty?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `startDate` field. */
  startDate?: InputMaybe<Scalars['Date']>;
  /** Checks for equality with the object’s `status` field. */
  status?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `targeting` field. */
  targeting?: InputMaybe<Scalars['JSON']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** A connection to a list of `LineItemDelivery` values. */
export type LineItemDeliveriesConnection = {
  __typename?: 'LineItemDeliveriesConnection';
  /** A list of edges which contains the `LineItemDelivery` and cursor to aid in pagination. */
  edges: Array<LineItemDeliveriesEdge>;
  /** A list of `LineItemDelivery` objects. */
  nodes: Array<LineItemDelivery>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `LineItemDelivery` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `LineItemDelivery` edge in the connection. */
export type LineItemDeliveriesEdge = {
  __typename?: 'LineItemDeliveriesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `LineItemDelivery` at the end of the edge. */
  node: LineItemDelivery;
};

/** Methods to use when ordering `LineItemDelivery`. */
export enum LineItemDeliveriesOrderBy {
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  LineItemIdAsc = 'LINE_ITEM_ID_ASC',
  LineItemIdDesc = 'LINE_ITEM_ID_DESC',
  Natural = 'NATURAL',
  NotesAsc = 'NOTES_ASC',
  NotesDesc = 'NOTES_DESC',
  PeriodEndAsc = 'PERIOD_END_ASC',
  PeriodEndDesc = 'PERIOD_END_DESC',
  PeriodStartAsc = 'PERIOD_START_ASC',
  PeriodStartDesc = 'PERIOD_START_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  ReportedAtAsc = 'REPORTED_AT_ASC',
  ReportedAtDesc = 'REPORTED_AT_DESC',
  ReportedByAsc = 'REPORTED_BY_ASC',
  ReportedByDesc = 'REPORTED_BY_DESC',
  RevenueAsc = 'REVENUE_ASC',
  RevenueDesc = 'REVENUE_DESC',
  SourceAsc = 'SOURCE_ASC',
  SourceDesc = 'SOURCE_DESC',
  UnitsAsc = 'UNITS_ASC',
  UnitsDesc = 'UNITS_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC'
}

/** Monthly delivery values per line item from client DCM CSV, GAM, or manual entry. */
export type LineItemDelivery = {
  __typename?: 'LineItemDelivery';
  createdAt: Scalars['Datetime'];
  id: Scalars['UUID'];
  /** Reads a single `LineItem` that is related to this `LineItemDelivery`. */
  lineItem?: Maybe<LineItem>;
  lineItemId: Scalars['UUID'];
  notes?: Maybe<Scalars['String']>;
  periodEnd: Scalars['Date'];
  periodStart: Scalars['Date'];
  /** Reads a single `PioUser` that is related to this `LineItemDelivery`. */
  pioUserByReportedBy?: Maybe<PioUser>;
  reportedAt: Scalars['Datetime'];
  /** Optional CSAdmin user who manually reported or imported the delivery value. */
  reportedBy?: Maybe<Scalars['UUID']>;
  revenue?: Maybe<Scalars['BigFloat']>;
  /** Source of the reported monthly delivery numbers: client_dcm, gam, or manual. */
  source: LineItemDeliverySource;
  units?: Maybe<Scalars['BigFloat']>;
  updatedAt: Scalars['Datetime'];
};

/**
 * A condition to be used against `LineItemDelivery` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type LineItemDeliveryCondition = {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `lineItemId` field. */
  lineItemId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `notes` field. */
  notes?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `periodEnd` field. */
  periodEnd?: InputMaybe<Scalars['Date']>;
  /** Checks for equality with the object’s `periodStart` field. */
  periodStart?: InputMaybe<Scalars['Date']>;
  /** Checks for equality with the object’s `reportedAt` field. */
  reportedAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `reportedBy` field. */
  reportedBy?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `revenue` field. */
  revenue?: InputMaybe<Scalars['BigFloat']>;
  /** Checks for equality with the object’s `source` field. */
  source?: InputMaybe<LineItemDeliverySource>;
  /** Checks for equality with the object’s `units` field. */
  units?: InputMaybe<Scalars['BigFloat']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** A filter to be used against `LineItemDelivery` object types. All fields are combined with a logical ‘and.’ */
export type LineItemDeliveryFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<LineItemDeliveryFilter>>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `lineItemId` field. */
  lineItemId?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<LineItemDeliveryFilter>;
  /** Filter by the object’s `notes` field. */
  notes?: InputMaybe<StringFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<LineItemDeliveryFilter>>;
  /** Filter by the object’s `periodEnd` field. */
  periodEnd?: InputMaybe<DateFilter>;
  /** Filter by the object’s `periodStart` field. */
  periodStart?: InputMaybe<DateFilter>;
  /** Filter by the object’s `reportedAt` field. */
  reportedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `reportedBy` field. */
  reportedBy?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `revenue` field. */
  revenue?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `source` field. */
  source?: InputMaybe<LineItemDeliverySourceFilter>;
  /** Filter by the object’s `units` field. */
  units?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
};

/** An input for mutations affecting `LineItemDelivery` */
export type LineItemDeliveryInput = {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  lineItemId: Scalars['UUID'];
  notes?: InputMaybe<Scalars['String']>;
  periodEnd: Scalars['Date'];
  periodStart: Scalars['Date'];
  reportedAt?: InputMaybe<Scalars['Datetime']>;
  /** Optional CSAdmin user who manually reported or imported the delivery value. */
  reportedBy?: InputMaybe<Scalars['UUID']>;
  revenue?: InputMaybe<Scalars['BigFloat']>;
  /** Source of the reported monthly delivery numbers: client_dcm, gam, or manual. */
  source: LineItemDeliverySource;
  units?: InputMaybe<Scalars['BigFloat']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** Represents an update to a `LineItemDelivery`. Fields that are set will be updated. */
export type LineItemDeliveryPatch = {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  lineItemId?: InputMaybe<Scalars['UUID']>;
  notes?: InputMaybe<Scalars['String']>;
  periodEnd?: InputMaybe<Scalars['Date']>;
  periodStart?: InputMaybe<Scalars['Date']>;
  reportedAt?: InputMaybe<Scalars['Datetime']>;
  /** Optional CSAdmin user who manually reported or imported the delivery value. */
  reportedBy?: InputMaybe<Scalars['UUID']>;
  revenue?: InputMaybe<Scalars['BigFloat']>;
  /** Source of the reported monthly delivery numbers: client_dcm, gam, or manual. */
  source?: InputMaybe<LineItemDeliverySource>;
  units?: InputMaybe<Scalars['BigFloat']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

export enum LineItemDeliverySource {
  ClientDcm = 'CLIENT_DCM',
  Gam = 'GAM',
  Manual = 'MANUAL'
}

/** A filter to be used against LineItemDeliverySource fields. All fields are combined with a logical ‘and.’ */
export type LineItemDeliverySourceFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<LineItemDeliverySource>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<LineItemDeliverySource>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<LineItemDeliverySource>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<LineItemDeliverySource>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<LineItemDeliverySource>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<LineItemDeliverySource>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<LineItemDeliverySource>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<LineItemDeliverySource>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<LineItemDeliverySource>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<LineItemDeliverySource>>;
};

/** A filter to be used against `LineItem` object types. All fields are combined with a logical ‘and.’ */
export type LineItemFilter = {
  /** Filter by the object’s `adServer` field. */
  adServer?: InputMaybe<StringFilter>;
  /** Filter by the object’s `adServerId` field. */
  adServerId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `advertiserId` field. */
  advertiserId?: InputMaybe<UuidFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<LineItemFilter>>;
  /** Filter by the object’s `archivedAt` field. */
  archivedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `campaignId` field. */
  campaignId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `contractedUnits` field. */
  contractedUnits?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `copiedFromLineItemId` field. */
  copiedFromLineItemId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `costBasis` field. */
  costBasis?: InputMaybe<StringFilter>;
  /** Filter by the object’s `costPerUnit` field. */
  costPerUnit?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `currencyCode` field. */
  currencyCode?: InputMaybe<StringFilter>;
  /** Filter by the object’s `deliveryRateType` field. */
  deliveryRateType?: InputMaybe<StringFilter>;
  /** Filter by the object’s `description` field. */
  description?: InputMaybe<StringFilter>;
  /** Filter by the object’s `endDate` field. */
  endDate?: InputMaybe<DateFilter>;
  /** Filter by the object’s `externalPioId` field. */
  externalPioId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `gamLineItemId` field. */
  gamLineItemId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `goal` field. */
  goal?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `goalType` field. */
  goalType?: InputMaybe<StringFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `invoiceAmount` field. */
  invoiceAmount?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `invoiceStatus` field. */
  invoiceStatus?: InputMaybe<StringFilter>;
  /** Filter by the object’s `invoiceUnits` field. */
  invoiceUnits?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `itemType` field. */
  itemType?: InputMaybe<StringFilter>;
  /** Filter by the object’s `lineItemNumber` field. */
  lineItemNumber?: InputMaybe<IntFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<LineItemFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<LineItemFilter>>;
  /** Filter by the object’s `priority` field. */
  priority?: InputMaybe<StringFilter>;
  /** Filter by the object’s `productId` field. */
  productId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `revenue` field. */
  revenue?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `revenueUnits` field. */
  revenueUnits?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `reviewedBy` field. */
  reviewedBy?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `specialty` field. */
  specialty?: InputMaybe<StringFilter>;
  /** Filter by the object’s `startDate` field. */
  startDate?: InputMaybe<DateFilter>;
  /** Filter by the object’s `status` field. */
  status?: InputMaybe<StringFilter>;
  /** Filter by the object’s `targeting` field. */
  targeting?: InputMaybe<JsonFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
};

/** An input for mutations affecting `LineItem` */
export type LineItemInput = {
  adServer?: InputMaybe<Scalars['String']>;
  adServerId?: InputMaybe<Scalars['String']>;
  archivedAt?: InputMaybe<Scalars['Datetime']>;
  campaignId: Scalars['UUID'];
  /** Contracted quantity imported from PIO Sponsorship Quantity custom field for sponsorship lines, otherwise native PIO contracted-units. */
  contractedUnits?: InputMaybe<Scalars['BigFloat']>;
  /** Optional lineage pointer used by the duplicate line item workflow. */
  copiedFromLineItemId?: InputMaybe<Scalars['UUID']>;
  costBasis?: InputMaybe<Scalars['String']>;
  costPerUnit?: InputMaybe<Scalars['BigFloat']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  currencyCode?: InputMaybe<Scalars['String']>;
  deliveryRateType?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  endDate?: InputMaybe<Scalars['Date']>;
  externalPioId?: InputMaybe<Scalars['String']>;
  /** Google Ad Manager line item ID populated by the later GAM shell workflow. */
  gamLineItemId?: InputMaybe<Scalars['String']>;
  goal?: InputMaybe<Scalars['BigFloat']>;
  goalType?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  invoiceAmount?: InputMaybe<Scalars['BigFloat']>;
  /** Normalized invoice status such as in_progress or ready_for_finance; unknown PIO values remain representable as text. */
  invoiceStatus?: InputMaybe<Scalars['String']>;
  invoiceUnits?: InputMaybe<Scalars['BigFloat']>;
  itemType?: InputMaybe<Scalars['String']>;
  /** PIO line item number preserved during import; unique within each campaign because PIO line-item numbers are campaign-scoped. */
  lineItemNumber?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  priority?: InputMaybe<Scalars['String']>;
  productId?: InputMaybe<Scalars['UUID']>;
  revenue?: InputMaybe<Scalars['BigFloat']>;
  revenueUnits?: InputMaybe<Scalars['BigFloat']>;
  /** Nullable reviewer FK replacing the old PIO approval workflow; NULL means self-reviewed. */
  reviewedBy?: InputMaybe<Scalars['UUID']>;
  specialty?: InputMaybe<Scalars['String']>;
  startDate?: InputMaybe<Scalars['Date']>;
  status?: InputMaybe<Scalars['String']>;
  /** Targeting metadata imported from PIO and retained as JSON until targeting editing is in scope. */
  targeting?: InputMaybe<Scalars['JSON']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** Table for managing the relationship between line items and labels. */
export type LineItemLabel = {
  __typename?: 'LineItemLabel';
  /** Reads a single `Label` that is related to this `LineItemLabel`. */
  label?: Maybe<Label>;
  labelId: Scalars['UUID'];
  /** Reads a single `LineItem` that is related to this `LineItemLabel`. */
  lineItem?: Maybe<LineItem>;
  /** Native CSAdmin line item FK added for PIO migration parallel-run; placements_line_item_id remains for rollback. */
  lineItemId?: Maybe<Scalars['UUID']>;
  placementsLineItemId: Scalars['String'];
};

/**
 * A condition to be used against `LineItemLabel` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type LineItemLabelCondition = {
  /** Checks for equality with the object’s `labelId` field. */
  labelId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `lineItemId` field. */
  lineItemId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `placementsLineItemId` field. */
  placementsLineItemId?: InputMaybe<Scalars['String']>;
};

/** A filter to be used against `LineItemLabel` object types. All fields are combined with a logical ‘and.’ */
export type LineItemLabelFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<LineItemLabelFilter>>;
  /** Filter by the object’s `labelId` field. */
  labelId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `lineItemId` field. */
  lineItemId?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<LineItemLabelFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<LineItemLabelFilter>>;
  /** Filter by the object’s `placementsLineItemId` field. */
  placementsLineItemId?: InputMaybe<StringFilter>;
};

/** An input for mutations affecting `LineItemLabel` */
export type LineItemLabelInput = {
  labelId: Scalars['UUID'];
  /** Native CSAdmin line item FK added for PIO migration parallel-run; placements_line_item_id remains for rollback. */
  lineItemId?: InputMaybe<Scalars['UUID']>;
  placementsLineItemId: Scalars['String'];
};

/** Represents an update to a `LineItemLabel`. Fields that are set will be updated. */
export type LineItemLabelPatch = {
  labelId?: InputMaybe<Scalars['UUID']>;
  /** Native CSAdmin line item FK added for PIO migration parallel-run; placements_line_item_id remains for rollback. */
  lineItemId?: InputMaybe<Scalars['UUID']>;
  placementsLineItemId?: InputMaybe<Scalars['String']>;
};

/** A connection to a list of `LineItemLabel` values. */
export type LineItemLabelsConnection = {
  __typename?: 'LineItemLabelsConnection';
  /** A list of edges which contains the `LineItemLabel` and cursor to aid in pagination. */
  edges: Array<LineItemLabelsEdge>;
  /** A list of `LineItemLabel` objects. */
  nodes: Array<LineItemLabel>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `LineItemLabel` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `LineItemLabel` edge in the connection. */
export type LineItemLabelsEdge = {
  __typename?: 'LineItemLabelsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `LineItemLabel` at the end of the edge. */
  node: LineItemLabel;
};

/** Methods to use when ordering `LineItemLabel`. */
export enum LineItemLabelsOrderBy {
  LabelIdAsc = 'LABEL_ID_ASC',
  LabelIdDesc = 'LABEL_ID_DESC',
  LineItemIdAsc = 'LINE_ITEM_ID_ASC',
  LineItemIdDesc = 'LINE_ITEM_ID_DESC',
  Natural = 'NATURAL',
  PlacementsLineItemIdAsc = 'PLACEMENTS_LINE_ITEM_ID_ASC',
  PlacementsLineItemIdDesc = 'PLACEMENTS_LINE_ITEM_ID_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC'
}

/** Represents an update to a `LineItem`. Fields that are set will be updated. */
export type LineItemPatch = {
  adServer?: InputMaybe<Scalars['String']>;
  adServerId?: InputMaybe<Scalars['String']>;
  archivedAt?: InputMaybe<Scalars['Datetime']>;
  campaignId?: InputMaybe<Scalars['UUID']>;
  /** Contracted quantity imported from PIO Sponsorship Quantity custom field for sponsorship lines, otherwise native PIO contracted-units. */
  contractedUnits?: InputMaybe<Scalars['BigFloat']>;
  /** Optional lineage pointer used by the duplicate line item workflow. */
  copiedFromLineItemId?: InputMaybe<Scalars['UUID']>;
  costBasis?: InputMaybe<Scalars['String']>;
  costPerUnit?: InputMaybe<Scalars['BigFloat']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  currencyCode?: InputMaybe<Scalars['String']>;
  deliveryRateType?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  endDate?: InputMaybe<Scalars['Date']>;
  externalPioId?: InputMaybe<Scalars['String']>;
  /** Google Ad Manager line item ID populated by the later GAM shell workflow. */
  gamLineItemId?: InputMaybe<Scalars['String']>;
  goal?: InputMaybe<Scalars['BigFloat']>;
  goalType?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  invoiceAmount?: InputMaybe<Scalars['BigFloat']>;
  /** Normalized invoice status such as in_progress or ready_for_finance; unknown PIO values remain representable as text. */
  invoiceStatus?: InputMaybe<Scalars['String']>;
  invoiceUnits?: InputMaybe<Scalars['BigFloat']>;
  itemType?: InputMaybe<Scalars['String']>;
  /** PIO line item number preserved during import; unique within each campaign because PIO line-item numbers are campaign-scoped. */
  lineItemNumber?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  priority?: InputMaybe<Scalars['String']>;
  productId?: InputMaybe<Scalars['UUID']>;
  revenue?: InputMaybe<Scalars['BigFloat']>;
  revenueUnits?: InputMaybe<Scalars['BigFloat']>;
  /** Nullable reviewer FK replacing the old PIO approval workflow; NULL means self-reviewed. */
  reviewedBy?: InputMaybe<Scalars['UUID']>;
  specialty?: InputMaybe<Scalars['String']>;
  startDate?: InputMaybe<Scalars['Date']>;
  status?: InputMaybe<Scalars['String']>;
  /** Targeting metadata imported from PIO and retained as JSON until targeting editing is in scope. */
  targeting?: InputMaybe<Scalars['JSON']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** A connection to a list of `LineItem` values. */
export type LineItemsConnection = {
  __typename?: 'LineItemsConnection';
  /** A list of edges which contains the `LineItem` and cursor to aid in pagination. */
  edges: Array<LineItemsEdge>;
  /** A list of `LineItem` objects. */
  nodes: Array<LineItem>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `LineItem` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `LineItem` edge in the connection. */
export type LineItemsEdge = {
  __typename?: 'LineItemsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `LineItem` at the end of the edge. */
  node: LineItem;
};

/** Methods to use when ordering `LineItem`. */
export enum LineItemsOrderBy {
  AdServerAsc = 'AD_SERVER_ASC',
  AdServerDesc = 'AD_SERVER_DESC',
  AdServerIdAsc = 'AD_SERVER_ID_ASC',
  AdServerIdDesc = 'AD_SERVER_ID_DESC',
  ArchivedAtAsc = 'ARCHIVED_AT_ASC',
  ArchivedAtDesc = 'ARCHIVED_AT_DESC',
  CampaignIdAsc = 'CAMPAIGN_ID_ASC',
  CampaignIdDesc = 'CAMPAIGN_ID_DESC',
  ContractedUnitsAsc = 'CONTRACTED_UNITS_ASC',
  ContractedUnitsDesc = 'CONTRACTED_UNITS_DESC',
  CopiedFromLineItemIdAsc = 'COPIED_FROM_LINE_ITEM_ID_ASC',
  CopiedFromLineItemIdDesc = 'COPIED_FROM_LINE_ITEM_ID_DESC',
  CostBasisAsc = 'COST_BASIS_ASC',
  CostBasisDesc = 'COST_BASIS_DESC',
  CostPerUnitAsc = 'COST_PER_UNIT_ASC',
  CostPerUnitDesc = 'COST_PER_UNIT_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  CurrencyCodeAsc = 'CURRENCY_CODE_ASC',
  CurrencyCodeDesc = 'CURRENCY_CODE_DESC',
  DeliveryRateTypeAsc = 'DELIVERY_RATE_TYPE_ASC',
  DeliveryRateTypeDesc = 'DELIVERY_RATE_TYPE_DESC',
  DescriptionAsc = 'DESCRIPTION_ASC',
  DescriptionDesc = 'DESCRIPTION_DESC',
  EndDateAsc = 'END_DATE_ASC',
  EndDateDesc = 'END_DATE_DESC',
  ExternalPioIdAsc = 'EXTERNAL_PIO_ID_ASC',
  ExternalPioIdDesc = 'EXTERNAL_PIO_ID_DESC',
  GamLineItemIdAsc = 'GAM_LINE_ITEM_ID_ASC',
  GamLineItemIdDesc = 'GAM_LINE_ITEM_ID_DESC',
  GoalAsc = 'GOAL_ASC',
  GoalDesc = 'GOAL_DESC',
  GoalTypeAsc = 'GOAL_TYPE_ASC',
  GoalTypeDesc = 'GOAL_TYPE_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  InvoiceAmountAsc = 'INVOICE_AMOUNT_ASC',
  InvoiceAmountDesc = 'INVOICE_AMOUNT_DESC',
  InvoiceStatusAsc = 'INVOICE_STATUS_ASC',
  InvoiceStatusDesc = 'INVOICE_STATUS_DESC',
  InvoiceUnitsAsc = 'INVOICE_UNITS_ASC',
  InvoiceUnitsDesc = 'INVOICE_UNITS_DESC',
  ItemTypeAsc = 'ITEM_TYPE_ASC',
  ItemTypeDesc = 'ITEM_TYPE_DESC',
  LineItemNumberAsc = 'LINE_ITEM_NUMBER_ASC',
  LineItemNumberDesc = 'LINE_ITEM_NUMBER_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  PriorityAsc = 'PRIORITY_ASC',
  PriorityDesc = 'PRIORITY_DESC',
  ProductIdAsc = 'PRODUCT_ID_ASC',
  ProductIdDesc = 'PRODUCT_ID_DESC',
  RevenueAsc = 'REVENUE_ASC',
  RevenueDesc = 'REVENUE_DESC',
  RevenueUnitsAsc = 'REVENUE_UNITS_ASC',
  RevenueUnitsDesc = 'REVENUE_UNITS_DESC',
  ReviewedByAsc = 'REVIEWED_BY_ASC',
  ReviewedByDesc = 'REVIEWED_BY_DESC',
  SpecialtyAsc = 'SPECIALTY_ASC',
  SpecialtyDesc = 'SPECIALTY_DESC',
  StartDateAsc = 'START_DATE_ASC',
  StartDateDesc = 'START_DATE_DESC',
  StatusAsc = 'STATUS_ASC',
  StatusDesc = 'STATUS_DESC',
  TargetingAsc = 'TARGETING_ASC',
  TargetingDesc = 'TARGETING_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC'
}

/** The root mutation type which contains root level fields which mutate data. */
export type Mutation = {
  __typename?: 'Mutation';
  /** Clear FMA views by NPI, UID, or AJS anonymous ID. For QA/development use only. */
  clearFmaViews?: Maybe<ClearFmaViewsPayload>;
  /** Creates a single `Advertiser`. */
  createAdvertiser?: Maybe<CreateAdvertiserPayload>;
  /** Creates a single `BannerTargeting`. */
  createBannerTargeting?: Maybe<CreateBannerTargetingPayload>;
  /** Creates a single `Campaign`. */
  createCampaign?: Maybe<CreateCampaignPayload>;
  /** Creates a single `CampaignLabel`. */
  createCampaignLabel?: Maybe<CreateCampaignLabelPayload>;
  /** Creates a single `ClicksCreative`. */
  createClicksCreative?: Maybe<CreateClicksCreativePayload>;
  /** Creates a single `EndemicDriver`. */
  createEndemicDriver?: Maybe<CreateEndemicDriverPayload>;
  /** Creates a single `EndemicDriverTargetList`. */
  createEndemicDriverTargetList?: Maybe<CreateEndemicDriverTargetListPayload>;
  /** Creates a single `EndemicDriverTopicTag`. */
  createEndemicDriverTopicTag?: Maybe<CreateEndemicDriverTopicTagPayload>;
  /** Creates a single `FmaCreative`. */
  createFmaCreative?: Maybe<CreateFmaCreativePayload>;
  /** Creates a single `Label`. */
  createLabel?: Maybe<CreateLabelPayload>;
  /** Creates a single `LeadGenCampaign`. */
  createLeadGenCampaign?: Maybe<CreateLeadGenCampaignPayload>;
  /** Creates a single `LeadGenView`. */
  createLeadGenView?: Maybe<CreateLeadGenViewPayload>;
  /** Creates a single `LineItem`. */
  createLineItem?: Maybe<CreateLineItemPayload>;
  /** Creates a single `LineItemDelivery`. */
  createLineItemDelivery?: Maybe<CreateLineItemDeliveryPayload>;
  /** Creates a single `LineItemLabel`. */
  createLineItemLabel?: Maybe<CreateLineItemLabelPayload>;
  /** Creates a single `Product`. */
  createProduct?: Maybe<CreateProductPayload>;
  /** Creates a single `Profession`. */
  createProfession?: Maybe<CreateProfessionPayload>;
  /** Creates a single `Specialty`. */
  createSpecialty?: Maybe<CreateSpecialtyPayload>;
  /** Creates a single `SpecialtyGroup`. */
  createSpecialtyGroup?: Maybe<CreateSpecialtyGroupPayload>;
  /** Creates a single `SponsoredContentTeaser`. */
  createSponsoredContentTeaser?: Maybe<CreateSponsoredContentTeaserPayload>;
  /** Creates a single `SponsoredContentTeaserProfession`. */
  createSponsoredContentTeaserProfession?: Maybe<CreateSponsoredContentTeaserProfessionPayload>;
  /** Creates a single `SponsoredContentTeaserSpecialty`. */
  createSponsoredContentTeaserSpecialty?: Maybe<CreateSponsoredContentTeaserSpecialtyPayload>;
  /** Creates a single `SponsoredContentTeaserTargetList`. */
  createSponsoredContentTeaserTargetList?: Maybe<CreateSponsoredContentTeaserTargetListPayload>;
  /** Creates a single `TargetList`. */
  createTargetList?: Maybe<CreateTargetListPayload>;
  /** Creates a single `TopicTag`. */
  createTopicTag?: Maybe<CreateTopicTagPayload>;
  /** Deletes a single `Advertiser` using a unique key. */
  deleteAdvertiser?: Maybe<DeleteAdvertiserPayload>;
  /** Deletes a single `BannerTargeting` using a unique key. */
  deleteBannerTargeting?: Maybe<DeleteBannerTargetingPayload>;
  /** Deletes a single `Campaign` using a unique key. */
  deleteCampaign?: Maybe<DeleteCampaignPayload>;
  /** Deletes a single `Campaign` using a unique key. */
  deleteCampaignByCampaignNumber?: Maybe<DeleteCampaignPayload>;
  /** Deletes a single `Campaign` using a unique key. */
  deleteCampaignByExternalPioId?: Maybe<DeleteCampaignPayload>;
  /** Deletes a single `CampaignLabel` using a unique key. */
  deleteCampaignLabel?: Maybe<DeleteCampaignLabelPayload>;
  /** Deletes a single `ClicksCreative` using a unique key. */
  deleteClicksCreative?: Maybe<DeleteClicksCreativePayload>;
  /** Deletes a single `EndemicDriver` using a unique key. */
  deleteEndemicDriver?: Maybe<DeleteEndemicDriverPayload>;
  /** Deletes a single `EndemicDriverTargetList` using a unique key. */
  deleteEndemicDriverTargetList?: Maybe<DeleteEndemicDriverTargetListPayload>;
  /** Deletes a single `EndemicDriverTopicTag` using a unique key. */
  deleteEndemicDriverTopicTag?: Maybe<DeleteEndemicDriverTopicTagPayload>;
  /** Deletes a single `FmaCreative` using a unique key. */
  deleteFmaCreative?: Maybe<DeleteFmaCreativePayload>;
  /** Deletes a single `Label` using a unique key. */
  deleteLabel?: Maybe<DeleteLabelPayload>;
  /** Deletes a single `Label` using a unique key. */
  deleteLabelByName?: Maybe<DeleteLabelPayload>;
  /** Deletes a single `LeadGenCampaign` using a unique key. */
  deleteLeadGenCampaign?: Maybe<DeleteLeadGenCampaignPayload>;
  /** Deletes a single `LeadGenView` using a unique key. */
  deleteLeadGenView?: Maybe<DeleteLeadGenViewPayload>;
  /** Deletes a single `LeadGenView` using a unique key. */
  deleteLeadGenViewByLeadGenCampaignIdAndBrowserInstanceId?: Maybe<DeleteLeadGenViewPayload>;
  /** Deletes a single `LineItem` using a unique key. */
  deleteLineItem?: Maybe<DeleteLineItemPayload>;
  /** Deletes a single `LineItem` using a unique key. */
  deleteLineItemByCampaignIdAndLineItemNumber?: Maybe<DeleteLineItemPayload>;
  /** Deletes a single `LineItem` using a unique key. */
  deleteLineItemByExternalPioId?: Maybe<DeleteLineItemPayload>;
  /** Deletes a single `LineItemDelivery` using a unique key. */
  deleteLineItemDelivery?: Maybe<DeleteLineItemDeliveryPayload>;
  /** Deletes a single `LineItemDelivery` using a unique key. */
  deleteLineItemDeliveryByLineItemIdAndPeriodStartAndPeriodEndAndSource?: Maybe<DeleteLineItemDeliveryPayload>;
  /** Deletes a single `LineItemLabel` using a unique key. */
  deleteLineItemLabel?: Maybe<DeleteLineItemLabelPayload>;
  /** Deletes a single `Product` using a unique key. */
  deleteProduct?: Maybe<DeleteProductPayload>;
  /** Deletes a single `Profession` using a unique key. */
  deleteProfession?: Maybe<DeleteProfessionPayload>;
  /** Deletes a single `Specialty` using a unique key. */
  deleteSpecialty?: Maybe<DeleteSpecialtyPayload>;
  /** Deletes a single `SpecialtyGroup` using a unique key. */
  deleteSpecialtyGroup?: Maybe<DeleteSpecialtyGroupPayload>;
  /** Deletes a single `SponsoredContentTeaser` using a unique key. */
  deleteSponsoredContentTeaser?: Maybe<DeleteSponsoredContentTeaserPayload>;
  /** Deletes a single `SponsoredContentTeaserProfession` using a unique key. */
  deleteSponsoredContentTeaserProfession?: Maybe<DeleteSponsoredContentTeaserProfessionPayload>;
  /** Deletes a single `SponsoredContentTeaserSpecialty` using a unique key. */
  deleteSponsoredContentTeaserSpecialty?: Maybe<DeleteSponsoredContentTeaserSpecialtyPayload>;
  /** Deletes a single `SponsoredContentTeaserTargetList` using a unique key. */
  deleteSponsoredContentTeaserTargetList?: Maybe<DeleteSponsoredContentTeaserTargetListPayload>;
  /** Deletes a single `TargetList` using a unique key. */
  deleteTargetList?: Maybe<DeleteTargetListPayload>;
  /** Deletes a single `TopicTag` using a unique key. */
  deleteTopicTag?: Maybe<DeleteTopicTagPayload>;
  duplicateClicksCreative?: Maybe<DuplicateClicksCreativePayload>;
  duplicateFmaCreative?: Maybe<DuplicateFmaCreativePayload>;
  recordLeadGenConversion?: Maybe<RecordLeadGenConversionPayload>;
  recordLeadGenView?: Maybe<RecordLeadGenViewPayload>;
  /** Set the days to hide the creative to the specified list of days. Idempotent, avoids updating timestamps for unchanged records. */
  setClicksCreativeHideOnDays?: Maybe<SetClicksCreativeHideOnDaysPayload>;
  /** Set the professions for the specified Clicks creative to the specified list of profession ids. Idempotent, avoids updating timestamps for unchanged records. */
  setClicksCreativeProfessions?: Maybe<SetClicksCreativeProfessionsPayload>;
  /** Set the specialties for the specified Clicks creative to the specified list of specialty ids. Idempotent, avoids updating timestamps for unchanged records. */
  setClicksCreativeSpecialties?: Maybe<SetClicksCreativeSpecialtiesPayload>;
  setClicksCreativeTargetLists?: Maybe<SetClicksCreativeTargetListsPayload>;
  setEndemicDriverProfessions?: Maybe<SetEndemicDriverProfessionsPayload>;
  setEndemicDriverSpecialties?: Maybe<SetEndemicDriverSpecialtiesPayload>;
  setEndemicDriverTargetLists?: Maybe<SetEndemicDriverTargetListsPayload>;
  setEndemicDriverTopicTags?: Maybe<SetEndemicDriverTopicTagsPayload>;
  setFmaCreativeTargetLists?: Maybe<SetFmaCreativeTargetListsPayload>;
  setLeadGenCampaignTargetLists?: Maybe<SetLeadGenCampaignTargetListsPayload>;
  /** Set the professions for the specified Sponsored Content Teaser to the specified list of profession ids. Idempotent, avoids updating timestamps for unchanged records. */
  setSponsoredContentTeaserProfessions?: Maybe<SetSponsoredContentTeaserProfessionsPayload>;
  /** Set the specialties for the specified Sponsored Content Teaser to the specified list of specialty ids. Idempotent, avoids updating timestamps for unchanged records. */
  setSponsoredContentTeaserSpecialties?: Maybe<SetSponsoredContentTeaserSpecialtiesPayload>;
  /** Set the target lists for the specified Sponsored Content Teaser to the specified list of target list ids. Idempotent, avoids updating timestamps for unchanged records. */
  setSponsoredContentTeaserTargetLists?: Maybe<SetSponsoredContentTeaserTargetListsPayload>;
  /** Assign target-list line items while preserving placements_line_item_id and filling native line_item_id when a matching imported or native line item exists. */
  setTargetListLineItems?: Maybe<SetTargetListLineItemsPayload>;
  /** Set the NPIs for the specified target group to the specified list of NPIs. Idempotent, avoids updating timestamps for unchanged records. */
  setTargetListNpis?: Maybe<SetTargetListNpisPayload>;
  /** Updates a single `Advertiser` using a unique key and a patch. */
  updateAdvertiser?: Maybe<UpdateAdvertiserPayload>;
  /** Updates a single `BannerTargeting` using a unique key and a patch. */
  updateBannerTargeting?: Maybe<UpdateBannerTargetingPayload>;
  /** Updates a single `Campaign` using a unique key and a patch. */
  updateCampaign?: Maybe<UpdateCampaignPayload>;
  /** Updates a single `Campaign` using a unique key and a patch. */
  updateCampaignByCampaignNumber?: Maybe<UpdateCampaignPayload>;
  /** Updates a single `Campaign` using a unique key and a patch. */
  updateCampaignByExternalPioId?: Maybe<UpdateCampaignPayload>;
  /** Updates a single `CampaignLabel` using a unique key and a patch. */
  updateCampaignLabel?: Maybe<UpdateCampaignLabelPayload>;
  /** Updates a single `ClicksCreative` using a unique key and a patch. */
  updateClicksCreative?: Maybe<UpdateClicksCreativePayload>;
  /** Updates a single `EndemicDriver` using a unique key and a patch. */
  updateEndemicDriver?: Maybe<UpdateEndemicDriverPayload>;
  /** Updates a single `EndemicDriverTargetList` using a unique key and a patch. */
  updateEndemicDriverTargetList?: Maybe<UpdateEndemicDriverTargetListPayload>;
  /** Updates a single `EndemicDriverTopicTag` using a unique key and a patch. */
  updateEndemicDriverTopicTag?: Maybe<UpdateEndemicDriverTopicTagPayload>;
  /** Updates a single `FmaCreative` using a unique key and a patch. */
  updateFmaCreative?: Maybe<UpdateFmaCreativePayload>;
  /** Updates a single `Label` using a unique key and a patch. */
  updateLabel?: Maybe<UpdateLabelPayload>;
  /** Updates a single `Label` using a unique key and a patch. */
  updateLabelByName?: Maybe<UpdateLabelPayload>;
  /** Updates a single `LeadGenCampaign` using a unique key and a patch. */
  updateLeadGenCampaign?: Maybe<UpdateLeadGenCampaignPayload>;
  /** Updates a single `LeadGenView` using a unique key and a patch. */
  updateLeadGenView?: Maybe<UpdateLeadGenViewPayload>;
  /** Updates a single `LeadGenView` using a unique key and a patch. */
  updateLeadGenViewByLeadGenCampaignIdAndBrowserInstanceId?: Maybe<UpdateLeadGenViewPayload>;
  /** Updates a single `LineItem` using a unique key and a patch. */
  updateLineItem?: Maybe<UpdateLineItemPayload>;
  /** Updates a single `LineItem` using a unique key and a patch. */
  updateLineItemByCampaignIdAndLineItemNumber?: Maybe<UpdateLineItemPayload>;
  /** Updates a single `LineItem` using a unique key and a patch. */
  updateLineItemByExternalPioId?: Maybe<UpdateLineItemPayload>;
  /** Updates a single `LineItemDelivery` using a unique key and a patch. */
  updateLineItemDelivery?: Maybe<UpdateLineItemDeliveryPayload>;
  /** Updates a single `LineItemDelivery` using a unique key and a patch. */
  updateLineItemDeliveryByLineItemIdAndPeriodStartAndPeriodEndAndSource?: Maybe<UpdateLineItemDeliveryPayload>;
  /** Updates a single `LineItemLabel` using a unique key and a patch. */
  updateLineItemLabel?: Maybe<UpdateLineItemLabelPayload>;
  /** Updates a single `Product` using a unique key and a patch. */
  updateProduct?: Maybe<UpdateProductPayload>;
  /** Updates a single `Profession` using a unique key and a patch. */
  updateProfession?: Maybe<UpdateProfessionPayload>;
  /** Updates a single `Specialty` using a unique key and a patch. */
  updateSpecialty?: Maybe<UpdateSpecialtyPayload>;
  /** Updates a single `SpecialtyGroup` using a unique key and a patch. */
  updateSpecialtyGroup?: Maybe<UpdateSpecialtyGroupPayload>;
  /** Updates a single `SponsoredContentTeaser` using a unique key and a patch. */
  updateSponsoredContentTeaser?: Maybe<UpdateSponsoredContentTeaserPayload>;
  /** Updates a single `SponsoredContentTeaserProfession` using a unique key and a patch. */
  updateSponsoredContentTeaserProfession?: Maybe<UpdateSponsoredContentTeaserProfessionPayload>;
  /** Updates a single `SponsoredContentTeaserSpecialty` using a unique key and a patch. */
  updateSponsoredContentTeaserSpecialty?: Maybe<UpdateSponsoredContentTeaserSpecialtyPayload>;
  /** Updates a single `SponsoredContentTeaserTargetList` using a unique key and a patch. */
  updateSponsoredContentTeaserTargetList?: Maybe<UpdateSponsoredContentTeaserTargetListPayload>;
  /** Updates a single `TargetList` using a unique key and a patch. */
  updateTargetList?: Maybe<UpdateTargetListPayload>;
  /** Updates a single `TopicTag` using a unique key and a patch. */
  updateTopicTag?: Maybe<UpdateTopicTagPayload>;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationClearFmaViewsArgs = {
  input: ClearFmaViewsInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateAdvertiserArgs = {
  input: CreateAdvertiserInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateBannerTargetingArgs = {
  input: CreateBannerTargetingInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateCampaignArgs = {
  input: CreateCampaignInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateCampaignLabelArgs = {
  input: CreateCampaignLabelInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateClicksCreativeArgs = {
  input: CreateClicksCreativeInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateEndemicDriverArgs = {
  input: CreateEndemicDriverInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateEndemicDriverTargetListArgs = {
  input: CreateEndemicDriverTargetListInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateEndemicDriverTopicTagArgs = {
  input: CreateEndemicDriverTopicTagInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateFmaCreativeArgs = {
  input: CreateFmaCreativeInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateLabelArgs = {
  input: CreateLabelInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateLeadGenCampaignArgs = {
  input: CreateLeadGenCampaignInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateLeadGenViewArgs = {
  input: CreateLeadGenViewInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateLineItemArgs = {
  input: CreateLineItemInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateLineItemDeliveryArgs = {
  input: CreateLineItemDeliveryInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateLineItemLabelArgs = {
  input: CreateLineItemLabelInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateProductArgs = {
  input: CreateProductInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateProfessionArgs = {
  input: CreateProfessionInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateSpecialtyArgs = {
  input: CreateSpecialtyInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateSpecialtyGroupArgs = {
  input: CreateSpecialtyGroupInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateSponsoredContentTeaserArgs = {
  input: CreateSponsoredContentTeaserInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateSponsoredContentTeaserProfessionArgs = {
  input: CreateSponsoredContentTeaserProfessionInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateSponsoredContentTeaserSpecialtyArgs = {
  input: CreateSponsoredContentTeaserSpecialtyInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateSponsoredContentTeaserTargetListArgs = {
  input: CreateSponsoredContentTeaserTargetListInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateTargetListArgs = {
  input: CreateTargetListInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateTopicTagArgs = {
  input: CreateTopicTagInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteAdvertiserArgs = {
  input: DeleteAdvertiserInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteBannerTargetingArgs = {
  input: DeleteBannerTargetingInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteCampaignArgs = {
  input: DeleteCampaignInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteCampaignByCampaignNumberArgs = {
  input: DeleteCampaignByCampaignNumberInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteCampaignByExternalPioIdArgs = {
  input: DeleteCampaignByExternalPioIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteCampaignLabelArgs = {
  input: DeleteCampaignLabelInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteClicksCreativeArgs = {
  input: DeleteClicksCreativeInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteEndemicDriverArgs = {
  input: DeleteEndemicDriverInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteEndemicDriverTargetListArgs = {
  input: DeleteEndemicDriverTargetListInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteEndemicDriverTopicTagArgs = {
  input: DeleteEndemicDriverTopicTagInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteFmaCreativeArgs = {
  input: DeleteFmaCreativeInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteLabelArgs = {
  input: DeleteLabelInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteLabelByNameArgs = {
  input: DeleteLabelByNameInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteLeadGenCampaignArgs = {
  input: DeleteLeadGenCampaignInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteLeadGenViewArgs = {
  input: DeleteLeadGenViewInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteLeadGenViewByLeadGenCampaignIdAndBrowserInstanceIdArgs = {
  input: DeleteLeadGenViewByLeadGenCampaignIdAndBrowserInstanceIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteLineItemArgs = {
  input: DeleteLineItemInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteLineItemByCampaignIdAndLineItemNumberArgs = {
  input: DeleteLineItemByCampaignIdAndLineItemNumberInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteLineItemByExternalPioIdArgs = {
  input: DeleteLineItemByExternalPioIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteLineItemDeliveryArgs = {
  input: DeleteLineItemDeliveryInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteLineItemDeliveryByLineItemIdAndPeriodStartAndPeriodEndAndSourceArgs = {
  input: DeleteLineItemDeliveryByLineItemIdAndPeriodStartAndPeriodEndAndSourceInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteLineItemLabelArgs = {
  input: DeleteLineItemLabelInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteProductArgs = {
  input: DeleteProductInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteProfessionArgs = {
  input: DeleteProfessionInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteSpecialtyArgs = {
  input: DeleteSpecialtyInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteSpecialtyGroupArgs = {
  input: DeleteSpecialtyGroupInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteSponsoredContentTeaserArgs = {
  input: DeleteSponsoredContentTeaserInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteSponsoredContentTeaserProfessionArgs = {
  input: DeleteSponsoredContentTeaserProfessionInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteSponsoredContentTeaserSpecialtyArgs = {
  input: DeleteSponsoredContentTeaserSpecialtyInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteSponsoredContentTeaserTargetListArgs = {
  input: DeleteSponsoredContentTeaserTargetListInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteTargetListArgs = {
  input: DeleteTargetListInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteTopicTagArgs = {
  input: DeleteTopicTagInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDuplicateClicksCreativeArgs = {
  input: DuplicateClicksCreativeInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDuplicateFmaCreativeArgs = {
  input: DuplicateFmaCreativeInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationRecordLeadGenConversionArgs = {
  input: RecordLeadGenConversionInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationRecordLeadGenViewArgs = {
  input: RecordLeadGenViewInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationSetClicksCreativeHideOnDaysArgs = {
  input: SetClicksCreativeHideOnDaysInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationSetClicksCreativeProfessionsArgs = {
  input: SetClicksCreativeProfessionsInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationSetClicksCreativeSpecialtiesArgs = {
  input: SetClicksCreativeSpecialtiesInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationSetClicksCreativeTargetListsArgs = {
  input: SetClicksCreativeTargetListsInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationSetEndemicDriverProfessionsArgs = {
  input: SetEndemicDriverProfessionsInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationSetEndemicDriverSpecialtiesArgs = {
  input: SetEndemicDriverSpecialtiesInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationSetEndemicDriverTargetListsArgs = {
  input: SetEndemicDriverTargetListsInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationSetEndemicDriverTopicTagsArgs = {
  input: SetEndemicDriverTopicTagsInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationSetFmaCreativeTargetListsArgs = {
  input: SetFmaCreativeTargetListsInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationSetLeadGenCampaignTargetListsArgs = {
  input: SetLeadGenCampaignTargetListsInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationSetSponsoredContentTeaserProfessionsArgs = {
  input: SetSponsoredContentTeaserProfessionsInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationSetSponsoredContentTeaserSpecialtiesArgs = {
  input: SetSponsoredContentTeaserSpecialtiesInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationSetSponsoredContentTeaserTargetListsArgs = {
  input: SetSponsoredContentTeaserTargetListsInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationSetTargetListLineItemsArgs = {
  input: SetTargetListLineItemsInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationSetTargetListNpisArgs = {
  input: SetTargetListNpisInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateAdvertiserArgs = {
  input: UpdateAdvertiserInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateBannerTargetingArgs = {
  input: UpdateBannerTargetingInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateCampaignArgs = {
  input: UpdateCampaignInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateCampaignByCampaignNumberArgs = {
  input: UpdateCampaignByCampaignNumberInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateCampaignByExternalPioIdArgs = {
  input: UpdateCampaignByExternalPioIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateCampaignLabelArgs = {
  input: UpdateCampaignLabelInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateClicksCreativeArgs = {
  input: UpdateClicksCreativeInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateEndemicDriverArgs = {
  input: UpdateEndemicDriverInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateEndemicDriverTargetListArgs = {
  input: UpdateEndemicDriverTargetListInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateEndemicDriverTopicTagArgs = {
  input: UpdateEndemicDriverTopicTagInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateFmaCreativeArgs = {
  input: UpdateFmaCreativeInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateLabelArgs = {
  input: UpdateLabelInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateLabelByNameArgs = {
  input: UpdateLabelByNameInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateLeadGenCampaignArgs = {
  input: UpdateLeadGenCampaignInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateLeadGenViewArgs = {
  input: UpdateLeadGenViewInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateLeadGenViewByLeadGenCampaignIdAndBrowserInstanceIdArgs = {
  input: UpdateLeadGenViewByLeadGenCampaignIdAndBrowserInstanceIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateLineItemArgs = {
  input: UpdateLineItemInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateLineItemByCampaignIdAndLineItemNumberArgs = {
  input: UpdateLineItemByCampaignIdAndLineItemNumberInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateLineItemByExternalPioIdArgs = {
  input: UpdateLineItemByExternalPioIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateLineItemDeliveryArgs = {
  input: UpdateLineItemDeliveryInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateLineItemDeliveryByLineItemIdAndPeriodStartAndPeriodEndAndSourceArgs = {
  input: UpdateLineItemDeliveryByLineItemIdAndPeriodStartAndPeriodEndAndSourceInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateLineItemLabelArgs = {
  input: UpdateLineItemLabelInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateProductArgs = {
  input: UpdateProductInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateProfessionArgs = {
  input: UpdateProfessionInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateSpecialtyArgs = {
  input: UpdateSpecialtyInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateSpecialtyGroupArgs = {
  input: UpdateSpecialtyGroupInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateSponsoredContentTeaserArgs = {
  input: UpdateSponsoredContentTeaserInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateSponsoredContentTeaserProfessionArgs = {
  input: UpdateSponsoredContentTeaserProfessionInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateSponsoredContentTeaserSpecialtyArgs = {
  input: UpdateSponsoredContentTeaserSpecialtyInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateSponsoredContentTeaserTargetListArgs = {
  input: UpdateSponsoredContentTeaserTargetListInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateTargetListArgs = {
  input: UpdateTargetListInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateTopicTagArgs = {
  input: UpdateTopicTagInput;
};

/** Information about pagination in a connection. */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['Cursor']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean'];
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['Cursor']>;
};

/** Placements.IO imported users and Clerk-backed CSAdmin reviewer rows retained only for review and delivery attribution; Clerk remains the CSAdmin identity provider. */
export type PioUser = {
  __typename?: 'PioUser';
  archivedAt?: Maybe<Scalars['Datetime']>;
  createdAt: Scalars['Datetime'];
  email?: Maybe<Scalars['String']>;
  /** Optional Placements.IO user ID retained for imported attribution when available. */
  externalPioId?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** Reads and enables pagination through a set of `LineItemDelivery`. */
  lineItemDeliveriesByReportedBy: LineItemDeliveriesConnection;
  /** Reads and enables pagination through a set of `LineItem`. */
  lineItemsByReviewedBy: LineItemsConnection;
  name?: Maybe<Scalars['String']>;
  updatedAt: Scalars['Datetime'];
};


/** Placements.IO imported users and Clerk-backed CSAdmin reviewer rows retained only for review and delivery attribution; Clerk remains the CSAdmin identity provider. */
export type PioUserLineItemDeliveriesByReportedByArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<LineItemDeliveryCondition>;
  filter?: InputMaybe<LineItemDeliveryFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LineItemDeliveriesOrderBy>>;
};


/** Placements.IO imported users and Clerk-backed CSAdmin reviewer rows retained only for review and delivery attribution; Clerk remains the CSAdmin identity provider. */
export type PioUserLineItemsByReviewedByArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<LineItemCondition>;
  filter?: InputMaybe<LineItemFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LineItemsOrderBy>>;
};

/** A condition to be used against `PioUser` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type PioUserCondition = {
  /** Checks for equality with the object’s `archivedAt` field. */
  archivedAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `email` field. */
  email?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `externalPioId` field. */
  externalPioId?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** A filter to be used against `PioUser` object types. All fields are combined with a logical ‘and.’ */
export type PioUserFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<PioUserFilter>>;
  /** Filter by the object’s `archivedAt` field. */
  archivedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `email` field. */
  email?: InputMaybe<StringFilter>;
  /** Filter by the object’s `externalPioId` field. */
  externalPioId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<PioUserFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<PioUserFilter>>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
};

/** A connection to a list of `PioUser` values. */
export type PioUsersConnection = {
  __typename?: 'PioUsersConnection';
  /** A list of edges which contains the `PioUser` and cursor to aid in pagination. */
  edges: Array<PioUsersEdge>;
  /** A list of `PioUser` objects. */
  nodes: Array<PioUser>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `PioUser` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `PioUser` edge in the connection. */
export type PioUsersEdge = {
  __typename?: 'PioUsersEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `PioUser` at the end of the edge. */
  node: PioUser;
};

/** Methods to use when ordering `PioUser`. */
export enum PioUsersOrderBy {
  ArchivedAtAsc = 'ARCHIVED_AT_ASC',
  ArchivedAtDesc = 'ARCHIVED_AT_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  EmailAsc = 'EMAIL_ASC',
  EmailDesc = 'EMAIL_DESC',
  ExternalPioIdAsc = 'EXTERNAL_PIO_ID_ASC',
  ExternalPioIdDesc = 'EXTERNAL_PIO_ID_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC'
}

/** PIO product and placement type reference data. */
export type Product = {
  __typename?: 'Product';
  archivedAt?: Maybe<Scalars['Datetime']>;
  createdAt: Scalars['Datetime'];
  /** Default targeting metadata imported from PIO and retained as JSON until targeting editing is in scope. */
  defaultTargeting?: Maybe<Scalars['JSON']>;
  externalPioId?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** Reads and enables pagination through a set of `LineItem`. */
  lineItems: LineItemsConnection;
  name: Scalars['String'];
  updatedAt: Scalars['Datetime'];
};


/** PIO product and placement type reference data. */
export type ProductLineItemsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<LineItemCondition>;
  filter?: InputMaybe<LineItemFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LineItemsOrderBy>>;
};

/** A condition to be used against `Product` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type ProductCondition = {
  /** Checks for equality with the object’s `archivedAt` field. */
  archivedAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `defaultTargeting` field. */
  defaultTargeting?: InputMaybe<Scalars['JSON']>;
  /** Checks for equality with the object’s `externalPioId` field. */
  externalPioId?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** A filter to be used against `Product` object types. All fields are combined with a logical ‘and.’ */
export type ProductFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ProductFilter>>;
  /** Filter by the object’s `archivedAt` field. */
  archivedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `defaultTargeting` field. */
  defaultTargeting?: InputMaybe<JsonFilter>;
  /** Filter by the object’s `externalPioId` field. */
  externalPioId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ProductFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ProductFilter>>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
};

/** An input for mutations affecting `Product` */
export type ProductInput = {
  archivedAt?: InputMaybe<Scalars['Datetime']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Default targeting metadata imported from PIO and retained as JSON until targeting editing is in scope. */
  defaultTargeting?: InputMaybe<Scalars['JSON']>;
  externalPioId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  name: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** Represents an update to a `Product`. Fields that are set will be updated. */
export type ProductPatch = {
  archivedAt?: InputMaybe<Scalars['Datetime']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Default targeting metadata imported from PIO and retained as JSON until targeting editing is in scope. */
  defaultTargeting?: InputMaybe<Scalars['JSON']>;
  externalPioId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** A connection to a list of `Product` values. */
export type ProductsConnection = {
  __typename?: 'ProductsConnection';
  /** A list of edges which contains the `Product` and cursor to aid in pagination. */
  edges: Array<ProductsEdge>;
  /** A list of `Product` objects. */
  nodes: Array<Product>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Product` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Product` edge in the connection. */
export type ProductsEdge = {
  __typename?: 'ProductsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `Product` at the end of the edge. */
  node: Product;
};

/** Methods to use when ordering `Product`. */
export enum ProductsOrderBy {
  ArchivedAtAsc = 'ARCHIVED_AT_ASC',
  ArchivedAtDesc = 'ARCHIVED_AT_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  DefaultTargetingAsc = 'DEFAULT_TARGETING_ASC',
  DefaultTargetingDesc = 'DEFAULT_TARGETING_DESC',
  ExternalPioIdAsc = 'EXTERNAL_PIO_ID_ASC',
  ExternalPioIdDesc = 'EXTERNAL_PIO_ID_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC'
}

/** Professions that can be used for targeting. */
export type Profession = {
  __typename?: 'Profession';
  createdAt: Scalars['Datetime'];
  id: Scalars['Int'];
  legacyProfessionId?: Maybe<Scalars['Int']>;
  name: Scalars['String'];
  /** Reads and enables pagination through a set of `SponsoredContentTeaserProfession`. */
  sponsoredContentTeaserProfessions: SponsoredContentTeaserProfessionsConnection;
  updatedAt: Scalars['Datetime'];
};


/** Professions that can be used for targeting. */
export type ProfessionSponsoredContentTeaserProfessionsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<SponsoredContentTeaserProfessionCondition>;
  filter?: InputMaybe<SponsoredContentTeaserProfessionFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<SponsoredContentTeaserProfessionsOrderBy>>;
};

/**
 * A condition to be used against `Profession` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type ProfessionCondition = {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `legacyProfessionId` field. */
  legacyProfessionId?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** A filter to be used against `Profession` object types. All fields are combined with a logical ‘and.’ */
export type ProfessionFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ProfessionFilter>>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `legacyProfessionId` field. */
  legacyProfessionId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ProfessionFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ProfessionFilter>>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
};

/** An input for mutations affecting `Profession` */
export type ProfessionInput = {
  legacyProfessionId?: InputMaybe<Scalars['Int']>;
  name: Scalars['String'];
};

/** Represents an update to a `Profession`. Fields that are set will be updated. */
export type ProfessionPatch = {
  legacyProfessionId?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
};

/** A connection to a list of `Profession` values. */
export type ProfessionsConnection = {
  __typename?: 'ProfessionsConnection';
  /** A list of edges which contains the `Profession` and cursor to aid in pagination. */
  edges: Array<ProfessionsEdge>;
  /** A list of `Profession` objects. */
  nodes: Array<Profession>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Profession` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Profession` edge in the connection. */
export type ProfessionsEdge = {
  __typename?: 'ProfessionsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `Profession` at the end of the edge. */
  node: Profession;
};

/** Methods to use when ordering `Profession`. */
export enum ProfessionsOrderBy {
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  LegacyProfessionIdAsc = 'LEGACY_PROFESSION_ID_ASC',
  LegacyProfessionIdDesc = 'LEGACY_PROFESSION_ID_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC'
}

/** The root query type which gives access points into the data universe. */
export type Query = {
  __typename?: 'Query';
  advertiser?: Maybe<Advertiser>;
  /** Reads and enables pagination through a set of `Advertiser`. */
  advertisers?: Maybe<AdvertisersConnection>;
  bannerTargeting?: Maybe<BannerTargeting>;
  /** Reads and enables pagination through a set of `BannerTargeting`. */
  bannerTargetings?: Maybe<BannerTargetingsConnection>;
  campaign?: Maybe<Campaign>;
  campaignByCampaignNumber?: Maybe<Campaign>;
  campaignByExternalPioId?: Maybe<Campaign>;
  campaignLabel?: Maybe<CampaignLabel>;
  /** Reads and enables pagination through a set of `CampaignLabel`. */
  campaignLabels?: Maybe<CampaignLabelsConnection>;
  /** Reads and enables pagination through a set of `Campaign`. */
  campaigns?: Maybe<CampaignsConnection>;
  clicksCreative?: Maybe<ClicksCreative>;
  /** Reads and enables pagination through a set of `ClicksCreative`. */
  clicksCreatives?: Maybe<ClicksCreativesConnection>;
  endemicDriver?: Maybe<EndemicDriver>;
  endemicDriverTargetList?: Maybe<EndemicDriverTargetList>;
  /** Reads and enables pagination through a set of `EndemicDriverTargetList`. */
  endemicDriverTargetLists?: Maybe<EndemicDriverTargetListsConnection>;
  endemicDriverTopicTag?: Maybe<EndemicDriverTopicTag>;
  /** Reads and enables pagination through a set of `EndemicDriverTopicTag`. */
  endemicDriverTopicTags?: Maybe<EndemicDriverTopicTagsConnection>;
  /** Reads and enables pagination through a set of `EndemicDriver`. */
  endemicDrivers?: Maybe<EndemicDriversConnection>;
  fmaCreative?: Maybe<FmaCreative>;
  /** Reads and enables pagination through a set of `FmaCreative`. */
  fmaCreatives?: Maybe<FmaCreativesConnection>;
  /** Reads and enables pagination through a set of `FmaView`. */
  fmaViews?: Maybe<FmaViewsConnection>;
  label?: Maybe<Label>;
  labelByName?: Maybe<Label>;
  /** Reads and enables pagination through a set of `Label`. */
  labels?: Maybe<LabelsConnection>;
  leadGenCampaign?: Maybe<LeadGenCampaign>;
  /** Reads and enables pagination through a set of `LeadGenCampaignStat`. */
  leadGenCampaignStats?: Maybe<LeadGenCampaignStatsConnection>;
  /** Reads and enables pagination through a set of `LeadGenCampaign`. */
  leadGenCampaigns?: Maybe<LeadGenCampaignsConnection>;
  leadGenView?: Maybe<LeadGenView>;
  leadGenViewByLeadGenCampaignIdAndBrowserInstanceId?: Maybe<LeadGenView>;
  /** Reads and enables pagination through a set of `LeadGenView`. */
  leadGenViews?: Maybe<LeadGenViewsConnection>;
  lineItem?: Maybe<LineItem>;
  lineItemByCampaignIdAndLineItemNumber?: Maybe<LineItem>;
  lineItemByExternalPioId?: Maybe<LineItem>;
  /** Reads and enables pagination through a set of `LineItemDelivery`. */
  lineItemDeliveries?: Maybe<LineItemDeliveriesConnection>;
  lineItemDelivery?: Maybe<LineItemDelivery>;
  lineItemDeliveryByLineItemIdAndPeriodStartAndPeriodEndAndSource?: Maybe<LineItemDelivery>;
  lineItemLabel?: Maybe<LineItemLabel>;
  /** Reads and enables pagination through a set of `LineItemLabel`. */
  lineItemLabels?: Maybe<LineItemLabelsConnection>;
  /** Reads and enables pagination through a set of `LineItem`. */
  lineItems?: Maybe<LineItemsConnection>;
  pioUser?: Maybe<PioUser>;
  pioUserByEmail?: Maybe<PioUser>;
  pioUserByExternalPioId?: Maybe<PioUser>;
  /** Reads and enables pagination through a set of `PioUser`. */
  pioUsers?: Maybe<PioUsersConnection>;
  product?: Maybe<Product>;
  /** Reads and enables pagination through a set of `Product`. */
  products?: Maybe<ProductsConnection>;
  profession?: Maybe<Profession>;
  /** Reads and enables pagination through a set of `Profession`. */
  professions?: Maybe<ProfessionsConnection>;
  /**
   * Exposes the root query type nested one level down. This is helpful for Relay 1
   * which can only query top level fields if they are in a particular form.
   */
  query: Query;
  /** Reads and enables pagination through a set of `Specialty`. */
  specialties?: Maybe<SpecialtiesConnection>;
  specialty?: Maybe<Specialty>;
  specialtyGroup?: Maybe<SpecialtyGroup>;
  /** Reads and enables pagination through a set of `SpecialtyGroup`. */
  specialtyGroups?: Maybe<SpecialtyGroupsConnection>;
  sponsoredContentTeaser?: Maybe<SponsoredContentTeaser>;
  sponsoredContentTeaserProfession?: Maybe<SponsoredContentTeaserProfession>;
  /** Reads and enables pagination through a set of `SponsoredContentTeaserProfession`. */
  sponsoredContentTeaserProfessions?: Maybe<SponsoredContentTeaserProfessionsConnection>;
  /** Reads and enables pagination through a set of `SponsoredContentTeaserSpecialty`. */
  sponsoredContentTeaserSpecialties?: Maybe<SponsoredContentTeaserSpecialtiesConnection>;
  sponsoredContentTeaserSpecialty?: Maybe<SponsoredContentTeaserSpecialty>;
  sponsoredContentTeaserTargetList?: Maybe<SponsoredContentTeaserTargetList>;
  /** Reads and enables pagination through a set of `SponsoredContentTeaserTargetList`. */
  sponsoredContentTeaserTargetLists?: Maybe<SponsoredContentTeaserTargetListsConnection>;
  /** Reads and enables pagination through a set of `SponsoredContentTeaser`. */
  sponsoredContentTeasers?: Maybe<SponsoredContentTeasersConnection>;
  targetList?: Maybe<TargetList>;
  /** Reads and enables pagination through a set of `TargetList`. */
  targetLists?: Maybe<TargetListsConnection>;
  topicTag?: Maybe<TopicTag>;
  /** Reads and enables pagination through a set of `TopicTag`. */
  topicTags?: Maybe<TopicTagsConnection>;
  userLeadGenCampaign?: Maybe<LeadGenCampaign>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAdvertiserArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryAdvertisersArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<AdvertiserCondition>;
  filter?: InputMaybe<AdvertiserFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AdvertisersOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryBannerTargetingArgs = {
  id: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type QueryBannerTargetingsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<BannerTargetingCondition>;
  filter?: InputMaybe<BannerTargetingFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<BannerTargetingsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryCampaignArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryCampaignByCampaignNumberArgs = {
  campaignNumber: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type QueryCampaignByExternalPioIdArgs = {
  externalPioId: Scalars['String'];
};


/** The root query type which gives access points into the data universe. */
export type QueryCampaignLabelArgs = {
  labelId: Scalars['UUID'];
  placementsCampaignId: Scalars['String'];
};


/** The root query type which gives access points into the data universe. */
export type QueryCampaignLabelsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<CampaignLabelCondition>;
  filter?: InputMaybe<CampaignLabelFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CampaignLabelsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryCampaignsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<CampaignCondition>;
  filter?: InputMaybe<CampaignFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CampaignsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryClicksCreativeArgs = {
  id: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type QueryClicksCreativesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ClicksCreativeCondition>;
  filter?: InputMaybe<ClicksCreativeFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ClicksCreativesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryEndemicDriverArgs = {
  id: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type QueryEndemicDriverTargetListArgs = {
  endemicDriverId: Scalars['Int'];
  targetListId: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type QueryEndemicDriverTargetListsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<EndemicDriverTargetListCondition>;
  filter?: InputMaybe<EndemicDriverTargetListFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EndemicDriverTargetListsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryEndemicDriverTopicTagArgs = {
  endemicDriverId: Scalars['Int'];
  topicTagId: Scalars['String'];
};


/** The root query type which gives access points into the data universe. */
export type QueryEndemicDriverTopicTagsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<EndemicDriverTopicTagCondition>;
  filter?: InputMaybe<EndemicDriverTopicTagFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EndemicDriverTopicTagsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryEndemicDriversArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<EndemicDriverCondition>;
  filter?: InputMaybe<EndemicDriverFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EndemicDriversOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryFmaCreativeArgs = {
  id: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type QueryFmaCreativesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<FmaCreativeCondition>;
  filter?: InputMaybe<FmaCreativeFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<FmaCreativesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryFmaViewsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<FmaViewCondition>;
  filter?: InputMaybe<FmaViewFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<FmaViewsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryLabelArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryLabelByNameArgs = {
  name: Scalars['String'];
};


/** The root query type which gives access points into the data universe. */
export type QueryLabelsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<LabelCondition>;
  filter?: InputMaybe<LabelFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LabelsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryLeadGenCampaignArgs = {
  id: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type QueryLeadGenCampaignStatsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<LeadGenCampaignStatCondition>;
  filter?: InputMaybe<LeadGenCampaignStatFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LeadGenCampaignStatsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryLeadGenCampaignsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<LeadGenCampaignCondition>;
  filter?: InputMaybe<LeadGenCampaignFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LeadGenCampaignsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryLeadGenViewArgs = {
  id: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type QueryLeadGenViewByLeadGenCampaignIdAndBrowserInstanceIdArgs = {
  browserInstanceId: Scalars['String'];
  leadGenCampaignId: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type QueryLeadGenViewsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<LeadGenViewCondition>;
  filter?: InputMaybe<LeadGenViewFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LeadGenViewsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryLineItemArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryLineItemByCampaignIdAndLineItemNumberArgs = {
  campaignId: Scalars['UUID'];
  lineItemNumber: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type QueryLineItemByExternalPioIdArgs = {
  externalPioId: Scalars['String'];
};


/** The root query type which gives access points into the data universe. */
export type QueryLineItemDeliveriesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<LineItemDeliveryCondition>;
  filter?: InputMaybe<LineItemDeliveryFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LineItemDeliveriesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryLineItemDeliveryArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryLineItemDeliveryByLineItemIdAndPeriodStartAndPeriodEndAndSourceArgs = {
  lineItemId: Scalars['UUID'];
  periodEnd: Scalars['Date'];
  periodStart: Scalars['Date'];
  source: LineItemDeliverySource;
};


/** The root query type which gives access points into the data universe. */
export type QueryLineItemLabelArgs = {
  labelId: Scalars['UUID'];
  placementsLineItemId: Scalars['String'];
};


/** The root query type which gives access points into the data universe. */
export type QueryLineItemLabelsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<LineItemLabelCondition>;
  filter?: InputMaybe<LineItemLabelFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LineItemLabelsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryLineItemsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<LineItemCondition>;
  filter?: InputMaybe<LineItemFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LineItemsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryPioUserArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryPioUserByEmailArgs = {
  email: Scalars['String'];
};


/** The root query type which gives access points into the data universe. */
export type QueryPioUserByExternalPioIdArgs = {
  externalPioId: Scalars['String'];
};


/** The root query type which gives access points into the data universe. */
export type QueryPioUsersArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PioUserCondition>;
  filter?: InputMaybe<PioUserFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PioUsersOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryProductArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryProductsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ProductCondition>;
  filter?: InputMaybe<ProductFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProductsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryProfessionArgs = {
  id: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type QueryProfessionsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ProfessionCondition>;
  filter?: InputMaybe<ProfessionFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProfessionsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QuerySpecialtiesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<SpecialtyCondition>;
  filter?: InputMaybe<SpecialtyFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<SpecialtiesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QuerySpecialtyArgs = {
  id: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type QuerySpecialtyGroupArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QuerySpecialtyGroupsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<SpecialtyGroupCondition>;
  filter?: InputMaybe<SpecialtyGroupFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<SpecialtyGroupsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QuerySponsoredContentTeaserArgs = {
  id: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type QuerySponsoredContentTeaserProfessionArgs = {
  professionId: Scalars['Int'];
  sponsoredContentTeaserId: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type QuerySponsoredContentTeaserProfessionsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<SponsoredContentTeaserProfessionCondition>;
  filter?: InputMaybe<SponsoredContentTeaserProfessionFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<SponsoredContentTeaserProfessionsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QuerySponsoredContentTeaserSpecialtiesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<SponsoredContentTeaserSpecialtyCondition>;
  filter?: InputMaybe<SponsoredContentTeaserSpecialtyFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<SponsoredContentTeaserSpecialtiesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QuerySponsoredContentTeaserSpecialtyArgs = {
  specialtyId: Scalars['Int'];
  sponsoredContentTeaserId: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type QuerySponsoredContentTeaserTargetListArgs = {
  sponsoredContentTeaserId: Scalars['Int'];
  targetListId: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type QuerySponsoredContentTeaserTargetListsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<SponsoredContentTeaserTargetListCondition>;
  filter?: InputMaybe<SponsoredContentTeaserTargetListFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<SponsoredContentTeaserTargetListsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QuerySponsoredContentTeasersArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<SponsoredContentTeaserCondition>;
  filter?: InputMaybe<SponsoredContentTeaserFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<SponsoredContentTeasersOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryTargetListArgs = {
  id: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type QueryTargetListsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<TargetListCondition>;
  filter?: InputMaybe<TargetListFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TargetListsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryTopicTagArgs = {
  id: Scalars['String'];
};


/** The root query type which gives access points into the data universe. */
export type QueryTopicTagsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<TopicTagCondition>;
  filter?: InputMaybe<TopicTagFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TopicTagsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryUserLeadGenCampaignArgs = {
  userBrowserInstanceId?: InputMaybe<Scalars['String']>;
  userNpi?: InputMaybe<Scalars['BigInt']>;
};

/** All input for the `recordLeadGenConversion` mutation. */
export type RecordLeadGenConversionInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  pBrowserInstanceId?: InputMaybe<Scalars['String']>;
  pCampaignId?: InputMaybe<Scalars['Int']>;
};

/** The output of our `recordLeadGenConversion` mutation. */
export type RecordLeadGenConversionPayload = {
  __typename?: 'RecordLeadGenConversionPayload';
  boolean?: Maybe<Scalars['Boolean']>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** All input for the `recordLeadGenView` mutation. */
export type RecordLeadGenViewInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  pAjsAnonymousId?: InputMaybe<Scalars['String']>;
  pBrowserInstanceId?: InputMaybe<Scalars['String']>;
  pCampaignId?: InputMaybe<Scalars['Int']>;
  pIpAddress?: InputMaybe<Scalars['String']>;
  pNpi?: InputMaybe<Scalars['BigInt']>;
  pReferrer?: InputMaybe<Scalars['String']>;
  pUid?: InputMaybe<Scalars['String']>;
  pUserAgent?: InputMaybe<Scalars['String']>;
};

/** The output of our `recordLeadGenView` mutation. */
export type RecordLeadGenViewPayload = {
  __typename?: 'RecordLeadGenViewPayload';
  boolean?: Maybe<Scalars['Boolean']>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** All input for the `setClicksCreativeHideOnDays` mutation. */
export type SetClicksCreativeHideOnDaysInput = {
  clicksCreativeId: Scalars['Int'];
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  daysToHide: Array<InputMaybe<DayOfWeekType>>;
};

/** The output of our `setClicksCreativeHideOnDays` mutation. */
export type SetClicksCreativeHideOnDaysPayload = {
  __typename?: 'SetClicksCreativeHideOnDaysPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** All input for the `setClicksCreativeProfessions` mutation. */
export type SetClicksCreativeProfessionsInput = {
  clicksCreativeId: Scalars['Int'];
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  professionIds: Array<InputMaybe<Scalars['Int']>>;
};

/** The output of our `setClicksCreativeProfessions` mutation. */
export type SetClicksCreativeProfessionsPayload = {
  __typename?: 'SetClicksCreativeProfessionsPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** All input for the `setClicksCreativeSpecialties` mutation. */
export type SetClicksCreativeSpecialtiesInput = {
  clicksCreativeId: Scalars['Int'];
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  specialtyIds: Array<InputMaybe<Scalars['Int']>>;
};

/** The output of our `setClicksCreativeSpecialties` mutation. */
export type SetClicksCreativeSpecialtiesPayload = {
  __typename?: 'SetClicksCreativeSpecialtiesPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** All input for the `setClicksCreativeTargetLists` mutation. */
export type SetClicksCreativeTargetListsInput = {
  clicksCreativeId: Scalars['Int'];
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  targetListIds: Array<InputMaybe<Scalars['Int']>>;
};

/** The output of our `setClicksCreativeTargetLists` mutation. */
export type SetClicksCreativeTargetListsPayload = {
  __typename?: 'SetClicksCreativeTargetListsPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** All input for the `setEndemicDriverProfessions` mutation. */
export type SetEndemicDriverProfessionsInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  endemicDriverId: Scalars['Int'];
  professionIds: Array<InputMaybe<Scalars['Int']>>;
};

/** The output of our `setEndemicDriverProfessions` mutation. */
export type SetEndemicDriverProfessionsPayload = {
  __typename?: 'SetEndemicDriverProfessionsPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** All input for the `setEndemicDriverSpecialties` mutation. */
export type SetEndemicDriverSpecialtiesInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  endemicDriverId: Scalars['Int'];
  specialtyIds: Array<InputMaybe<Scalars['Int']>>;
};

/** The output of our `setEndemicDriverSpecialties` mutation. */
export type SetEndemicDriverSpecialtiesPayload = {
  __typename?: 'SetEndemicDriverSpecialtiesPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** All input for the `setEndemicDriverTargetLists` mutation. */
export type SetEndemicDriverTargetListsInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  endemicDriverId: Scalars['Int'];
  targetListIds: Array<InputMaybe<Scalars['Int']>>;
};

/** The output of our `setEndemicDriverTargetLists` mutation. */
export type SetEndemicDriverTargetListsPayload = {
  __typename?: 'SetEndemicDriverTargetListsPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** All input for the `setEndemicDriverTopicTags` mutation. */
export type SetEndemicDriverTopicTagsInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  endemicDriverId: Scalars['Int'];
  topicTagIds: Array<InputMaybe<Scalars['String']>>;
};

/** The output of our `setEndemicDriverTopicTags` mutation. */
export type SetEndemicDriverTopicTagsPayload = {
  __typename?: 'SetEndemicDriverTopicTagsPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** All input for the `setFmaCreativeTargetLists` mutation. */
export type SetFmaCreativeTargetListsInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  fmaCreativeId: Scalars['Int'];
  targetListIds: Array<InputMaybe<Scalars['Int']>>;
};

/** The output of our `setFmaCreativeTargetLists` mutation. */
export type SetFmaCreativeTargetListsPayload = {
  __typename?: 'SetFmaCreativeTargetListsPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** All input for the `setLeadGenCampaignTargetLists` mutation. */
export type SetLeadGenCampaignTargetListsInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  leadGenCampaignId: Scalars['Int'];
  targetListIds: Array<InputMaybe<Scalars['Int']>>;
};

/** The output of our `setLeadGenCampaignTargetLists` mutation. */
export type SetLeadGenCampaignTargetListsPayload = {
  __typename?: 'SetLeadGenCampaignTargetListsPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** All input for the `setSponsoredContentTeaserProfessions` mutation. */
export type SetSponsoredContentTeaserProfessionsInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  professionIds: Array<InputMaybe<Scalars['Int']>>;
  sponsoredContentTeaserId: Scalars['Int'];
};

/** The output of our `setSponsoredContentTeaserProfessions` mutation. */
export type SetSponsoredContentTeaserProfessionsPayload = {
  __typename?: 'SetSponsoredContentTeaserProfessionsPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** All input for the `setSponsoredContentTeaserSpecialties` mutation. */
export type SetSponsoredContentTeaserSpecialtiesInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  specialtyIds: Array<InputMaybe<Scalars['Int']>>;
  sponsoredContentTeaserId: Scalars['Int'];
};

/** The output of our `setSponsoredContentTeaserSpecialties` mutation. */
export type SetSponsoredContentTeaserSpecialtiesPayload = {
  __typename?: 'SetSponsoredContentTeaserSpecialtiesPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** All input for the `setSponsoredContentTeaserTargetLists` mutation. */
export type SetSponsoredContentTeaserTargetListsInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  sponsoredContentTeaserId: Scalars['Int'];
  targetListIds: Array<InputMaybe<Scalars['Int']>>;
};

/** The output of our `setSponsoredContentTeaserTargetLists` mutation. */
export type SetSponsoredContentTeaserTargetListsPayload = {
  __typename?: 'SetSponsoredContentTeaserTargetListsPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** All input for the `setTargetListLineItems` mutation. */
export type SetTargetListLineItemsInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  lineItemIds: Array<InputMaybe<Scalars['String']>>;
  targetListId: Scalars['Int'];
};

/** The output of our `setTargetListLineItems` mutation. */
export type SetTargetListLineItemsPayload = {
  __typename?: 'SetTargetListLineItemsPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** All input for the `setTargetListNpis` mutation. */
export type SetTargetListNpisInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  npis: Array<InputMaybe<Scalars['Int']>>;
  targetListId: Scalars['Int'];
};

/** The output of our `setTargetListNpis` mutation. */
export type SetTargetListNpisPayload = {
  __typename?: 'SetTargetListNpisPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** A connection to a list of `Specialty` values. */
export type SpecialtiesConnection = {
  __typename?: 'SpecialtiesConnection';
  /** A list of edges which contains the `Specialty` and cursor to aid in pagination. */
  edges: Array<SpecialtiesEdge>;
  /** A list of `Specialty` objects. */
  nodes: Array<Specialty>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Specialty` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Specialty` edge in the connection. */
export type SpecialtiesEdge = {
  __typename?: 'SpecialtiesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `Specialty` at the end of the edge. */
  node: Specialty;
};

/** Methods to use when ordering `Specialty`. */
export enum SpecialtiesOrderBy {
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  SlugAsc = 'SLUG_ASC',
  SlugDesc = 'SLUG_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC'
}

/** Specialties that can be used for targeting, based on page specialty tag or user specialty. */
export type Specialty = {
  __typename?: 'Specialty';
  createdAt: Scalars['Datetime'];
  id: Scalars['Int'];
  name: Scalars['String'];
  slug: Scalars['String'];
  /** Reads and enables pagination through a set of `SponsoredContentTeaserSpecialty`. */
  sponsoredContentTeaserSpecialties: SponsoredContentTeaserSpecialtiesConnection;
  updatedAt: Scalars['Datetime'];
};


/** Specialties that can be used for targeting, based on page specialty tag or user specialty. */
export type SpecialtySponsoredContentTeaserSpecialtiesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<SponsoredContentTeaserSpecialtyCondition>;
  filter?: InputMaybe<SponsoredContentTeaserSpecialtyFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<SponsoredContentTeaserSpecialtiesOrderBy>>;
};

/**
 * A condition to be used against `Specialty` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type SpecialtyCondition = {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `slug` field. */
  slug?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** A filter to be used against `Specialty` object types. All fields are combined with a logical ‘and.’ */
export type SpecialtyFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<SpecialtyFilter>>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<SpecialtyFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<SpecialtyFilter>>;
  /** Filter by the object’s `slug` field. */
  slug?: InputMaybe<StringFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
};

/** PIO specialty group reference data. Separate from existing app_public.specialties until specialty CRUD reconciliation is decided. */
export type SpecialtyGroup = {
  __typename?: 'SpecialtyGroup';
  createdAt: Scalars['Datetime'];
  externalPioId?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  name: Scalars['String'];
  updatedAt: Scalars['Datetime'];
};

/**
 * A condition to be used against `SpecialtyGroup` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type SpecialtyGroupCondition = {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `externalPioId` field. */
  externalPioId?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** A filter to be used against `SpecialtyGroup` object types. All fields are combined with a logical ‘and.’ */
export type SpecialtyGroupFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<SpecialtyGroupFilter>>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `externalPioId` field. */
  externalPioId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<SpecialtyGroupFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<SpecialtyGroupFilter>>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
};

/** An input for mutations affecting `SpecialtyGroup` */
export type SpecialtyGroupInput = {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  externalPioId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  name: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** Represents an update to a `SpecialtyGroup`. Fields that are set will be updated. */
export type SpecialtyGroupPatch = {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  externalPioId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** A connection to a list of `SpecialtyGroup` values. */
export type SpecialtyGroupsConnection = {
  __typename?: 'SpecialtyGroupsConnection';
  /** A list of edges which contains the `SpecialtyGroup` and cursor to aid in pagination. */
  edges: Array<SpecialtyGroupsEdge>;
  /** A list of `SpecialtyGroup` objects. */
  nodes: Array<SpecialtyGroup>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `SpecialtyGroup` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `SpecialtyGroup` edge in the connection. */
export type SpecialtyGroupsEdge = {
  __typename?: 'SpecialtyGroupsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `SpecialtyGroup` at the end of the edge. */
  node: SpecialtyGroup;
};

/** Methods to use when ordering `SpecialtyGroup`. */
export enum SpecialtyGroupsOrderBy {
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  ExternalPioIdAsc = 'EXTERNAL_PIO_ID_ASC',
  ExternalPioIdDesc = 'EXTERNAL_PIO_ID_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC'
}

/** An input for mutations affecting `Specialty` */
export type SpecialtyInput = {
  name: Scalars['String'];
  slug: Scalars['String'];
};

/** Represents an update to a `Specialty`. Fields that are set will be updated. */
export type SpecialtyPatch = {
  name?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
};

export type SponsoredContentTeaser = {
  __typename?: 'SponsoredContentTeaser';
  /** Sponsor/Company/Brand name for the Sponsored Content Teaser. */
  companyName: Scalars['String'];
  contentId: Scalars['String'];
  createdAt: Scalars['Datetime'];
  endsAt: Scalars['Datetime'];
  id: Scalars['Int'];
  isApproved?: Maybe<Scalars['Boolean']>;
  /** Reads a single `LineItem` that is related to this `SponsoredContentTeaser`. */
  lineItem?: Maybe<LineItem>;
  /** Native CSAdmin line item FK added for PIO migration parallel-run; placements_line_item_id remains for rollback. */
  lineItemId?: Maybe<Scalars['UUID']>;
  placementsCampaignId?: Maybe<Scalars['String']>;
  placementsLineItemId?: Maybe<Scalars['String']>;
  priority: Scalars['Int'];
  professionIdsList?: Maybe<Array<Maybe<Scalars['Int']>>>;
  /** Get the professions associated with this sponsored content teaser. */
  professions: ProfessionsConnection;
  /** Get the specialties associated with this sponsored content teaser. */
  specialties: SpecialtiesConnection;
  specialtyIdsList?: Maybe<Array<Maybe<Scalars['Int']>>>;
  /** Reads and enables pagination through a set of `SponsoredContentTeaserProfession`. */
  sponsoredContentTeaserProfessions: SponsoredContentTeaserProfessionsConnection;
  /** Reads and enables pagination through a set of `SponsoredContentTeaserSpecialty`. */
  sponsoredContentTeaserSpecialties: SponsoredContentTeaserSpecialtiesConnection;
  /** Reads and enables pagination through a set of `SponsoredContentTeaserTargetList`. */
  sponsoredContentTeaserTargetLists: SponsoredContentTeaserTargetListsConnection;
  startsAt: Scalars['Datetime'];
  targetListIdsList?: Maybe<Array<Maybe<Scalars['Int']>>>;
  /** Get the target lists associated with this sponsored content teaser. */
  targetLists: TargetListsConnection;
  targetingType?: Maybe<ClicksCreativeTargetingType>;
  title: Scalars['String'];
  updatedAt: Scalars['Datetime'];
};


export type SponsoredContentTeaserProfessionIdsListArgs = {
  filter?: InputMaybe<IntFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type SponsoredContentTeaserProfessionsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  filter?: InputMaybe<ProfessionFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type SponsoredContentTeaserSpecialtiesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  filter?: InputMaybe<SpecialtyFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type SponsoredContentTeaserSpecialtyIdsListArgs = {
  filter?: InputMaybe<IntFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type SponsoredContentTeaserSponsoredContentTeaserProfessionsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<SponsoredContentTeaserProfessionCondition>;
  filter?: InputMaybe<SponsoredContentTeaserProfessionFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<SponsoredContentTeaserProfessionsOrderBy>>;
};


export type SponsoredContentTeaserSponsoredContentTeaserSpecialtiesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<SponsoredContentTeaserSpecialtyCondition>;
  filter?: InputMaybe<SponsoredContentTeaserSpecialtyFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<SponsoredContentTeaserSpecialtiesOrderBy>>;
};


export type SponsoredContentTeaserSponsoredContentTeaserTargetListsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<SponsoredContentTeaserTargetListCondition>;
  filter?: InputMaybe<SponsoredContentTeaserTargetListFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<SponsoredContentTeaserTargetListsOrderBy>>;
};


export type SponsoredContentTeaserTargetListIdsListArgs = {
  filter?: InputMaybe<IntFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type SponsoredContentTeaserTargetListsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  filter?: InputMaybe<TargetListFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

/**
 * A condition to be used against `SponsoredContentTeaser` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type SponsoredContentTeaserCondition = {
  /** Checks for equality with the object’s `companyName` field. */
  companyName?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `contentId` field. */
  contentId?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `endsAt` field. */
  endsAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `isApproved` field. */
  isApproved?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `lineItemId` field. */
  lineItemId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `placementsCampaignId` field. */
  placementsCampaignId?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `placementsLineItemId` field. */
  placementsLineItemId?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `priority` field. */
  priority?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `startsAt` field. */
  startsAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `targetingType` field. */
  targetingType?: InputMaybe<ClicksCreativeTargetingType>;
  /** Checks for equality with the object’s `title` field. */
  title?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** A filter to be used against `SponsoredContentTeaser` object types. All fields are combined with a logical ‘and.’ */
export type SponsoredContentTeaserFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<SponsoredContentTeaserFilter>>;
  /** Filter by the object’s `companyName` field. */
  companyName?: InputMaybe<StringFilter>;
  /** Filter by the object’s `contentId` field. */
  contentId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `endsAt` field. */
  endsAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `isApproved` field. */
  isApproved?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `lineItemId` field. */
  lineItemId?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<SponsoredContentTeaserFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<SponsoredContentTeaserFilter>>;
  /** Filter by the object’s `placementsCampaignId` field. */
  placementsCampaignId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `placementsLineItemId` field. */
  placementsLineItemId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `priority` field. */
  priority?: InputMaybe<IntFilter>;
  /** Filter by the object’s `startsAt` field. */
  startsAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `targetingType` field. */
  targetingType?: InputMaybe<ClicksCreativeTargetingTypeFilter>;
  /** Filter by the object’s `title` field. */
  title?: InputMaybe<StringFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
};

/** An input for mutations affecting `SponsoredContentTeaser` */
export type SponsoredContentTeaserInput = {
  /** Sponsor/Company/Brand name for the Sponsored Content Teaser. */
  companyName: Scalars['String'];
  contentId: Scalars['String'];
  createdAt?: InputMaybe<Scalars['Datetime']>;
  endsAt: Scalars['Datetime'];
  id?: InputMaybe<Scalars['Int']>;
  isApproved?: InputMaybe<Scalars['Boolean']>;
  /** Native CSAdmin line item FK added for PIO migration parallel-run; placements_line_item_id remains for rollback. */
  lineItemId?: InputMaybe<Scalars['UUID']>;
  placementsCampaignId?: InputMaybe<Scalars['String']>;
  placementsLineItemId?: InputMaybe<Scalars['String']>;
  priority?: InputMaybe<Scalars['Int']>;
  startsAt: Scalars['Datetime'];
  targetingType?: InputMaybe<ClicksCreativeTargetingType>;
  title: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** Represents an update to a `SponsoredContentTeaser`. Fields that are set will be updated. */
export type SponsoredContentTeaserPatch = {
  /** Sponsor/Company/Brand name for the Sponsored Content Teaser. */
  companyName?: InputMaybe<Scalars['String']>;
  contentId?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  endsAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['Int']>;
  isApproved?: InputMaybe<Scalars['Boolean']>;
  /** Native CSAdmin line item FK added for PIO migration parallel-run; placements_line_item_id remains for rollback. */
  lineItemId?: InputMaybe<Scalars['UUID']>;
  placementsCampaignId?: InputMaybe<Scalars['String']>;
  placementsLineItemId?: InputMaybe<Scalars['String']>;
  priority?: InputMaybe<Scalars['Int']>;
  startsAt?: InputMaybe<Scalars['Datetime']>;
  targetingType?: InputMaybe<ClicksCreativeTargetingType>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

export type SponsoredContentTeaserProfession = {
  __typename?: 'SponsoredContentTeaserProfession';
  createdAt: Scalars['Datetime'];
  /** Reads a single `Profession` that is related to this `SponsoredContentTeaserProfession`. */
  profession?: Maybe<Profession>;
  professionId: Scalars['Int'];
  /** Reads a single `SponsoredContentTeaser` that is related to this `SponsoredContentTeaserProfession`. */
  sponsoredContentTeaser?: Maybe<SponsoredContentTeaser>;
  sponsoredContentTeaserId: Scalars['Int'];
};

/**
 * A condition to be used against `SponsoredContentTeaserProfession` object types.
 * All fields are tested for equality and combined with a logical ‘and.’
 */
export type SponsoredContentTeaserProfessionCondition = {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `professionId` field. */
  professionId?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `sponsoredContentTeaserId` field. */
  sponsoredContentTeaserId?: InputMaybe<Scalars['Int']>;
};

/** A filter to be used against `SponsoredContentTeaserProfession` object types. All fields are combined with a logical ‘and.’ */
export type SponsoredContentTeaserProfessionFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<SponsoredContentTeaserProfessionFilter>>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Negates the expression. */
  not?: InputMaybe<SponsoredContentTeaserProfessionFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<SponsoredContentTeaserProfessionFilter>>;
  /** Filter by the object’s `professionId` field. */
  professionId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `sponsoredContentTeaserId` field. */
  sponsoredContentTeaserId?: InputMaybe<IntFilter>;
};

/** An input for mutations affecting `SponsoredContentTeaserProfession` */
export type SponsoredContentTeaserProfessionInput = {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  professionId: Scalars['Int'];
  sponsoredContentTeaserId: Scalars['Int'];
};

/** Represents an update to a `SponsoredContentTeaserProfession`. Fields that are set will be updated. */
export type SponsoredContentTeaserProfessionPatch = {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  professionId?: InputMaybe<Scalars['Int']>;
  sponsoredContentTeaserId?: InputMaybe<Scalars['Int']>;
};

/** A connection to a list of `SponsoredContentTeaserProfession` values. */
export type SponsoredContentTeaserProfessionsConnection = {
  __typename?: 'SponsoredContentTeaserProfessionsConnection';
  /** A list of edges which contains the `SponsoredContentTeaserProfession` and cursor to aid in pagination. */
  edges: Array<SponsoredContentTeaserProfessionsEdge>;
  /** A list of `SponsoredContentTeaserProfession` objects. */
  nodes: Array<SponsoredContentTeaserProfession>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `SponsoredContentTeaserProfession` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `SponsoredContentTeaserProfession` edge in the connection. */
export type SponsoredContentTeaserProfessionsEdge = {
  __typename?: 'SponsoredContentTeaserProfessionsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `SponsoredContentTeaserProfession` at the end of the edge. */
  node: SponsoredContentTeaserProfession;
};

/** Methods to use when ordering `SponsoredContentTeaserProfession`. */
export enum SponsoredContentTeaserProfessionsOrderBy {
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  ProfessionIdAsc = 'PROFESSION_ID_ASC',
  ProfessionIdDesc = 'PROFESSION_ID_DESC',
  SponsoredContentTeaserIdAsc = 'SPONSORED_CONTENT_TEASER_ID_ASC',
  SponsoredContentTeaserIdDesc = 'SPONSORED_CONTENT_TEASER_ID_DESC'
}

/** A connection to a list of `SponsoredContentTeaserSpecialty` values. */
export type SponsoredContentTeaserSpecialtiesConnection = {
  __typename?: 'SponsoredContentTeaserSpecialtiesConnection';
  /** A list of edges which contains the `SponsoredContentTeaserSpecialty` and cursor to aid in pagination. */
  edges: Array<SponsoredContentTeaserSpecialtiesEdge>;
  /** A list of `SponsoredContentTeaserSpecialty` objects. */
  nodes: Array<SponsoredContentTeaserSpecialty>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `SponsoredContentTeaserSpecialty` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `SponsoredContentTeaserSpecialty` edge in the connection. */
export type SponsoredContentTeaserSpecialtiesEdge = {
  __typename?: 'SponsoredContentTeaserSpecialtiesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `SponsoredContentTeaserSpecialty` at the end of the edge. */
  node: SponsoredContentTeaserSpecialty;
};

/** Methods to use when ordering `SponsoredContentTeaserSpecialty`. */
export enum SponsoredContentTeaserSpecialtiesOrderBy {
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  SpecialtyIdAsc = 'SPECIALTY_ID_ASC',
  SpecialtyIdDesc = 'SPECIALTY_ID_DESC',
  SponsoredContentTeaserIdAsc = 'SPONSORED_CONTENT_TEASER_ID_ASC',
  SponsoredContentTeaserIdDesc = 'SPONSORED_CONTENT_TEASER_ID_DESC'
}

export type SponsoredContentTeaserSpecialty = {
  __typename?: 'SponsoredContentTeaserSpecialty';
  createdAt: Scalars['Datetime'];
  /** Reads a single `Specialty` that is related to this `SponsoredContentTeaserSpecialty`. */
  specialty?: Maybe<Specialty>;
  specialtyId: Scalars['Int'];
  /** Reads a single `SponsoredContentTeaser` that is related to this `SponsoredContentTeaserSpecialty`. */
  sponsoredContentTeaser?: Maybe<SponsoredContentTeaser>;
  sponsoredContentTeaserId: Scalars['Int'];
};

/**
 * A condition to be used against `SponsoredContentTeaserSpecialty` object types.
 * All fields are tested for equality and combined with a logical ‘and.’
 */
export type SponsoredContentTeaserSpecialtyCondition = {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `specialtyId` field. */
  specialtyId?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `sponsoredContentTeaserId` field. */
  sponsoredContentTeaserId?: InputMaybe<Scalars['Int']>;
};

/** A filter to be used against `SponsoredContentTeaserSpecialty` object types. All fields are combined with a logical ‘and.’ */
export type SponsoredContentTeaserSpecialtyFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<SponsoredContentTeaserSpecialtyFilter>>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Negates the expression. */
  not?: InputMaybe<SponsoredContentTeaserSpecialtyFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<SponsoredContentTeaserSpecialtyFilter>>;
  /** Filter by the object’s `specialtyId` field. */
  specialtyId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `sponsoredContentTeaserId` field. */
  sponsoredContentTeaserId?: InputMaybe<IntFilter>;
};

/** An input for mutations affecting `SponsoredContentTeaserSpecialty` */
export type SponsoredContentTeaserSpecialtyInput = {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  specialtyId: Scalars['Int'];
  sponsoredContentTeaserId: Scalars['Int'];
};

/** Represents an update to a `SponsoredContentTeaserSpecialty`. Fields that are set will be updated. */
export type SponsoredContentTeaserSpecialtyPatch = {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  specialtyId?: InputMaybe<Scalars['Int']>;
  sponsoredContentTeaserId?: InputMaybe<Scalars['Int']>;
};

export type SponsoredContentTeaserTargetList = {
  __typename?: 'SponsoredContentTeaserTargetList';
  createdAt: Scalars['Datetime'];
  /** Reads a single `SponsoredContentTeaser` that is related to this `SponsoredContentTeaserTargetList`. */
  sponsoredContentTeaser?: Maybe<SponsoredContentTeaser>;
  sponsoredContentTeaserId: Scalars['Int'];
  /** Reads a single `TargetList` that is related to this `SponsoredContentTeaserTargetList`. */
  targetList?: Maybe<TargetList>;
  targetListId: Scalars['Int'];
};

/**
 * A condition to be used against `SponsoredContentTeaserTargetList` object types.
 * All fields are tested for equality and combined with a logical ‘and.’
 */
export type SponsoredContentTeaserTargetListCondition = {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `sponsoredContentTeaserId` field. */
  sponsoredContentTeaserId?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `targetListId` field. */
  targetListId?: InputMaybe<Scalars['Int']>;
};

/** A filter to be used against `SponsoredContentTeaserTargetList` object types. All fields are combined with a logical ‘and.’ */
export type SponsoredContentTeaserTargetListFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<SponsoredContentTeaserTargetListFilter>>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Negates the expression. */
  not?: InputMaybe<SponsoredContentTeaserTargetListFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<SponsoredContentTeaserTargetListFilter>>;
  /** Filter by the object’s `sponsoredContentTeaserId` field. */
  sponsoredContentTeaserId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `targetListId` field. */
  targetListId?: InputMaybe<IntFilter>;
};

/** An input for mutations affecting `SponsoredContentTeaserTargetList` */
export type SponsoredContentTeaserTargetListInput = {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  sponsoredContentTeaserId: Scalars['Int'];
  targetListId: Scalars['Int'];
};

/** Represents an update to a `SponsoredContentTeaserTargetList`. Fields that are set will be updated. */
export type SponsoredContentTeaserTargetListPatch = {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  sponsoredContentTeaserId?: InputMaybe<Scalars['Int']>;
  targetListId?: InputMaybe<Scalars['Int']>;
};

/** A connection to a list of `SponsoredContentTeaserTargetList` values. */
export type SponsoredContentTeaserTargetListsConnection = {
  __typename?: 'SponsoredContentTeaserTargetListsConnection';
  /** A list of edges which contains the `SponsoredContentTeaserTargetList` and cursor to aid in pagination. */
  edges: Array<SponsoredContentTeaserTargetListsEdge>;
  /** A list of `SponsoredContentTeaserTargetList` objects. */
  nodes: Array<SponsoredContentTeaserTargetList>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `SponsoredContentTeaserTargetList` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `SponsoredContentTeaserTargetList` edge in the connection. */
export type SponsoredContentTeaserTargetListsEdge = {
  __typename?: 'SponsoredContentTeaserTargetListsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `SponsoredContentTeaserTargetList` at the end of the edge. */
  node: SponsoredContentTeaserTargetList;
};

/** Methods to use when ordering `SponsoredContentTeaserTargetList`. */
export enum SponsoredContentTeaserTargetListsOrderBy {
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  SponsoredContentTeaserIdAsc = 'SPONSORED_CONTENT_TEASER_ID_ASC',
  SponsoredContentTeaserIdDesc = 'SPONSORED_CONTENT_TEASER_ID_DESC',
  TargetListIdAsc = 'TARGET_LIST_ID_ASC',
  TargetListIdDesc = 'TARGET_LIST_ID_DESC'
}

/** A connection to a list of `SponsoredContentTeaser` values. */
export type SponsoredContentTeasersConnection = {
  __typename?: 'SponsoredContentTeasersConnection';
  /** A list of edges which contains the `SponsoredContentTeaser` and cursor to aid in pagination. */
  edges: Array<SponsoredContentTeasersEdge>;
  /** A list of `SponsoredContentTeaser` objects. */
  nodes: Array<SponsoredContentTeaser>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `SponsoredContentTeaser` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `SponsoredContentTeaser` edge in the connection. */
export type SponsoredContentTeasersEdge = {
  __typename?: 'SponsoredContentTeasersEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `SponsoredContentTeaser` at the end of the edge. */
  node: SponsoredContentTeaser;
};

/** Methods to use when ordering `SponsoredContentTeaser`. */
export enum SponsoredContentTeasersOrderBy {
  CompanyNameAsc = 'COMPANY_NAME_ASC',
  CompanyNameDesc = 'COMPANY_NAME_DESC',
  ContentIdAsc = 'CONTENT_ID_ASC',
  ContentIdDesc = 'CONTENT_ID_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  EndsAtAsc = 'ENDS_AT_ASC',
  EndsAtDesc = 'ENDS_AT_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  IsApprovedAsc = 'IS_APPROVED_ASC',
  IsApprovedDesc = 'IS_APPROVED_DESC',
  LineItemIdAsc = 'LINE_ITEM_ID_ASC',
  LineItemIdDesc = 'LINE_ITEM_ID_DESC',
  Natural = 'NATURAL',
  PlacementsCampaignIdAsc = 'PLACEMENTS_CAMPAIGN_ID_ASC',
  PlacementsCampaignIdDesc = 'PLACEMENTS_CAMPAIGN_ID_DESC',
  PlacementsLineItemIdAsc = 'PLACEMENTS_LINE_ITEM_ID_ASC',
  PlacementsLineItemIdDesc = 'PLACEMENTS_LINE_ITEM_ID_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  PriorityAsc = 'PRIORITY_ASC',
  PriorityDesc = 'PRIORITY_DESC',
  StartsAtAsc = 'STARTS_AT_ASC',
  StartsAtDesc = 'STARTS_AT_DESC',
  TargetingTypeAsc = 'TARGETING_TYPE_ASC',
  TargetingTypeDesc = 'TARGETING_TYPE_DESC',
  TitleAsc = 'TITLE_ASC',
  TitleDesc = 'TITLE_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC'
}

/** A filter to be used against String fields. All fields are combined with a logical ‘and.’ */
export type StringFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Scalars['String']>;
  /** Not equal to the specified value, treating null like an ordinary value (case-insensitive). */
  distinctFromInsensitive?: InputMaybe<Scalars['String']>;
  /** Ends with the specified string (case-sensitive). */
  endsWith?: InputMaybe<Scalars['String']>;
  /** Ends with the specified string (case-insensitive). */
  endsWithInsensitive?: InputMaybe<Scalars['String']>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Scalars['String']>;
  /** Equal to the specified value (case-insensitive). */
  equalToInsensitive?: InputMaybe<Scalars['String']>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Scalars['String']>;
  /** Greater than the specified value (case-insensitive). */
  greaterThanInsensitive?: InputMaybe<Scalars['String']>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Scalars['String']>;
  /** Greater than or equal to the specified value (case-insensitive). */
  greaterThanOrEqualToInsensitive?: InputMaybe<Scalars['String']>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<Scalars['String']>>;
  /** Included in the specified list (case-insensitive). */
  inInsensitive?: InputMaybe<Array<Scalars['String']>>;
  /** Contains the specified string (case-sensitive). */
  includes?: InputMaybe<Scalars['String']>;
  /** Contains the specified string (case-insensitive). */
  includesInsensitive?: InputMaybe<Scalars['String']>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Scalars['String']>;
  /** Less than the specified value (case-insensitive). */
  lessThanInsensitive?: InputMaybe<Scalars['String']>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Scalars['String']>;
  /** Less than or equal to the specified value (case-insensitive). */
  lessThanOrEqualToInsensitive?: InputMaybe<Scalars['String']>;
  /** Matches the specified pattern (case-sensitive). An underscore (_) matches any single character; a percent sign (%) matches any sequence of zero or more characters. */
  like?: InputMaybe<Scalars['String']>;
  /** Matches the specified pattern (case-insensitive). An underscore (_) matches any single character; a percent sign (%) matches any sequence of zero or more characters. */
  likeInsensitive?: InputMaybe<Scalars['String']>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Scalars['String']>;
  /** Equal to the specified value, treating null like an ordinary value (case-insensitive). */
  notDistinctFromInsensitive?: InputMaybe<Scalars['String']>;
  /** Does not end with the specified string (case-sensitive). */
  notEndsWith?: InputMaybe<Scalars['String']>;
  /** Does not end with the specified string (case-insensitive). */
  notEndsWithInsensitive?: InputMaybe<Scalars['String']>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Scalars['String']>;
  /** Not equal to the specified value (case-insensitive). */
  notEqualToInsensitive?: InputMaybe<Scalars['String']>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Scalars['String']>>;
  /** Not included in the specified list (case-insensitive). */
  notInInsensitive?: InputMaybe<Array<Scalars['String']>>;
  /** Does not contain the specified string (case-sensitive). */
  notIncludes?: InputMaybe<Scalars['String']>;
  /** Does not contain the specified string (case-insensitive). */
  notIncludesInsensitive?: InputMaybe<Scalars['String']>;
  /** Does not match the specified pattern (case-sensitive). An underscore (_) matches any single character; a percent sign (%) matches any sequence of zero or more characters. */
  notLike?: InputMaybe<Scalars['String']>;
  /** Does not match the specified pattern (case-insensitive). An underscore (_) matches any single character; a percent sign (%) matches any sequence of zero or more characters. */
  notLikeInsensitive?: InputMaybe<Scalars['String']>;
  /** Does not start with the specified string (case-sensitive). */
  notStartsWith?: InputMaybe<Scalars['String']>;
  /** Does not start with the specified string (case-insensitive). */
  notStartsWithInsensitive?: InputMaybe<Scalars['String']>;
  /** Starts with the specified string (case-sensitive). */
  startsWith?: InputMaybe<Scalars['String']>;
  /** Starts with the specified string (case-insensitive). */
  startsWithInsensitive?: InputMaybe<Scalars['String']>;
};

/** A filter to be used against String List fields. All fields are combined with a logical ‘and.’ */
export type StringListFilter = {
  /** Any array item is equal to the specified value. */
  anyEqualTo?: InputMaybe<Scalars['String']>;
  /** Any array item is greater than the specified value. */
  anyGreaterThan?: InputMaybe<Scalars['String']>;
  /** Any array item is greater than or equal to the specified value. */
  anyGreaterThanOrEqualTo?: InputMaybe<Scalars['String']>;
  /** Any array item is less than the specified value. */
  anyLessThan?: InputMaybe<Scalars['String']>;
  /** Any array item is less than or equal to the specified value. */
  anyLessThanOrEqualTo?: InputMaybe<Scalars['String']>;
  /** Any array item is not equal to the specified value. */
  anyNotEqualTo?: InputMaybe<Scalars['String']>;
  /** Contained by the specified list of values. */
  containedBy?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Contains the specified list of values. */
  contains?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Overlaps the specified list of values. */
  overlaps?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

/** A target list. */
export type TargetList = {
  __typename?: 'TargetList';
  bannerLineItemRefsList?: Maybe<Array<Maybe<Scalars['JSON']>>>;
  bannerPlacementLineItemIdsList?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Reads and enables pagination through a set of `BannerTargeting`. */
  bannerTargetings: BannerTargetingsConnection;
  clicksCreativeIdsList?: Maybe<Array<Maybe<Scalars['Int']>>>;
  clicksLineItemRefsList?: Maybe<Array<Maybe<Scalars['JSON']>>>;
  clicksPlacementLineItemIdsList?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Timestamp when the target list was created */
  createdAt: Scalars['Datetime'];
  /** Optional comment with a more detailed description of the target list. */
  description?: Maybe<Scalars['String']>;
  /** Reads and enables pagination through a set of `EndemicDriverTargetList`. */
  endemicDriverTargetLists: EndemicDriverTargetListsConnection;
  fmaCreativeIdsList?: Maybe<Array<Maybe<Scalars['Int']>>>;
  fmaLineItemRefsList?: Maybe<Array<Maybe<Scalars['JSON']>>>;
  fmaPlacementLineItemIdsList?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** ID for the target group. */
  id: Scalars['Int'];
  /** Soft delete flag - archived target lists are hidden from dropdowns by default */
  isArchived: Scalars['Boolean'];
  /** Native-preferred target-list line item IDs for PIO migration dual reads; falls back to placements_line_item_id until backfill is complete. */
  lineItemIdsList?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** A name describing the target list. */
  name: Scalars['String'];
  npiCount?: Maybe<Scalars['Int']>;
  placementLineItemIdsList?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Reads and enables pagination through a set of `SponsoredContentTeaserTargetList`. */
  sponsoredContentTeaserTargetLists: SponsoredContentTeaserTargetListsConnection;
  /** Timestamp when the target list was last modified */
  updatedAt: Scalars['Datetime'];
  /** Date and time in UTC when the target list was most recently uploaded. Defaults to the current time. */
  uploadedAt: Scalars['Datetime'];
  /** Filename of the file that was most recently uploaded as the target list. */
  uploadedFilename: Scalars['String'];
};


/** A target list. */
export type TargetListBannerLineItemRefsListArgs = {
  filter?: InputMaybe<JsonFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


/** A target list. */
export type TargetListBannerPlacementLineItemIdsListArgs = {
  filter?: InputMaybe<StringFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


/** A target list. */
export type TargetListBannerTargetingsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<BannerTargetingCondition>;
  filter?: InputMaybe<BannerTargetingFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<BannerTargetingsOrderBy>>;
};


/** A target list. */
export type TargetListClicksCreativeIdsListArgs = {
  filter?: InputMaybe<IntFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


/** A target list. */
export type TargetListClicksLineItemRefsListArgs = {
  filter?: InputMaybe<JsonFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


/** A target list. */
export type TargetListClicksPlacementLineItemIdsListArgs = {
  filter?: InputMaybe<StringFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


/** A target list. */
export type TargetListEndemicDriverTargetListsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<EndemicDriverTargetListCondition>;
  filter?: InputMaybe<EndemicDriverTargetListFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EndemicDriverTargetListsOrderBy>>;
};


/** A target list. */
export type TargetListFmaCreativeIdsListArgs = {
  filter?: InputMaybe<IntFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


/** A target list. */
export type TargetListFmaLineItemRefsListArgs = {
  filter?: InputMaybe<JsonFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


/** A target list. */
export type TargetListFmaPlacementLineItemIdsListArgs = {
  filter?: InputMaybe<StringFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


/** A target list. */
export type TargetListLineItemIdsListArgs = {
  filter?: InputMaybe<StringFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


/** A target list. */
export type TargetListPlacementLineItemIdsListArgs = {
  filter?: InputMaybe<StringFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


/** A target list. */
export type TargetListSponsoredContentTeaserTargetListsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<SponsoredContentTeaserTargetListCondition>;
  filter?: InputMaybe<SponsoredContentTeaserTargetListFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<SponsoredContentTeaserTargetListsOrderBy>>;
};

/**
 * A condition to be used against `TargetList` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type TargetListCondition = {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `description` field. */
  description?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `isArchived` field. */
  isArchived?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `uploadedAt` field. */
  uploadedAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `uploadedFilename` field. */
  uploadedFilename?: InputMaybe<Scalars['String']>;
};

/** A filter to be used against `TargetList` object types. All fields are combined with a logical ‘and.’ */
export type TargetListFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<TargetListFilter>>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `description` field. */
  description?: InputMaybe<StringFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `isArchived` field. */
  isArchived?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<TargetListFilter>;
  /** Filter by the object’s `npiCount` field. */
  npiCount?: InputMaybe<IntFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<TargetListFilter>>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `uploadedAt` field. */
  uploadedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `uploadedFilename` field. */
  uploadedFilename?: InputMaybe<StringFilter>;
};

/** An input for mutations affecting `TargetList` */
export type TargetListInput = {
  /** Timestamp when the target list was created */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Optional comment with a more detailed description of the target list. */
  description?: InputMaybe<Scalars['String']>;
  /** ID for the target group. */
  id?: InputMaybe<Scalars['Int']>;
  /** Soft delete flag - archived target lists are hidden from dropdowns by default */
  isArchived?: InputMaybe<Scalars['Boolean']>;
  /** A name describing the target list. */
  name: Scalars['String'];
  /** Timestamp when the target list was last modified */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  /** Date and time in UTC when the target list was most recently uploaded. Defaults to the current time. */
  uploadedAt?: InputMaybe<Scalars['Datetime']>;
  /** Filename of the file that was most recently uploaded as the target list. */
  uploadedFilename: Scalars['String'];
};

/** Represents an update to a `TargetList`. Fields that are set will be updated. */
export type TargetListPatch = {
  /** Timestamp when the target list was created */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Optional comment with a more detailed description of the target list. */
  description?: InputMaybe<Scalars['String']>;
  /** ID for the target group. */
  id?: InputMaybe<Scalars['Int']>;
  /** Soft delete flag - archived target lists are hidden from dropdowns by default */
  isArchived?: InputMaybe<Scalars['Boolean']>;
  /** A name describing the target list. */
  name?: InputMaybe<Scalars['String']>;
  /** Timestamp when the target list was last modified */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  /** Date and time in UTC when the target list was most recently uploaded. Defaults to the current time. */
  uploadedAt?: InputMaybe<Scalars['Datetime']>;
  /** Filename of the file that was most recently uploaded as the target list. */
  uploadedFilename?: InputMaybe<Scalars['String']>;
};

/** A connection to a list of `TargetList` values. */
export type TargetListsConnection = {
  __typename?: 'TargetListsConnection';
  /** A list of edges which contains the `TargetList` and cursor to aid in pagination. */
  edges: Array<TargetListsEdge>;
  /** A list of `TargetList` objects. */
  nodes: Array<TargetList>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `TargetList` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `TargetList` edge in the connection. */
export type TargetListsEdge = {
  __typename?: 'TargetListsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `TargetList` at the end of the edge. */
  node: TargetList;
};

/** Methods to use when ordering `TargetList`. */
export enum TargetListsOrderBy {
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  DescriptionAsc = 'DESCRIPTION_ASC',
  DescriptionDesc = 'DESCRIPTION_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  IsArchivedAsc = 'IS_ARCHIVED_ASC',
  IsArchivedDesc = 'IS_ARCHIVED_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC',
  UploadedAtAsc = 'UPLOADED_AT_ASC',
  UploadedAtDesc = 'UPLOADED_AT_DESC',
  UploadedFilenameAsc = 'UPLOADED_FILENAME_ASC',
  UploadedFilenameDesc = 'UPLOADED_FILENAME_DESC'
}

export type TopicTag = {
  __typename?: 'TopicTag';
  createdAt: Scalars['Datetime'];
  /** Reads and enables pagination through a set of `EndemicDriverTopicTag`. */
  endemicDriverTopicTags: EndemicDriverTopicTagsConnection;
  id: Scalars['String'];
  name: Scalars['String'];
};


export type TopicTagEndemicDriverTopicTagsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<EndemicDriverTopicTagCondition>;
  filter?: InputMaybe<EndemicDriverTopicTagFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EndemicDriverTopicTagsOrderBy>>;
};

/**
 * A condition to be used against `TopicTag` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type TopicTagCondition = {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']>;
};

/** A filter to be used against `TopicTag` object types. All fields are combined with a logical ‘and.’ */
export type TopicTagFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<TopicTagFilter>>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<StringFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<TopicTagFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<TopicTagFilter>>;
};

/** An input for mutations affecting `TopicTag` */
export type TopicTagInput = {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  id: Scalars['String'];
  name: Scalars['String'];
};

/** Represents an update to a `TopicTag`. Fields that are set will be updated. */
export type TopicTagPatch = {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

/** A connection to a list of `TopicTag` values. */
export type TopicTagsConnection = {
  __typename?: 'TopicTagsConnection';
  /** A list of edges which contains the `TopicTag` and cursor to aid in pagination. */
  edges: Array<TopicTagsEdge>;
  /** A list of `TopicTag` objects. */
  nodes: Array<TopicTag>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `TopicTag` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `TopicTag` edge in the connection. */
export type TopicTagsEdge = {
  __typename?: 'TopicTagsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `TopicTag` at the end of the edge. */
  node: TopicTag;
};

/** Methods to use when ordering `TopicTag`. */
export enum TopicTagsOrderBy {
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC'
}

/** A filter to be used against UUID fields. All fields are combined with a logical ‘and.’ */
export type UuidFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Scalars['UUID']>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Scalars['UUID']>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Scalars['UUID']>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Scalars['UUID']>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<Scalars['UUID']>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Scalars['UUID']>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Scalars['UUID']>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Scalars['UUID']>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Scalars['UUID']>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Scalars['UUID']>>;
};

/** All input for the `updateAdvertiser` mutation. */
export type UpdateAdvertiserInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `Advertiser` being updated. */
  patch: AdvertiserPatch;
};

/** The output of our update `Advertiser` mutation. */
export type UpdateAdvertiserPayload = {
  __typename?: 'UpdateAdvertiserPayload';
  /** The `Advertiser` that was updated by this mutation. */
  advertiser?: Maybe<Advertiser>;
  /** An edge for our `Advertiser`. May be used by Relay 1. */
  advertiserEdge?: Maybe<AdvertisersEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Advertiser` that is related to this `Advertiser`. */
  parent?: Maybe<Advertiser>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `Advertiser` mutation. */
export type UpdateAdvertiserPayloadAdvertiserEdgeArgs = {
  orderBy?: InputMaybe<Array<AdvertisersOrderBy>>;
};

/** All input for the `updateBannerTargeting` mutation. */
export type UpdateBannerTargetingInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
  /** An object where the defined keys will be set on the `BannerTargeting` being updated. */
  patch: BannerTargetingPatch;
};

/** The output of our update `BannerTargeting` mutation. */
export type UpdateBannerTargetingPayload = {
  __typename?: 'UpdateBannerTargetingPayload';
  /** The `BannerTargeting` that was updated by this mutation. */
  bannerTargeting?: Maybe<BannerTargeting>;
  /** An edge for our `BannerTargeting`. May be used by Relay 1. */
  bannerTargetingEdge?: Maybe<BannerTargetingsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `LineItem` that is related to this `BannerTargeting`. */
  lineItem?: Maybe<LineItem>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `TargetList` that is related to this `BannerTargeting`. */
  targetList?: Maybe<TargetList>;
};


/** The output of our update `BannerTargeting` mutation. */
export type UpdateBannerTargetingPayloadBannerTargetingEdgeArgs = {
  orderBy?: InputMaybe<Array<BannerTargetingsOrderBy>>;
};

/** All input for the `updateCampaignByCampaignNumber` mutation. */
export type UpdateCampaignByCampaignNumberInput = {
  /** Four-digit PIO campaign number used by Client Services and preserved during import. */
  campaignNumber: Scalars['Int'];
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** An object where the defined keys will be set on the `Campaign` being updated. */
  patch: CampaignPatch;
};

/** All input for the `updateCampaignByExternalPioId` mutation. */
export type UpdateCampaignByExternalPioIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  externalPioId: Scalars['String'];
  /** An object where the defined keys will be set on the `Campaign` being updated. */
  patch: CampaignPatch;
};

/** All input for the `updateCampaign` mutation. */
export type UpdateCampaignInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `Campaign` being updated. */
  patch: CampaignPatch;
};

/** All input for the `updateCampaignLabel` mutation. */
export type UpdateCampaignLabelInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  labelId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `CampaignLabel` being updated. */
  patch: CampaignLabelPatch;
  placementsCampaignId: Scalars['String'];
};

/** The output of our update `CampaignLabel` mutation. */
export type UpdateCampaignLabelPayload = {
  __typename?: 'UpdateCampaignLabelPayload';
  /** The `CampaignLabel` that was updated by this mutation. */
  campaignLabel?: Maybe<CampaignLabel>;
  /** An edge for our `CampaignLabel`. May be used by Relay 1. */
  campaignLabelEdge?: Maybe<CampaignLabelsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Label` that is related to this `CampaignLabel`. */
  label?: Maybe<Label>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `CampaignLabel` mutation. */
export type UpdateCampaignLabelPayloadCampaignLabelEdgeArgs = {
  orderBy?: InputMaybe<Array<CampaignLabelsOrderBy>>;
};

/** The output of our update `Campaign` mutation. */
export type UpdateCampaignPayload = {
  __typename?: 'UpdateCampaignPayload';
  /** Reads a single `Advertiser` that is related to this `Campaign`. */
  advertiser?: Maybe<Advertiser>;
  /** Reads a single `Advertiser` that is related to this `Campaign`. */
  agency?: Maybe<Advertiser>;
  /** Reads a single `Advertiser` that is related to this `Campaign`. */
  billToAdvertiser?: Maybe<Advertiser>;
  /** Reads a single `Advertiser` that is related to this `Campaign`. */
  brand?: Maybe<Advertiser>;
  /** The `Campaign` that was updated by this mutation. */
  campaign?: Maybe<Campaign>;
  /** An edge for our `Campaign`. May be used by Relay 1. */
  campaignEdge?: Maybe<CampaignsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `Campaign` mutation. */
export type UpdateCampaignPayloadCampaignEdgeArgs = {
  orderBy?: InputMaybe<Array<CampaignsOrderBy>>;
};

/** All input for the `updateClicksCreative` mutation. */
export type UpdateClicksCreativeInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** ID for the creative. */
  id: Scalars['Int'];
  /** An object where the defined keys will be set on the `ClicksCreative` being updated. */
  patch: ClicksCreativePatch;
};

/** The output of our update `ClicksCreative` mutation. */
export type UpdateClicksCreativePayload = {
  __typename?: 'UpdateClicksCreativePayload';
  /** The `ClicksCreative` that was updated by this mutation. */
  clicksCreative?: Maybe<ClicksCreative>;
  /** An edge for our `ClicksCreative`. May be used by Relay 1. */
  clicksCreativeEdge?: Maybe<ClicksCreativesEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `LineItem` that is related to this `ClicksCreative`. */
  lineItem?: Maybe<LineItem>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `ClicksCreative` mutation. */
export type UpdateClicksCreativePayloadClicksCreativeEdgeArgs = {
  orderBy?: InputMaybe<Array<ClicksCreativesOrderBy>>;
};

/** All input for the `updateEndemicDriver` mutation. */
export type UpdateEndemicDriverInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** ID for the endemic driver. */
  id: Scalars['Int'];
  /** An object where the defined keys will be set on the `EndemicDriver` being updated. */
  patch: EndemicDriverPatch;
};

/** The output of our update `EndemicDriver` mutation. */
export type UpdateEndemicDriverPayload = {
  __typename?: 'UpdateEndemicDriverPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `EndemicDriver` that was updated by this mutation. */
  endemicDriver?: Maybe<EndemicDriver>;
  /** An edge for our `EndemicDriver`. May be used by Relay 1. */
  endemicDriverEdge?: Maybe<EndemicDriversEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `EndemicDriver` mutation. */
export type UpdateEndemicDriverPayloadEndemicDriverEdgeArgs = {
  orderBy?: InputMaybe<Array<EndemicDriversOrderBy>>;
};

/** All input for the `updateEndemicDriverTargetList` mutation. */
export type UpdateEndemicDriverTargetListInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  endemicDriverId: Scalars['Int'];
  /** An object where the defined keys will be set on the `EndemicDriverTargetList` being updated. */
  patch: EndemicDriverTargetListPatch;
  targetListId: Scalars['Int'];
};

/** The output of our update `EndemicDriverTargetList` mutation. */
export type UpdateEndemicDriverTargetListPayload = {
  __typename?: 'UpdateEndemicDriverTargetListPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `EndemicDriver` that is related to this `EndemicDriverTargetList`. */
  endemicDriver?: Maybe<EndemicDriver>;
  /** The `EndemicDriverTargetList` that was updated by this mutation. */
  endemicDriverTargetList?: Maybe<EndemicDriverTargetList>;
  /** An edge for our `EndemicDriverTargetList`. May be used by Relay 1. */
  endemicDriverTargetListEdge?: Maybe<EndemicDriverTargetListsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `TargetList` that is related to this `EndemicDriverTargetList`. */
  targetList?: Maybe<TargetList>;
};


/** The output of our update `EndemicDriverTargetList` mutation. */
export type UpdateEndemicDriverTargetListPayloadEndemicDriverTargetListEdgeArgs = {
  orderBy?: InputMaybe<Array<EndemicDriverTargetListsOrderBy>>;
};

/** All input for the `updateEndemicDriverTopicTag` mutation. */
export type UpdateEndemicDriverTopicTagInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  endemicDriverId: Scalars['Int'];
  /** An object where the defined keys will be set on the `EndemicDriverTopicTag` being updated. */
  patch: EndemicDriverTopicTagPatch;
  topicTagId: Scalars['String'];
};

/** The output of our update `EndemicDriverTopicTag` mutation. */
export type UpdateEndemicDriverTopicTagPayload = {
  __typename?: 'UpdateEndemicDriverTopicTagPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `EndemicDriver` that is related to this `EndemicDriverTopicTag`. */
  endemicDriver?: Maybe<EndemicDriver>;
  /** The `EndemicDriverTopicTag` that was updated by this mutation. */
  endemicDriverTopicTag?: Maybe<EndemicDriverTopicTag>;
  /** An edge for our `EndemicDriverTopicTag`. May be used by Relay 1. */
  endemicDriverTopicTagEdge?: Maybe<EndemicDriverTopicTagsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `TopicTag` that is related to this `EndemicDriverTopicTag`. */
  topicTag?: Maybe<TopicTag>;
};


/** The output of our update `EndemicDriverTopicTag` mutation. */
export type UpdateEndemicDriverTopicTagPayloadEndemicDriverTopicTagEdgeArgs = {
  orderBy?: InputMaybe<Array<EndemicDriverTopicTagsOrderBy>>;
};

/** All input for the `updateFmaCreative` mutation. */
export type UpdateFmaCreativeInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** ID for the creative. */
  id: Scalars['Int'];
  /** An object where the defined keys will be set on the `FmaCreative` being updated. */
  patch: FmaCreativePatch;
};

/** The output of our update `FmaCreative` mutation. */
export type UpdateFmaCreativePayload = {
  __typename?: 'UpdateFmaCreativePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `FmaCreative` that was updated by this mutation. */
  fmaCreative?: Maybe<FmaCreative>;
  /** An edge for our `FmaCreative`. May be used by Relay 1. */
  fmaCreativeEdge?: Maybe<FmaCreativesEdge>;
  /** Reads a single `LineItem` that is related to this `FmaCreative`. */
  lineItem?: Maybe<LineItem>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `FmaCreative` mutation. */
export type UpdateFmaCreativePayloadFmaCreativeEdgeArgs = {
  orderBy?: InputMaybe<Array<FmaCreativesOrderBy>>;
};

/** All input for the `updateLabelByName` mutation. */
export type UpdateLabelByNameInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  /** An object where the defined keys will be set on the `Label` being updated. */
  patch: LabelPatch;
};

/** All input for the `updateLabel` mutation. */
export type UpdateLabelInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `Label` being updated. */
  patch: LabelPatch;
};

/** The output of our update `Label` mutation. */
export type UpdateLabelPayload = {
  __typename?: 'UpdateLabelPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `Label` that was updated by this mutation. */
  label?: Maybe<Label>;
  /** An edge for our `Label`. May be used by Relay 1. */
  labelEdge?: Maybe<LabelsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `Label` mutation. */
export type UpdateLabelPayloadLabelEdgeArgs = {
  orderBy?: InputMaybe<Array<LabelsOrderBy>>;
};

/** All input for the `updateLeadGenCampaign` mutation. */
export type UpdateLeadGenCampaignInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
  /** An object where the defined keys will be set on the `LeadGenCampaign` being updated. */
  patch: LeadGenCampaignPatch;
};

/** The output of our update `LeadGenCampaign` mutation. */
export type UpdateLeadGenCampaignPayload = {
  __typename?: 'UpdateLeadGenCampaignPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `LeadGenCampaign` that was updated by this mutation. */
  leadGenCampaign?: Maybe<LeadGenCampaign>;
  /** An edge for our `LeadGenCampaign`. May be used by Relay 1. */
  leadGenCampaignEdge?: Maybe<LeadGenCampaignsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `LeadGenCampaign` mutation. */
export type UpdateLeadGenCampaignPayloadLeadGenCampaignEdgeArgs = {
  orderBy?: InputMaybe<Array<LeadGenCampaignsOrderBy>>;
};

/** All input for the `updateLeadGenViewByLeadGenCampaignIdAndBrowserInstanceId` mutation. */
export type UpdateLeadGenViewByLeadGenCampaignIdAndBrowserInstanceIdInput = {
  browserInstanceId: Scalars['String'];
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  leadGenCampaignId: Scalars['Int'];
  /** An object where the defined keys will be set on the `LeadGenView` being updated. */
  patch: LeadGenViewPatch;
};

/** All input for the `updateLeadGenView` mutation. */
export type UpdateLeadGenViewInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
  /** An object where the defined keys will be set on the `LeadGenView` being updated. */
  patch: LeadGenViewPatch;
};

/** The output of our update `LeadGenView` mutation. */
export type UpdateLeadGenViewPayload = {
  __typename?: 'UpdateLeadGenViewPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `LeadGenCampaign` that is related to this `LeadGenView`. */
  leadGenCampaign?: Maybe<LeadGenCampaign>;
  /** The `LeadGenView` that was updated by this mutation. */
  leadGenView?: Maybe<LeadGenView>;
  /** An edge for our `LeadGenView`. May be used by Relay 1. */
  leadGenViewEdge?: Maybe<LeadGenViewsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `LeadGenView` mutation. */
export type UpdateLeadGenViewPayloadLeadGenViewEdgeArgs = {
  orderBy?: InputMaybe<Array<LeadGenViewsOrderBy>>;
};

/** All input for the `updateLineItemByCampaignIdAndLineItemNumber` mutation. */
export type UpdateLineItemByCampaignIdAndLineItemNumberInput = {
  campaignId: Scalars['UUID'];
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** PIO line item number preserved during import; unique within each campaign because PIO line-item numbers are campaign-scoped. */
  lineItemNumber: Scalars['Int'];
  /** An object where the defined keys will be set on the `LineItem` being updated. */
  patch: LineItemPatch;
};

/** All input for the `updateLineItemByExternalPioId` mutation. */
export type UpdateLineItemByExternalPioIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  externalPioId: Scalars['String'];
  /** An object where the defined keys will be set on the `LineItem` being updated. */
  patch: LineItemPatch;
};

/** All input for the `updateLineItemDeliveryByLineItemIdAndPeriodStartAndPeriodEndAndSource` mutation. */
export type UpdateLineItemDeliveryByLineItemIdAndPeriodStartAndPeriodEndAndSourceInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  lineItemId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `LineItemDelivery` being updated. */
  patch: LineItemDeliveryPatch;
  periodEnd: Scalars['Date'];
  periodStart: Scalars['Date'];
  /** Source of the reported monthly delivery numbers: client_dcm, gam, or manual. */
  source: LineItemDeliverySource;
};

/** All input for the `updateLineItemDelivery` mutation. */
export type UpdateLineItemDeliveryInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `LineItemDelivery` being updated. */
  patch: LineItemDeliveryPatch;
};

/** The output of our update `LineItemDelivery` mutation. */
export type UpdateLineItemDeliveryPayload = {
  __typename?: 'UpdateLineItemDeliveryPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `LineItem` that is related to this `LineItemDelivery`. */
  lineItem?: Maybe<LineItem>;
  /** The `LineItemDelivery` that was updated by this mutation. */
  lineItemDelivery?: Maybe<LineItemDelivery>;
  /** An edge for our `LineItemDelivery`. May be used by Relay 1. */
  lineItemDeliveryEdge?: Maybe<LineItemDeliveriesEdge>;
  /** Reads a single `PioUser` that is related to this `LineItemDelivery`. */
  pioUserByReportedBy?: Maybe<PioUser>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `LineItemDelivery` mutation. */
export type UpdateLineItemDeliveryPayloadLineItemDeliveryEdgeArgs = {
  orderBy?: InputMaybe<Array<LineItemDeliveriesOrderBy>>;
};

/** All input for the `updateLineItem` mutation. */
export type UpdateLineItemInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `LineItem` being updated. */
  patch: LineItemPatch;
};

/** All input for the `updateLineItemLabel` mutation. */
export type UpdateLineItemLabelInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  labelId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `LineItemLabel` being updated. */
  patch: LineItemLabelPatch;
  placementsLineItemId: Scalars['String'];
};

/** The output of our update `LineItemLabel` mutation. */
export type UpdateLineItemLabelPayload = {
  __typename?: 'UpdateLineItemLabelPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Label` that is related to this `LineItemLabel`. */
  label?: Maybe<Label>;
  /** Reads a single `LineItem` that is related to this `LineItemLabel`. */
  lineItem?: Maybe<LineItem>;
  /** The `LineItemLabel` that was updated by this mutation. */
  lineItemLabel?: Maybe<LineItemLabel>;
  /** An edge for our `LineItemLabel`. May be used by Relay 1. */
  lineItemLabelEdge?: Maybe<LineItemLabelsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `LineItemLabel` mutation. */
export type UpdateLineItemLabelPayloadLineItemLabelEdgeArgs = {
  orderBy?: InputMaybe<Array<LineItemLabelsOrderBy>>;
};

/** The output of our update `LineItem` mutation. */
export type UpdateLineItemPayload = {
  __typename?: 'UpdateLineItemPayload';
  /** Reads a single `Campaign` that is related to this `LineItem`. */
  campaign?: Maybe<Campaign>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `LineItem` that is related to this `LineItem`. */
  copiedFromLineItem?: Maybe<LineItem>;
  /** The `LineItem` that was updated by this mutation. */
  lineItem?: Maybe<LineItem>;
  /** An edge for our `LineItem`. May be used by Relay 1. */
  lineItemEdge?: Maybe<LineItemsEdge>;
  /** Reads a single `PioUser` that is related to this `LineItem`. */
  pioUserByReviewedBy?: Maybe<PioUser>;
  /** Reads a single `Product` that is related to this `LineItem`. */
  product?: Maybe<Product>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `LineItem` mutation. */
export type UpdateLineItemPayloadLineItemEdgeArgs = {
  orderBy?: InputMaybe<Array<LineItemsOrderBy>>;
};

/** All input for the `updateProduct` mutation. */
export type UpdateProductInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `Product` being updated. */
  patch: ProductPatch;
};

/** The output of our update `Product` mutation. */
export type UpdateProductPayload = {
  __typename?: 'UpdateProductPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `Product` that was updated by this mutation. */
  product?: Maybe<Product>;
  /** An edge for our `Product`. May be used by Relay 1. */
  productEdge?: Maybe<ProductsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `Product` mutation. */
export type UpdateProductPayloadProductEdgeArgs = {
  orderBy?: InputMaybe<Array<ProductsOrderBy>>;
};

/** All input for the `updateProfession` mutation. */
export type UpdateProfessionInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
  /** An object where the defined keys will be set on the `Profession` being updated. */
  patch: ProfessionPatch;
};

/** The output of our update `Profession` mutation. */
export type UpdateProfessionPayload = {
  __typename?: 'UpdateProfessionPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `Profession` that was updated by this mutation. */
  profession?: Maybe<Profession>;
  /** An edge for our `Profession`. May be used by Relay 1. */
  professionEdge?: Maybe<ProfessionsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `Profession` mutation. */
export type UpdateProfessionPayloadProfessionEdgeArgs = {
  orderBy?: InputMaybe<Array<ProfessionsOrderBy>>;
};

/** All input for the `updateSpecialtyGroup` mutation. */
export type UpdateSpecialtyGroupInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `SpecialtyGroup` being updated. */
  patch: SpecialtyGroupPatch;
};

/** The output of our update `SpecialtyGroup` mutation. */
export type UpdateSpecialtyGroupPayload = {
  __typename?: 'UpdateSpecialtyGroupPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `SpecialtyGroup` that was updated by this mutation. */
  specialtyGroup?: Maybe<SpecialtyGroup>;
  /** An edge for our `SpecialtyGroup`. May be used by Relay 1. */
  specialtyGroupEdge?: Maybe<SpecialtyGroupsEdge>;
};


/** The output of our update `SpecialtyGroup` mutation. */
export type UpdateSpecialtyGroupPayloadSpecialtyGroupEdgeArgs = {
  orderBy?: InputMaybe<Array<SpecialtyGroupsOrderBy>>;
};

/** All input for the `updateSpecialty` mutation. */
export type UpdateSpecialtyInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
  /** An object where the defined keys will be set on the `Specialty` being updated. */
  patch: SpecialtyPatch;
};

/** The output of our update `Specialty` mutation. */
export type UpdateSpecialtyPayload = {
  __typename?: 'UpdateSpecialtyPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `Specialty` that was updated by this mutation. */
  specialty?: Maybe<Specialty>;
  /** An edge for our `Specialty`. May be used by Relay 1. */
  specialtyEdge?: Maybe<SpecialtiesEdge>;
};


/** The output of our update `Specialty` mutation. */
export type UpdateSpecialtyPayloadSpecialtyEdgeArgs = {
  orderBy?: InputMaybe<Array<SpecialtiesOrderBy>>;
};

/** All input for the `updateSponsoredContentTeaser` mutation. */
export type UpdateSponsoredContentTeaserInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
  /** An object where the defined keys will be set on the `SponsoredContentTeaser` being updated. */
  patch: SponsoredContentTeaserPatch;
};

/** The output of our update `SponsoredContentTeaser` mutation. */
export type UpdateSponsoredContentTeaserPayload = {
  __typename?: 'UpdateSponsoredContentTeaserPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `LineItem` that is related to this `SponsoredContentTeaser`. */
  lineItem?: Maybe<LineItem>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `SponsoredContentTeaser` that was updated by this mutation. */
  sponsoredContentTeaser?: Maybe<SponsoredContentTeaser>;
  /** An edge for our `SponsoredContentTeaser`. May be used by Relay 1. */
  sponsoredContentTeaserEdge?: Maybe<SponsoredContentTeasersEdge>;
};


/** The output of our update `SponsoredContentTeaser` mutation. */
export type UpdateSponsoredContentTeaserPayloadSponsoredContentTeaserEdgeArgs = {
  orderBy?: InputMaybe<Array<SponsoredContentTeasersOrderBy>>;
};

/** All input for the `updateSponsoredContentTeaserProfession` mutation. */
export type UpdateSponsoredContentTeaserProfessionInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** An object where the defined keys will be set on the `SponsoredContentTeaserProfession` being updated. */
  patch: SponsoredContentTeaserProfessionPatch;
  professionId: Scalars['Int'];
  sponsoredContentTeaserId: Scalars['Int'];
};

/** The output of our update `SponsoredContentTeaserProfession` mutation. */
export type UpdateSponsoredContentTeaserProfessionPayload = {
  __typename?: 'UpdateSponsoredContentTeaserProfessionPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Profession` that is related to this `SponsoredContentTeaserProfession`. */
  profession?: Maybe<Profession>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `SponsoredContentTeaser` that is related to this `SponsoredContentTeaserProfession`. */
  sponsoredContentTeaser?: Maybe<SponsoredContentTeaser>;
  /** The `SponsoredContentTeaserProfession` that was updated by this mutation. */
  sponsoredContentTeaserProfession?: Maybe<SponsoredContentTeaserProfession>;
  /** An edge for our `SponsoredContentTeaserProfession`. May be used by Relay 1. */
  sponsoredContentTeaserProfessionEdge?: Maybe<SponsoredContentTeaserProfessionsEdge>;
};


/** The output of our update `SponsoredContentTeaserProfession` mutation. */
export type UpdateSponsoredContentTeaserProfessionPayloadSponsoredContentTeaserProfessionEdgeArgs = {
  orderBy?: InputMaybe<Array<SponsoredContentTeaserProfessionsOrderBy>>;
};

/** All input for the `updateSponsoredContentTeaserSpecialty` mutation. */
export type UpdateSponsoredContentTeaserSpecialtyInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** An object where the defined keys will be set on the `SponsoredContentTeaserSpecialty` being updated. */
  patch: SponsoredContentTeaserSpecialtyPatch;
  specialtyId: Scalars['Int'];
  sponsoredContentTeaserId: Scalars['Int'];
};

/** The output of our update `SponsoredContentTeaserSpecialty` mutation. */
export type UpdateSponsoredContentTeaserSpecialtyPayload = {
  __typename?: 'UpdateSponsoredContentTeaserSpecialtyPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Specialty` that is related to this `SponsoredContentTeaserSpecialty`. */
  specialty?: Maybe<Specialty>;
  /** Reads a single `SponsoredContentTeaser` that is related to this `SponsoredContentTeaserSpecialty`. */
  sponsoredContentTeaser?: Maybe<SponsoredContentTeaser>;
  /** The `SponsoredContentTeaserSpecialty` that was updated by this mutation. */
  sponsoredContentTeaserSpecialty?: Maybe<SponsoredContentTeaserSpecialty>;
  /** An edge for our `SponsoredContentTeaserSpecialty`. May be used by Relay 1. */
  sponsoredContentTeaserSpecialtyEdge?: Maybe<SponsoredContentTeaserSpecialtiesEdge>;
};


/** The output of our update `SponsoredContentTeaserSpecialty` mutation. */
export type UpdateSponsoredContentTeaserSpecialtyPayloadSponsoredContentTeaserSpecialtyEdgeArgs = {
  orderBy?: InputMaybe<Array<SponsoredContentTeaserSpecialtiesOrderBy>>;
};

/** All input for the `updateSponsoredContentTeaserTargetList` mutation. */
export type UpdateSponsoredContentTeaserTargetListInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** An object where the defined keys will be set on the `SponsoredContentTeaserTargetList` being updated. */
  patch: SponsoredContentTeaserTargetListPatch;
  sponsoredContentTeaserId: Scalars['Int'];
  targetListId: Scalars['Int'];
};

/** The output of our update `SponsoredContentTeaserTargetList` mutation. */
export type UpdateSponsoredContentTeaserTargetListPayload = {
  __typename?: 'UpdateSponsoredContentTeaserTargetListPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `SponsoredContentTeaser` that is related to this `SponsoredContentTeaserTargetList`. */
  sponsoredContentTeaser?: Maybe<SponsoredContentTeaser>;
  /** The `SponsoredContentTeaserTargetList` that was updated by this mutation. */
  sponsoredContentTeaserTargetList?: Maybe<SponsoredContentTeaserTargetList>;
  /** An edge for our `SponsoredContentTeaserTargetList`. May be used by Relay 1. */
  sponsoredContentTeaserTargetListEdge?: Maybe<SponsoredContentTeaserTargetListsEdge>;
  /** Reads a single `TargetList` that is related to this `SponsoredContentTeaserTargetList`. */
  targetList?: Maybe<TargetList>;
};


/** The output of our update `SponsoredContentTeaserTargetList` mutation. */
export type UpdateSponsoredContentTeaserTargetListPayloadSponsoredContentTeaserTargetListEdgeArgs = {
  orderBy?: InputMaybe<Array<SponsoredContentTeaserTargetListsOrderBy>>;
};

/** All input for the `updateTargetList` mutation. */
export type UpdateTargetListInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** ID for the target group. */
  id: Scalars['Int'];
  /** An object where the defined keys will be set on the `TargetList` being updated. */
  patch: TargetListPatch;
};

/** The output of our update `TargetList` mutation. */
export type UpdateTargetListPayload = {
  __typename?: 'UpdateTargetListPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `TargetList` that was updated by this mutation. */
  targetList?: Maybe<TargetList>;
  /** An edge for our `TargetList`. May be used by Relay 1. */
  targetListEdge?: Maybe<TargetListsEdge>;
};


/** The output of our update `TargetList` mutation. */
export type UpdateTargetListPayloadTargetListEdgeArgs = {
  orderBy?: InputMaybe<Array<TargetListsOrderBy>>;
};

/** All input for the `updateTopicTag` mutation. */
export type UpdateTopicTagInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  /** An object where the defined keys will be set on the `TopicTag` being updated. */
  patch: TopicTagPatch;
};

/** The output of our update `TopicTag` mutation. */
export type UpdateTopicTagPayload = {
  __typename?: 'UpdateTopicTagPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `TopicTag` that was updated by this mutation. */
  topicTag?: Maybe<TopicTag>;
  /** An edge for our `TopicTag`. May be used by Relay 1. */
  topicTagEdge?: Maybe<TopicTagsEdge>;
};


/** The output of our update `TopicTag` mutation. */
export type UpdateTopicTagPayloadTopicTagEdgeArgs = {
  orderBy?: InputMaybe<Array<TopicTagsOrderBy>>;
};

export type CreateTargetListMutationVariables = Exact<{
  name: Scalars['String'];
  description?: InputMaybe<Scalars['String']>;
  uploadedFilename: Scalars['String'];
}>;


export type CreateTargetListMutation = { __typename?: 'Mutation', createTargetList?: { __typename?: 'CreateTargetListPayload', targetList?: { __typename?: 'TargetList', id: number, name: string, description?: string | null, uploadedFilename: string, uploadedAt: any, npiCount?: number | null, placementLineItemIdsList?: Array<string | null> | null } | null } | null };

export type UpdateTargetListMutationVariables = Exact<{
  id: Scalars['Int'];
  description?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  uploadedFilename?: InputMaybe<Scalars['String']>;
  isArchived?: InputMaybe<Scalars['Boolean']>;
}>;


export type UpdateTargetListMutation = { __typename?: 'Mutation', updateTargetList?: { __typename?: 'UpdateTargetListPayload', clientMutationId?: string | null, targetList?: { __typename?: 'TargetList', id: number, name: string, description?: string | null, uploadedFilename: string, uploadedAt: any, npiCount?: number | null, placementLineItemIdsList?: Array<string | null> | null, isArchived: boolean } | null } | null };

export type SetTargetListNpisMutationVariables = Exact<{
  id: Scalars['Int'];
  npis: Array<InputMaybe<Scalars['Int']>> | InputMaybe<Scalars['Int']>;
}>;


export type SetTargetListNpisMutation = { __typename?: 'Mutation', setTargetListNpis?: { __typename?: 'SetTargetListNpisPayload', clientMutationId?: string | null, query?: { __typename?: 'Query', targetList?: { __typename?: 'TargetList', id: number, name: string, description?: string | null, uploadedFilename: string, uploadedAt: any, npiCount?: number | null, placementLineItemIdsList?: Array<string | null> | null } | null } | null } | null };

export type DuplicateClicksCreativeMutationVariables = Exact<{
  existingId: Scalars['Int'];
}>;


export type DuplicateClicksCreativeMutation = { __typename?: 'Mutation', duplicateClicksCreative?: { __typename?: 'DuplicateClicksCreativePayload', clientMutationId?: string | null, clicksCreative?: { __typename?: 'ClicksCreative', id: number } | null } | null };

export type UpdateFmaCreativeMutationVariables = Exact<{
  id: Scalars['Int'];
  patch: FmaCreativePatch;
  targetListIds: Array<InputMaybe<Scalars['Int']>> | InputMaybe<Scalars['Int']>;
}>;


export type UpdateFmaCreativeMutation = { __typename?: 'Mutation', updateFmaCreative?: { __typename?: 'UpdateFmaCreativePayload', clientMutationId?: string | null, fmaCreative?: { __typename?: 'FmaCreative', id: number } | null } | null, setFmaCreativeTargetLists?: { __typename?: 'SetFmaCreativeTargetListsPayload', clientMutationId?: string | null } | null };

export type DuplicateFmaCreativeMutationVariables = Exact<{
  existingId: Scalars['Int'];
}>;


export type DuplicateFmaCreativeMutation = { __typename?: 'Mutation', duplicateFmaCreative?: { __typename?: 'DuplicateFmaCreativePayload', clientMutationId?: string | null, fmaCreative?: { __typename?: 'FmaCreative', id: number } | null } | null };

export type CreateFmaCreativeMutationVariables = Exact<{
  input: CreateFmaCreativeInput;
}>;


export type CreateFmaCreativeMutation = { __typename?: 'Mutation', createFmaCreative?: { __typename?: 'CreateFmaCreativePayload', clientMutationId?: string | null, fmaCreative?: { __typename?: 'FmaCreative', id: number } | null } | null };

export type SetFmaCreativeTargetListsMutationVariables = Exact<{
  input: SetFmaCreativeTargetListsInput;
}>;


export type SetFmaCreativeTargetListsMutation = { __typename?: 'Mutation', setFmaCreativeTargetLists?: { __typename?: 'SetFmaCreativeTargetListsPayload', clientMutationId?: string | null } | null };

export type UpdateClicksCreativeMutationVariables = Exact<{
  id: Scalars['Int'];
  patch: ClicksCreativePatch;
  daysToHide: Array<InputMaybe<DayOfWeekType>> | InputMaybe<DayOfWeekType>;
  targetListIds: Array<InputMaybe<Scalars['Int']>> | InputMaybe<Scalars['Int']>;
  professionIds: Array<InputMaybe<Scalars['Int']>> | InputMaybe<Scalars['Int']>;
  specialtyIds: Array<InputMaybe<Scalars['Int']>> | InputMaybe<Scalars['Int']>;
}>;


export type UpdateClicksCreativeMutation = { __typename?: 'Mutation', updateClicksCreative?: { __typename?: 'UpdateClicksCreativePayload', clientMutationId?: string | null, clicksCreative?: { __typename?: 'ClicksCreative', id: number } | null } | null, setClicksCreativeHideOnDays?: { __typename?: 'SetClicksCreativeHideOnDaysPayload', clientMutationId?: string | null } | null, setClicksCreativeProfessions?: { __typename?: 'SetClicksCreativeProfessionsPayload', clientMutationId?: string | null } | null, setClicksCreativeSpecialties?: { __typename?: 'SetClicksCreativeSpecialtiesPayload', clientMutationId?: string | null } | null, setClicksCreativeTargetLists?: { __typename?: 'SetClicksCreativeTargetListsPayload', clientMutationId?: string | null } | null };

export type CreateClicksCreativeMutationVariables = Exact<{
  input: CreateClicksCreativeInput;
}>;


export type CreateClicksCreativeMutation = { __typename?: 'Mutation', createClicksCreative?: { __typename?: 'CreateClicksCreativePayload', clientMutationId?: string | null, clicksCreative?: { __typename?: 'ClicksCreative', id: number } | null } | null };

export type SetClicksCreativeListsMutationVariables = Exact<{
  id: Scalars['Int'];
  daysToHide: Array<InputMaybe<DayOfWeekType>> | InputMaybe<DayOfWeekType>;
  targetListIds: Array<InputMaybe<Scalars['Int']>> | InputMaybe<Scalars['Int']>;
  professionIds: Array<InputMaybe<Scalars['Int']>> | InputMaybe<Scalars['Int']>;
  specialtyIds: Array<InputMaybe<Scalars['Int']>> | InputMaybe<Scalars['Int']>;
}>;


export type SetClicksCreativeListsMutation = { __typename?: 'Mutation', setClicksCreativeHideOnDays?: { __typename?: 'SetClicksCreativeHideOnDaysPayload', clientMutationId?: string | null } | null, setClicksCreativeProfessions?: { __typename?: 'SetClicksCreativeProfessionsPayload', clientMutationId?: string | null } | null, setClicksCreativeSpecialties?: { __typename?: 'SetClicksCreativeSpecialtiesPayload', clientMutationId?: string | null } | null, setClicksCreativeTargetLists?: { __typename?: 'SetClicksCreativeTargetListsPayload', clientMutationId?: string | null } | null };

export type ArchiveLabelMutationVariables = Exact<{
  id: Scalars['UUID'];
  isArchived: Scalars['Boolean'];
  name: Scalars['String'];
  updatedBy: Scalars['String'];
}>;


export type ArchiveLabelMutation = { __typename?: 'Mutation', updateLabel?: { __typename?: 'UpdateLabelPayload', label?: { __typename?: 'Label', id: any, name: string, description?: string | null, isArchived: boolean } | null } | null };

export type DeleteLineItemLabelMutationVariables = Exact<{
  placementsLineItemId: Scalars['String'];
  labelId: Scalars['UUID'];
}>;


export type DeleteLineItemLabelMutation = { __typename?: 'Mutation', deleteLineItemLabel?: { __typename?: 'DeleteLineItemLabelPayload', lineItemLabel?: { __typename?: 'LineItemLabel', placementsLineItemId: string, lineItemId?: any | null, labelId: any } | null } | null };

export type DeleteCampaignLabelMutationVariables = Exact<{
  placementsCampaignId: Scalars['String'];
  labelId: Scalars['UUID'];
}>;


export type DeleteCampaignLabelMutation = { __typename?: 'Mutation', deleteCampaignLabel?: { __typename?: 'DeleteCampaignLabelPayload', campaignLabel?: { __typename?: 'CampaignLabel', placementsCampaignId: string, labelId: any } | null } | null };

export type CreateSponsoredContentTeaserMutationVariables = Exact<{
  input: CreateSponsoredContentTeaserInput;
}>;


export type CreateSponsoredContentTeaserMutation = { __typename?: 'Mutation', createSponsoredContentTeaser?: { __typename?: 'CreateSponsoredContentTeaserPayload', clientMutationId?: string | null, sponsoredContentTeaser?: { __typename?: 'SponsoredContentTeaser', id: number } | null } | null };

export type UpdateSponsoredContentTeaserMutationVariables = Exact<{
  id: Scalars['Int'];
  patch: SponsoredContentTeaserPatch;
  targetListIds: Array<InputMaybe<Scalars['Int']>> | InputMaybe<Scalars['Int']>;
  professionIds: Array<InputMaybe<Scalars['Int']>> | InputMaybe<Scalars['Int']>;
  specialtyIds: Array<InputMaybe<Scalars['Int']>> | InputMaybe<Scalars['Int']>;
}>;


export type UpdateSponsoredContentTeaserMutation = { __typename?: 'Mutation', updateSponsoredContentTeaser?: { __typename?: 'UpdateSponsoredContentTeaserPayload', clientMutationId?: string | null, sponsoredContentTeaser?: { __typename?: 'SponsoredContentTeaser', id: number } | null } | null, setSponsoredContentTeaserSpecialties?: { __typename?: 'SetSponsoredContentTeaserSpecialtiesPayload', clientMutationId?: string | null } | null, setSponsoredContentTeaserProfessions?: { __typename?: 'SetSponsoredContentTeaserProfessionsPayload', clientMutationId?: string | null } | null, setSponsoredContentTeaserTargetLists?: { __typename?: 'SetSponsoredContentTeaserTargetListsPayload', clientMutationId?: string | null } | null };

export type SetSponsoredContentTeaserListsMutationVariables = Exact<{
  id: Scalars['Int'];
  targetListIds: Array<InputMaybe<Scalars['Int']>> | InputMaybe<Scalars['Int']>;
  professionIds: Array<InputMaybe<Scalars['Int']>> | InputMaybe<Scalars['Int']>;
  specialtyIds: Array<InputMaybe<Scalars['Int']>> | InputMaybe<Scalars['Int']>;
}>;


export type SetSponsoredContentTeaserListsMutation = { __typename?: 'Mutation', setSponsoredContentTeaserProfessions?: { __typename?: 'SetSponsoredContentTeaserProfessionsPayload', clientMutationId?: string | null } | null, setSponsoredContentTeaserSpecialties?: { __typename?: 'SetSponsoredContentTeaserSpecialtiesPayload', clientMutationId?: string | null } | null, setSponsoredContentTeaserTargetLists?: { __typename?: 'SetSponsoredContentTeaserTargetListsPayload', clientMutationId?: string | null } | null };

export type CreateEndemicDriverMutationVariables = Exact<{
  input: CreateEndemicDriverInput;
}>;


export type CreateEndemicDriverMutation = { __typename?: 'Mutation', createEndemicDriver?: { __typename?: 'CreateEndemicDriverPayload', clientMutationId?: string | null, endemicDriver?: { __typename?: 'EndemicDriver', id: number, contentfulId: string, driverContentType: string, name: string, priority: number, isApproved: boolean, startsAt: any, endsAt: any } | null } | null };

export type CreateLeadGenCampaignMutationVariables = Exact<{
  name: Scalars['String'];
  startsAt: Scalars['Datetime'];
  endsAt: Scalars['Datetime'];
  priority?: InputMaybe<Scalars['Int']>;
  maxViewsPerNpi?: InputMaybe<Scalars['Int']>;
  maxViewsPerSession?: InputMaybe<Scalars['Int']>;
  isApproved?: InputMaybe<Scalars['Boolean']>;
}>;


export type CreateLeadGenCampaignMutation = { __typename?: 'Mutation', createLeadGenCampaign?: { __typename?: 'CreateLeadGenCampaignPayload', leadGenCampaign?: { __typename?: 'LeadGenCampaign', id: number, name: string, startsAt: any, endsAt: any, priority?: number | null, maxViewsPerNpi?: number | null, maxViewsPerSession?: number | null, isApproved?: boolean | null, createdAt?: any | null, updatedAt?: any | null } | null } | null };

export type UpdateEndemicDriverMutationVariables = Exact<{
  input: UpdateEndemicDriverInput;
}>;


export type UpdateEndemicDriverMutation = { __typename?: 'Mutation', updateEndemicDriver?: { __typename?: 'UpdateEndemicDriverPayload', clientMutationId?: string | null, endemicDriver?: { __typename?: 'EndemicDriver', id: number, contentfulId: string, driverContentType: string, name: string, priority: number, isApproved: boolean, startsAt: any, endsAt: any } | null } | null };

export type SetEndemicDriverTargetListsMutationVariables = Exact<{
  input: SetEndemicDriverTargetListsInput;
}>;


export type SetEndemicDriverTargetListsMutation = { __typename?: 'Mutation', setEndemicDriverTargetLists?: { __typename?: 'SetEndemicDriverTargetListsPayload', clientMutationId?: string | null } | null };

export type UpdateLeadGenCampaignMutationVariables = Exact<{
  id: Scalars['Int'];
  name?: InputMaybe<Scalars['String']>;
  startsAt?: InputMaybe<Scalars['Datetime']>;
  endsAt?: InputMaybe<Scalars['Datetime']>;
  priority?: InputMaybe<Scalars['Int']>;
  maxViewsPerNpi?: InputMaybe<Scalars['Int']>;
  maxViewsPerSession?: InputMaybe<Scalars['Int']>;
  isApproved?: InputMaybe<Scalars['Boolean']>;
  targetListIds: Array<InputMaybe<Scalars['Int']>> | InputMaybe<Scalars['Int']>;
}>;


export type UpdateLeadGenCampaignMutation = { __typename?: 'Mutation', updateLeadGenCampaign?: { __typename?: 'UpdateLeadGenCampaignPayload', leadGenCampaign?: { __typename?: 'LeadGenCampaign', id: number, name: string, startsAt: any, endsAt: any, priority?: number | null, maxViewsPerNpi?: number | null, maxViewsPerSession?: number | null, isApproved?: boolean | null, createdAt?: any | null, updatedAt?: any | null } | null } | null, setLeadGenCampaignTargetLists?: { __typename?: 'SetLeadGenCampaignTargetListsPayload', clientMutationId?: string | null } | null };

export type SetEndemicDriverTopicTagsMutationVariables = Exact<{
  input: SetEndemicDriverTopicTagsInput;
}>;


export type SetEndemicDriverTopicTagsMutation = { __typename?: 'Mutation', setEndemicDriverTopicTags?: { __typename?: 'SetEndemicDriverTopicTagsPayload', clientMutationId?: string | null } | null };

export type SetEndemicDriverSpecialtiesMutationVariables = Exact<{
  input: SetEndemicDriverSpecialtiesInput;
}>;


export type SetEndemicDriverSpecialtiesMutation = { __typename?: 'Mutation', setEndemicDriverSpecialties?: { __typename?: 'SetEndemicDriverSpecialtiesPayload', clientMutationId?: string | null } | null };

export type SetEndemicDriverProfessionsMutationVariables = Exact<{
  input: SetEndemicDriverProfessionsInput;
}>;


export type SetEndemicDriverProfessionsMutation = { __typename?: 'Mutation', setEndemicDriverProfessions?: { __typename?: 'SetEndemicDriverProfessionsPayload', clientMutationId?: string | null } | null };

export type DeleteLeadGenCampaignMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type DeleteLeadGenCampaignMutation = { __typename?: 'Mutation', deleteLeadGenCampaign?: { __typename?: 'DeleteLeadGenCampaignPayload', deletedLeadGenCampaignNodeId?: string | null } | null };

export type SetLeadGenCampaignTargetListsMutationVariables = Exact<{
  id: Scalars['Int'];
  targetListIds: Array<InputMaybe<Scalars['Int']>> | InputMaybe<Scalars['Int']>;
}>;


export type SetLeadGenCampaignTargetListsMutation = { __typename?: 'Mutation', setLeadGenCampaignTargetLists?: { __typename?: 'SetLeadGenCampaignTargetListsPayload', clientMutationId?: string | null } | null };

export type TargetListsPlacementLineItemIdsListQueryVariables = Exact<{
  includes: Scalars['String'];
}>;


export type TargetListsPlacementLineItemIdsListQuery = { __typename?: 'Query', targetLists?: { __typename?: 'TargetListsConnection', nodes: Array<{ __typename?: 'TargetList', id: number, name: string, description?: string | null, placementLineItemIdsList?: Array<string | null> | null }> } | null };

export type TargetListsLineItemIdsListQueryVariables = Exact<{
  lineItemIds: Array<Scalars['String']> | Scalars['String'];
}>;


export type TargetListsLineItemIdsListQuery = { __typename?: 'Query', targetLists?: { __typename?: 'TargetListsConnection', nodes: Array<{ __typename?: 'TargetList', id: number, name: string, description?: string | null, lineItemIdsList?: Array<string | null> | null }> } | null };

export type TargetListsForDropdownQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TargetListsOrderBy> | TargetListsOrderBy>;
  filter?: InputMaybe<TargetListFilter>;
}>;


export type TargetListsForDropdownQuery = { __typename?: 'Query', targetLists?: { __typename?: 'TargetListsConnection', totalCount: number, nodes: Array<{ __typename?: 'TargetList', id: number, name: string }> } | null };

export type GetLabelsForLineItemByPlacementsLineItemIdQueryVariables = Exact<{
  placementsLineItemId: Scalars['String'];
}>;


export type GetLabelsForLineItemByPlacementsLineItemIdQuery = { __typename?: 'Query', lineItemLabels?: { __typename?: 'LineItemLabelsConnection', nodes: Array<{ __typename?: 'LineItemLabel', placementsLineItemId: string, lineItemId?: any | null, labelId: any, label?: { __typename?: 'Label', id: any, name: string, isArchived: boolean } | null }> } | null };

export type GetLabelsForLineItemByNativeLineItemIdQueryVariables = Exact<{
  lineItemId: Scalars['UUID'];
}>;


export type GetLabelsForLineItemByNativeLineItemIdQuery = { __typename?: 'Query', lineItemLabels?: { __typename?: 'LineItemLabelsConnection', nodes: Array<{ __typename?: 'LineItemLabel', placementsLineItemId: string, lineItemId?: any | null, labelId: any, label?: { __typename?: 'Label', id: any, name: string, isArchived: boolean } | null }> } | null };

export type GetLabelsForCampaignQueryVariables = Exact<{
  campaignId: Scalars['String'];
}>;


export type GetLabelsForCampaignQuery = { __typename?: 'Query', campaignLabels?: { __typename?: 'CampaignLabelsConnection', nodes: Array<{ __typename?: 'CampaignLabel', placementsCampaignId: string, labelId: any, label?: { __typename?: 'Label', id: any, name: string, isArchived: boolean } | null }> } | null };

export type GetLeadGenCampaignsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['Cursor']>;
  after?: InputMaybe<Scalars['Cursor']>;
  orderBy?: InputMaybe<Array<LeadGenCampaignsOrderBy> | LeadGenCampaignsOrderBy>;
  filter?: InputMaybe<LeadGenCampaignFilter>;
}>;


export type GetLeadGenCampaignsQuery = { __typename?: 'Query', leadGenCampaigns?: { __typename?: 'LeadGenCampaignsConnection', totalCount: number, nodes: Array<{ __typename?: 'LeadGenCampaign', id: number, name: string, startsAt: any, endsAt: any, targetListIdsList?: Array<number | null> | null, isApproved?: boolean | null, createdAt?: any | null, updatedAt?: any | null, targetListsList?: Array<{ __typename?: 'TargetList', id: number, name: string }> | null }> } | null };

export type GetLeadGenCampaignQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type GetLeadGenCampaignQuery = { __typename?: 'Query', leadGenCampaign?: { __typename?: 'LeadGenCampaign', id: number, name: string, startsAt: any, endsAt: any, targetListIdsList?: Array<number | null> | null, priority?: number | null, maxViewsPerNpi?: number | null, maxViewsPerSession?: number | null, isApproved?: boolean | null, createdAt?: any | null, updatedAt?: any | null } | null };


export const CreateTargetListDocument = gql`
    mutation CreateTargetList($name: String!, $description: String, $uploadedFilename: String!) {
  createTargetList(
    input: {targetList: {name: $name, description: $description, uploadedFilename: $uploadedFilename}}
  ) {
    targetList {
      id
      name
      description
      uploadedFilename
      uploadedAt
      npiCount
      placementLineItemIdsList
    }
  }
}
    `;
export type CreateTargetListMutationFn = Apollo.MutationFunction<CreateTargetListMutation, CreateTargetListMutationVariables>;

/**
 * __useCreateTargetListMutation__
 *
 * To run a mutation, you first call `useCreateTargetListMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTargetListMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTargetListMutation, { data, loading, error }] = useCreateTargetListMutation({
 *   variables: {
 *      name: // value for 'name'
 *      description: // value for 'description'
 *      uploadedFilename: // value for 'uploadedFilename'
 *   },
 * });
 */
export function useCreateTargetListMutation(baseOptions?: Apollo.MutationHookOptions<CreateTargetListMutation, CreateTargetListMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTargetListMutation, CreateTargetListMutationVariables>(CreateTargetListDocument, options);
      }
export type CreateTargetListMutationHookResult = ReturnType<typeof useCreateTargetListMutation>;
export type CreateTargetListMutationResult = Apollo.MutationResult<CreateTargetListMutation>;
export type CreateTargetListMutationOptions = Apollo.BaseMutationOptions<CreateTargetListMutation, CreateTargetListMutationVariables>;
export const UpdateTargetListDocument = gql`
    mutation UpdateTargetList($id: Int!, $description: String, $name: String, $uploadedFilename: String, $isArchived: Boolean) {
  updateTargetList(
    input: {patch: {description: $description, name: $name, uploadedFilename: $uploadedFilename, isArchived: $isArchived}, id: $id}
  ) {
    clientMutationId
    targetList {
      id
      name
      description
      uploadedFilename
      uploadedAt
      npiCount
      placementLineItemIdsList
      isArchived
    }
  }
}
    `;
export type UpdateTargetListMutationFn = Apollo.MutationFunction<UpdateTargetListMutation, UpdateTargetListMutationVariables>;

/**
 * __useUpdateTargetListMutation__
 *
 * To run a mutation, you first call `useUpdateTargetListMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTargetListMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTargetListMutation, { data, loading, error }] = useUpdateTargetListMutation({
 *   variables: {
 *      id: // value for 'id'
 *      description: // value for 'description'
 *      name: // value for 'name'
 *      uploadedFilename: // value for 'uploadedFilename'
 *      isArchived: // value for 'isArchived'
 *   },
 * });
 */
export function useUpdateTargetListMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTargetListMutation, UpdateTargetListMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTargetListMutation, UpdateTargetListMutationVariables>(UpdateTargetListDocument, options);
      }
export type UpdateTargetListMutationHookResult = ReturnType<typeof useUpdateTargetListMutation>;
export type UpdateTargetListMutationResult = Apollo.MutationResult<UpdateTargetListMutation>;
export type UpdateTargetListMutationOptions = Apollo.BaseMutationOptions<UpdateTargetListMutation, UpdateTargetListMutationVariables>;
export const SetTargetListNpisDocument = gql`
    mutation SetTargetListNpis($id: Int!, $npis: [Int]!) {
  setTargetListNpis(input: {targetListId: $id, npis: $npis}) {
    clientMutationId
    query {
      targetList(id: $id) {
        id
        name
        description
        uploadedFilename
        uploadedAt
        npiCount
        placementLineItemIdsList
      }
    }
  }
}
    `;
export type SetTargetListNpisMutationFn = Apollo.MutationFunction<SetTargetListNpisMutation, SetTargetListNpisMutationVariables>;

/**
 * __useSetTargetListNpisMutation__
 *
 * To run a mutation, you first call `useSetTargetListNpisMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetTargetListNpisMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setTargetListNpisMutation, { data, loading, error }] = useSetTargetListNpisMutation({
 *   variables: {
 *      id: // value for 'id'
 *      npis: // value for 'npis'
 *   },
 * });
 */
export function useSetTargetListNpisMutation(baseOptions?: Apollo.MutationHookOptions<SetTargetListNpisMutation, SetTargetListNpisMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetTargetListNpisMutation, SetTargetListNpisMutationVariables>(SetTargetListNpisDocument, options);
      }
export type SetTargetListNpisMutationHookResult = ReturnType<typeof useSetTargetListNpisMutation>;
export type SetTargetListNpisMutationResult = Apollo.MutationResult<SetTargetListNpisMutation>;
export type SetTargetListNpisMutationOptions = Apollo.BaseMutationOptions<SetTargetListNpisMutation, SetTargetListNpisMutationVariables>;
export const DuplicateClicksCreativeDocument = gql`
    mutation DuplicateClicksCreative($existingId: Int!) {
  duplicateClicksCreative(input: {existingId: $existingId}) {
    clientMutationId
    clicksCreative {
      id
    }
  }
}
    `;
export type DuplicateClicksCreativeMutationFn = Apollo.MutationFunction<DuplicateClicksCreativeMutation, DuplicateClicksCreativeMutationVariables>;

/**
 * __useDuplicateClicksCreativeMutation__
 *
 * To run a mutation, you first call `useDuplicateClicksCreativeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDuplicateClicksCreativeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [duplicateClicksCreativeMutation, { data, loading, error }] = useDuplicateClicksCreativeMutation({
 *   variables: {
 *      existingId: // value for 'existingId'
 *   },
 * });
 */
export function useDuplicateClicksCreativeMutation(baseOptions?: Apollo.MutationHookOptions<DuplicateClicksCreativeMutation, DuplicateClicksCreativeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DuplicateClicksCreativeMutation, DuplicateClicksCreativeMutationVariables>(DuplicateClicksCreativeDocument, options);
      }
export type DuplicateClicksCreativeMutationHookResult = ReturnType<typeof useDuplicateClicksCreativeMutation>;
export type DuplicateClicksCreativeMutationResult = Apollo.MutationResult<DuplicateClicksCreativeMutation>;
export type DuplicateClicksCreativeMutationOptions = Apollo.BaseMutationOptions<DuplicateClicksCreativeMutation, DuplicateClicksCreativeMutationVariables>;
export const UpdateFmaCreativeDocument = gql`
    mutation UpdateFmaCreative($id: Int!, $patch: FmaCreativePatch!, $targetListIds: [Int]!) {
  updateFmaCreative(input: {id: $id, patch: $patch}) {
    clientMutationId
    fmaCreative {
      id
    }
  }
  setFmaCreativeTargetLists(
    input: {fmaCreativeId: $id, targetListIds: $targetListIds}
  ) {
    clientMutationId
  }
}
    `;
export type UpdateFmaCreativeMutationFn = Apollo.MutationFunction<UpdateFmaCreativeMutation, UpdateFmaCreativeMutationVariables>;

/**
 * __useUpdateFmaCreativeMutation__
 *
 * To run a mutation, you first call `useUpdateFmaCreativeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFmaCreativeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFmaCreativeMutation, { data, loading, error }] = useUpdateFmaCreativeMutation({
 *   variables: {
 *      id: // value for 'id'
 *      patch: // value for 'patch'
 *      targetListIds: // value for 'targetListIds'
 *   },
 * });
 */
export function useUpdateFmaCreativeMutation(baseOptions?: Apollo.MutationHookOptions<UpdateFmaCreativeMutation, UpdateFmaCreativeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateFmaCreativeMutation, UpdateFmaCreativeMutationVariables>(UpdateFmaCreativeDocument, options);
      }
export type UpdateFmaCreativeMutationHookResult = ReturnType<typeof useUpdateFmaCreativeMutation>;
export type UpdateFmaCreativeMutationResult = Apollo.MutationResult<UpdateFmaCreativeMutation>;
export type UpdateFmaCreativeMutationOptions = Apollo.BaseMutationOptions<UpdateFmaCreativeMutation, UpdateFmaCreativeMutationVariables>;
export const DuplicateFmaCreativeDocument = gql`
    mutation DuplicateFmaCreative($existingId: Int!) {
  duplicateFmaCreative(input: {existingId: $existingId}) {
    clientMutationId
    fmaCreative {
      id
    }
  }
}
    `;
export type DuplicateFmaCreativeMutationFn = Apollo.MutationFunction<DuplicateFmaCreativeMutation, DuplicateFmaCreativeMutationVariables>;

/**
 * __useDuplicateFmaCreativeMutation__
 *
 * To run a mutation, you first call `useDuplicateFmaCreativeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDuplicateFmaCreativeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [duplicateFmaCreativeMutation, { data, loading, error }] = useDuplicateFmaCreativeMutation({
 *   variables: {
 *      existingId: // value for 'existingId'
 *   },
 * });
 */
export function useDuplicateFmaCreativeMutation(baseOptions?: Apollo.MutationHookOptions<DuplicateFmaCreativeMutation, DuplicateFmaCreativeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DuplicateFmaCreativeMutation, DuplicateFmaCreativeMutationVariables>(DuplicateFmaCreativeDocument, options);
      }
export type DuplicateFmaCreativeMutationHookResult = ReturnType<typeof useDuplicateFmaCreativeMutation>;
export type DuplicateFmaCreativeMutationResult = Apollo.MutationResult<DuplicateFmaCreativeMutation>;
export type DuplicateFmaCreativeMutationOptions = Apollo.BaseMutationOptions<DuplicateFmaCreativeMutation, DuplicateFmaCreativeMutationVariables>;
export const CreateFmaCreativeDocument = gql`
    mutation CreateFmaCreative($input: CreateFmaCreativeInput!) {
  createFmaCreative(input: $input) {
    clientMutationId
    fmaCreative {
      id
    }
  }
}
    `;
export type CreateFmaCreativeMutationFn = Apollo.MutationFunction<CreateFmaCreativeMutation, CreateFmaCreativeMutationVariables>;

/**
 * __useCreateFmaCreativeMutation__
 *
 * To run a mutation, you first call `useCreateFmaCreativeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFmaCreativeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFmaCreativeMutation, { data, loading, error }] = useCreateFmaCreativeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateFmaCreativeMutation(baseOptions?: Apollo.MutationHookOptions<CreateFmaCreativeMutation, CreateFmaCreativeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateFmaCreativeMutation, CreateFmaCreativeMutationVariables>(CreateFmaCreativeDocument, options);
      }
export type CreateFmaCreativeMutationHookResult = ReturnType<typeof useCreateFmaCreativeMutation>;
export type CreateFmaCreativeMutationResult = Apollo.MutationResult<CreateFmaCreativeMutation>;
export type CreateFmaCreativeMutationOptions = Apollo.BaseMutationOptions<CreateFmaCreativeMutation, CreateFmaCreativeMutationVariables>;
export const SetFmaCreativeTargetListsDocument = gql`
    mutation SetFmaCreativeTargetLists($input: SetFmaCreativeTargetListsInput!) {
  setFmaCreativeTargetLists(input: $input) {
    clientMutationId
  }
}
    `;
export type SetFmaCreativeTargetListsMutationFn = Apollo.MutationFunction<SetFmaCreativeTargetListsMutation, SetFmaCreativeTargetListsMutationVariables>;

/**
 * __useSetFmaCreativeTargetListsMutation__
 *
 * To run a mutation, you first call `useSetFmaCreativeTargetListsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetFmaCreativeTargetListsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setFmaCreativeTargetListsMutation, { data, loading, error }] = useSetFmaCreativeTargetListsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetFmaCreativeTargetListsMutation(baseOptions?: Apollo.MutationHookOptions<SetFmaCreativeTargetListsMutation, SetFmaCreativeTargetListsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetFmaCreativeTargetListsMutation, SetFmaCreativeTargetListsMutationVariables>(SetFmaCreativeTargetListsDocument, options);
      }
export type SetFmaCreativeTargetListsMutationHookResult = ReturnType<typeof useSetFmaCreativeTargetListsMutation>;
export type SetFmaCreativeTargetListsMutationResult = Apollo.MutationResult<SetFmaCreativeTargetListsMutation>;
export type SetFmaCreativeTargetListsMutationOptions = Apollo.BaseMutationOptions<SetFmaCreativeTargetListsMutation, SetFmaCreativeTargetListsMutationVariables>;
export const UpdateClicksCreativeDocument = gql`
    mutation UpdateClicksCreative($id: Int!, $patch: ClicksCreativePatch!, $daysToHide: [DayOfWeekType]!, $targetListIds: [Int]!, $professionIds: [Int]!, $specialtyIds: [Int]!) {
  updateClicksCreative(input: {patch: $patch, id: $id}) {
    clientMutationId
    clicksCreative {
      id
    }
  }
  setClicksCreativeHideOnDays(
    input: {clicksCreativeId: $id, daysToHide: $daysToHide}
  ) {
    clientMutationId
  }
  setClicksCreativeProfessions(
    input: {clicksCreativeId: $id, professionIds: $professionIds}
  ) {
    clientMutationId
  }
  setClicksCreativeSpecialties(
    input: {clicksCreativeId: $id, specialtyIds: $specialtyIds}
  ) {
    clientMutationId
  }
  setClicksCreativeTargetLists(
    input: {clicksCreativeId: $id, targetListIds: $targetListIds}
  ) {
    clientMutationId
  }
}
    `;
export type UpdateClicksCreativeMutationFn = Apollo.MutationFunction<UpdateClicksCreativeMutation, UpdateClicksCreativeMutationVariables>;

/**
 * __useUpdateClicksCreativeMutation__
 *
 * To run a mutation, you first call `useUpdateClicksCreativeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateClicksCreativeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateClicksCreativeMutation, { data, loading, error }] = useUpdateClicksCreativeMutation({
 *   variables: {
 *      id: // value for 'id'
 *      patch: // value for 'patch'
 *      daysToHide: // value for 'daysToHide'
 *      targetListIds: // value for 'targetListIds'
 *      professionIds: // value for 'professionIds'
 *      specialtyIds: // value for 'specialtyIds'
 *   },
 * });
 */
export function useUpdateClicksCreativeMutation(baseOptions?: Apollo.MutationHookOptions<UpdateClicksCreativeMutation, UpdateClicksCreativeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateClicksCreativeMutation, UpdateClicksCreativeMutationVariables>(UpdateClicksCreativeDocument, options);
      }
export type UpdateClicksCreativeMutationHookResult = ReturnType<typeof useUpdateClicksCreativeMutation>;
export type UpdateClicksCreativeMutationResult = Apollo.MutationResult<UpdateClicksCreativeMutation>;
export type UpdateClicksCreativeMutationOptions = Apollo.BaseMutationOptions<UpdateClicksCreativeMutation, UpdateClicksCreativeMutationVariables>;
export const CreateClicksCreativeDocument = gql`
    mutation CreateClicksCreative($input: CreateClicksCreativeInput!) {
  createClicksCreative(input: $input) {
    clientMutationId
    clicksCreative {
      id
    }
  }
}
    `;
export type CreateClicksCreativeMutationFn = Apollo.MutationFunction<CreateClicksCreativeMutation, CreateClicksCreativeMutationVariables>;

/**
 * __useCreateClicksCreativeMutation__
 *
 * To run a mutation, you first call `useCreateClicksCreativeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateClicksCreativeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createClicksCreativeMutation, { data, loading, error }] = useCreateClicksCreativeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateClicksCreativeMutation(baseOptions?: Apollo.MutationHookOptions<CreateClicksCreativeMutation, CreateClicksCreativeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateClicksCreativeMutation, CreateClicksCreativeMutationVariables>(CreateClicksCreativeDocument, options);
      }
export type CreateClicksCreativeMutationHookResult = ReturnType<typeof useCreateClicksCreativeMutation>;
export type CreateClicksCreativeMutationResult = Apollo.MutationResult<CreateClicksCreativeMutation>;
export type CreateClicksCreativeMutationOptions = Apollo.BaseMutationOptions<CreateClicksCreativeMutation, CreateClicksCreativeMutationVariables>;
export const SetClicksCreativeListsDocument = gql`
    mutation SetClicksCreativeLists($id: Int!, $daysToHide: [DayOfWeekType]!, $targetListIds: [Int]!, $professionIds: [Int]!, $specialtyIds: [Int]!) {
  setClicksCreativeHideOnDays(
    input: {clicksCreativeId: $id, daysToHide: $daysToHide}
  ) {
    clientMutationId
  }
  setClicksCreativeProfessions(
    input: {clicksCreativeId: $id, professionIds: $professionIds}
  ) {
    clientMutationId
  }
  setClicksCreativeSpecialties(
    input: {clicksCreativeId: $id, specialtyIds: $specialtyIds}
  ) {
    clientMutationId
  }
  setClicksCreativeTargetLists(
    input: {clicksCreativeId: $id, targetListIds: $targetListIds}
  ) {
    clientMutationId
  }
}
    `;
export type SetClicksCreativeListsMutationFn = Apollo.MutationFunction<SetClicksCreativeListsMutation, SetClicksCreativeListsMutationVariables>;

/**
 * __useSetClicksCreativeListsMutation__
 *
 * To run a mutation, you first call `useSetClicksCreativeListsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetClicksCreativeListsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setClicksCreativeListsMutation, { data, loading, error }] = useSetClicksCreativeListsMutation({
 *   variables: {
 *      id: // value for 'id'
 *      daysToHide: // value for 'daysToHide'
 *      targetListIds: // value for 'targetListIds'
 *      professionIds: // value for 'professionIds'
 *      specialtyIds: // value for 'specialtyIds'
 *   },
 * });
 */
export function useSetClicksCreativeListsMutation(baseOptions?: Apollo.MutationHookOptions<SetClicksCreativeListsMutation, SetClicksCreativeListsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetClicksCreativeListsMutation, SetClicksCreativeListsMutationVariables>(SetClicksCreativeListsDocument, options);
      }
export type SetClicksCreativeListsMutationHookResult = ReturnType<typeof useSetClicksCreativeListsMutation>;
export type SetClicksCreativeListsMutationResult = Apollo.MutationResult<SetClicksCreativeListsMutation>;
export type SetClicksCreativeListsMutationOptions = Apollo.BaseMutationOptions<SetClicksCreativeListsMutation, SetClicksCreativeListsMutationVariables>;
export const ArchiveLabelDocument = gql`
    mutation ArchiveLabel($id: UUID!, $isArchived: Boolean!, $name: String!, $updatedBy: String!) {
  updateLabel(
    input: {id: $id, patch: {isArchived: $isArchived, name: $name, updatedBy: $updatedBy}}
  ) {
    label {
      id
      name
      description
      isArchived
    }
  }
}
    `;
export type ArchiveLabelMutationFn = Apollo.MutationFunction<ArchiveLabelMutation, ArchiveLabelMutationVariables>;

/**
 * __useArchiveLabelMutation__
 *
 * To run a mutation, you first call `useArchiveLabelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveLabelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveLabelMutation, { data, loading, error }] = useArchiveLabelMutation({
 *   variables: {
 *      id: // value for 'id'
 *      isArchived: // value for 'isArchived'
 *      name: // value for 'name'
 *      updatedBy: // value for 'updatedBy'
 *   },
 * });
 */
export function useArchiveLabelMutation(baseOptions?: Apollo.MutationHookOptions<ArchiveLabelMutation, ArchiveLabelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ArchiveLabelMutation, ArchiveLabelMutationVariables>(ArchiveLabelDocument, options);
      }
export type ArchiveLabelMutationHookResult = ReturnType<typeof useArchiveLabelMutation>;
export type ArchiveLabelMutationResult = Apollo.MutationResult<ArchiveLabelMutation>;
export type ArchiveLabelMutationOptions = Apollo.BaseMutationOptions<ArchiveLabelMutation, ArchiveLabelMutationVariables>;
export const DeleteLineItemLabelDocument = gql`
    mutation DeleteLineItemLabel($placementsLineItemId: String!, $labelId: UUID!) {
  deleteLineItemLabel(
    input: {placementsLineItemId: $placementsLineItemId, labelId: $labelId}
  ) {
    lineItemLabel {
      placementsLineItemId
      lineItemId
      labelId
    }
  }
}
    `;
export type DeleteLineItemLabelMutationFn = Apollo.MutationFunction<DeleteLineItemLabelMutation, DeleteLineItemLabelMutationVariables>;

/**
 * __useDeleteLineItemLabelMutation__
 *
 * To run a mutation, you first call `useDeleteLineItemLabelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteLineItemLabelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteLineItemLabelMutation, { data, loading, error }] = useDeleteLineItemLabelMutation({
 *   variables: {
 *      placementsLineItemId: // value for 'placementsLineItemId'
 *      labelId: // value for 'labelId'
 *   },
 * });
 */
export function useDeleteLineItemLabelMutation(baseOptions?: Apollo.MutationHookOptions<DeleteLineItemLabelMutation, DeleteLineItemLabelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteLineItemLabelMutation, DeleteLineItemLabelMutationVariables>(DeleteLineItemLabelDocument, options);
      }
export type DeleteLineItemLabelMutationHookResult = ReturnType<typeof useDeleteLineItemLabelMutation>;
export type DeleteLineItemLabelMutationResult = Apollo.MutationResult<DeleteLineItemLabelMutation>;
export type DeleteLineItemLabelMutationOptions = Apollo.BaseMutationOptions<DeleteLineItemLabelMutation, DeleteLineItemLabelMutationVariables>;
export const DeleteCampaignLabelDocument = gql`
    mutation DeleteCampaignLabel($placementsCampaignId: String!, $labelId: UUID!) {
  deleteCampaignLabel(
    input: {placementsCampaignId: $placementsCampaignId, labelId: $labelId}
  ) {
    campaignLabel {
      placementsCampaignId
      labelId
    }
  }
}
    `;
export type DeleteCampaignLabelMutationFn = Apollo.MutationFunction<DeleteCampaignLabelMutation, DeleteCampaignLabelMutationVariables>;

/**
 * __useDeleteCampaignLabelMutation__
 *
 * To run a mutation, you first call `useDeleteCampaignLabelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCampaignLabelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCampaignLabelMutation, { data, loading, error }] = useDeleteCampaignLabelMutation({
 *   variables: {
 *      placementsCampaignId: // value for 'placementsCampaignId'
 *      labelId: // value for 'labelId'
 *   },
 * });
 */
export function useDeleteCampaignLabelMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCampaignLabelMutation, DeleteCampaignLabelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCampaignLabelMutation, DeleteCampaignLabelMutationVariables>(DeleteCampaignLabelDocument, options);
      }
export type DeleteCampaignLabelMutationHookResult = ReturnType<typeof useDeleteCampaignLabelMutation>;
export type DeleteCampaignLabelMutationResult = Apollo.MutationResult<DeleteCampaignLabelMutation>;
export type DeleteCampaignLabelMutationOptions = Apollo.BaseMutationOptions<DeleteCampaignLabelMutation, DeleteCampaignLabelMutationVariables>;
export const CreateSponsoredContentTeaserDocument = gql`
    mutation CreateSponsoredContentTeaser($input: CreateSponsoredContentTeaserInput!) {
  createSponsoredContentTeaser(input: $input) {
    clientMutationId
    sponsoredContentTeaser {
      id
    }
  }
}
    `;
export type CreateSponsoredContentTeaserMutationFn = Apollo.MutationFunction<CreateSponsoredContentTeaserMutation, CreateSponsoredContentTeaserMutationVariables>;

/**
 * __useCreateSponsoredContentTeaserMutation__
 *
 * To run a mutation, you first call `useCreateSponsoredContentTeaserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSponsoredContentTeaserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSponsoredContentTeaserMutation, { data, loading, error }] = useCreateSponsoredContentTeaserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateSponsoredContentTeaserMutation(baseOptions?: Apollo.MutationHookOptions<CreateSponsoredContentTeaserMutation, CreateSponsoredContentTeaserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSponsoredContentTeaserMutation, CreateSponsoredContentTeaserMutationVariables>(CreateSponsoredContentTeaserDocument, options);
      }
export type CreateSponsoredContentTeaserMutationHookResult = ReturnType<typeof useCreateSponsoredContentTeaserMutation>;
export type CreateSponsoredContentTeaserMutationResult = Apollo.MutationResult<CreateSponsoredContentTeaserMutation>;
export type CreateSponsoredContentTeaserMutationOptions = Apollo.BaseMutationOptions<CreateSponsoredContentTeaserMutation, CreateSponsoredContentTeaserMutationVariables>;
export const UpdateSponsoredContentTeaserDocument = gql`
    mutation UpdateSponsoredContentTeaser($id: Int!, $patch: SponsoredContentTeaserPatch!, $targetListIds: [Int]!, $professionIds: [Int]!, $specialtyIds: [Int]!) {
  updateSponsoredContentTeaser(input: {patch: $patch, id: $id}) {
    clientMutationId
    sponsoredContentTeaser {
      id
    }
  }
  setSponsoredContentTeaserSpecialties(
    input: {sponsoredContentTeaserId: $id, specialtyIds: $specialtyIds}
  ) {
    clientMutationId
  }
  setSponsoredContentTeaserProfessions(
    input: {sponsoredContentTeaserId: $id, professionIds: $professionIds}
  ) {
    clientMutationId
  }
  setSponsoredContentTeaserTargetLists(
    input: {sponsoredContentTeaserId: $id, targetListIds: $targetListIds}
  ) {
    clientMutationId
  }
}
    `;
export type UpdateSponsoredContentTeaserMutationFn = Apollo.MutationFunction<UpdateSponsoredContentTeaserMutation, UpdateSponsoredContentTeaserMutationVariables>;

/**
 * __useUpdateSponsoredContentTeaserMutation__
 *
 * To run a mutation, you first call `useUpdateSponsoredContentTeaserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSponsoredContentTeaserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSponsoredContentTeaserMutation, { data, loading, error }] = useUpdateSponsoredContentTeaserMutation({
 *   variables: {
 *      id: // value for 'id'
 *      patch: // value for 'patch'
 *      targetListIds: // value for 'targetListIds'
 *      professionIds: // value for 'professionIds'
 *      specialtyIds: // value for 'specialtyIds'
 *   },
 * });
 */
export function useUpdateSponsoredContentTeaserMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSponsoredContentTeaserMutation, UpdateSponsoredContentTeaserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSponsoredContentTeaserMutation, UpdateSponsoredContentTeaserMutationVariables>(UpdateSponsoredContentTeaserDocument, options);
      }
export type UpdateSponsoredContentTeaserMutationHookResult = ReturnType<typeof useUpdateSponsoredContentTeaserMutation>;
export type UpdateSponsoredContentTeaserMutationResult = Apollo.MutationResult<UpdateSponsoredContentTeaserMutation>;
export type UpdateSponsoredContentTeaserMutationOptions = Apollo.BaseMutationOptions<UpdateSponsoredContentTeaserMutation, UpdateSponsoredContentTeaserMutationVariables>;
export const SetSponsoredContentTeaserListsDocument = gql`
    mutation SetSponsoredContentTeaserLists($id: Int!, $targetListIds: [Int]!, $professionIds: [Int]!, $specialtyIds: [Int]!) {
  setSponsoredContentTeaserProfessions(
    input: {sponsoredContentTeaserId: $id, professionIds: $professionIds}
  ) {
    clientMutationId
  }
  setSponsoredContentTeaserSpecialties(
    input: {sponsoredContentTeaserId: $id, specialtyIds: $specialtyIds}
  ) {
    clientMutationId
  }
  setSponsoredContentTeaserTargetLists(
    input: {sponsoredContentTeaserId: $id, targetListIds: $targetListIds}
  ) {
    clientMutationId
  }
}
    `;
export type SetSponsoredContentTeaserListsMutationFn = Apollo.MutationFunction<SetSponsoredContentTeaserListsMutation, SetSponsoredContentTeaserListsMutationVariables>;

/**
 * __useSetSponsoredContentTeaserListsMutation__
 *
 * To run a mutation, you first call `useSetSponsoredContentTeaserListsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetSponsoredContentTeaserListsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setSponsoredContentTeaserListsMutation, { data, loading, error }] = useSetSponsoredContentTeaserListsMutation({
 *   variables: {
 *      id: // value for 'id'
 *      targetListIds: // value for 'targetListIds'
 *      professionIds: // value for 'professionIds'
 *      specialtyIds: // value for 'specialtyIds'
 *   },
 * });
 */
export function useSetSponsoredContentTeaserListsMutation(baseOptions?: Apollo.MutationHookOptions<SetSponsoredContentTeaserListsMutation, SetSponsoredContentTeaserListsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetSponsoredContentTeaserListsMutation, SetSponsoredContentTeaserListsMutationVariables>(SetSponsoredContentTeaserListsDocument, options);
      }
export type SetSponsoredContentTeaserListsMutationHookResult = ReturnType<typeof useSetSponsoredContentTeaserListsMutation>;
export type SetSponsoredContentTeaserListsMutationResult = Apollo.MutationResult<SetSponsoredContentTeaserListsMutation>;
export type SetSponsoredContentTeaserListsMutationOptions = Apollo.BaseMutationOptions<SetSponsoredContentTeaserListsMutation, SetSponsoredContentTeaserListsMutationVariables>;
export const CreateEndemicDriverDocument = gql`
    mutation CreateEndemicDriver($input: CreateEndemicDriverInput!) {
  createEndemicDriver(input: $input) {
    clientMutationId
    endemicDriver {
      id
      contentfulId
      driverContentType
      name
      priority
      isApproved
      startsAt
      endsAt
    }
  }
}
    `;
export type CreateEndemicDriverMutationFn = Apollo.MutationFunction<CreateEndemicDriverMutation, CreateEndemicDriverMutationVariables>;

/**
 * __useCreateEndemicDriverMutation__
 *
 * To run a mutation, you first call `useCreateEndemicDriverMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEndemicDriverMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEndemicDriverMutation, { data, loading, error }] = useCreateEndemicDriverMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateEndemicDriverMutation(baseOptions?: Apollo.MutationHookOptions<CreateEndemicDriverMutation, CreateEndemicDriverMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateEndemicDriverMutation, CreateEndemicDriverMutationVariables>(CreateEndemicDriverDocument, options);
      }
export type CreateEndemicDriverMutationHookResult = ReturnType<typeof useCreateEndemicDriverMutation>;
export type CreateEndemicDriverMutationResult = Apollo.MutationResult<CreateEndemicDriverMutation>;
export type CreateEndemicDriverMutationOptions = Apollo.BaseMutationOptions<CreateEndemicDriverMutation, CreateEndemicDriverMutationVariables>;
export const CreateLeadGenCampaignDocument = gql`
    mutation CreateLeadGenCampaign($name: String!, $startsAt: Datetime!, $endsAt: Datetime!, $priority: Int, $maxViewsPerNpi: Int, $maxViewsPerSession: Int, $isApproved: Boolean) {
  createLeadGenCampaign(
    input: {leadGenCampaign: {name: $name, startsAt: $startsAt, endsAt: $endsAt, priority: $priority, maxViewsPerNpi: $maxViewsPerNpi, maxViewsPerSession: $maxViewsPerSession, isApproved: $isApproved}}
  ) {
    leadGenCampaign {
      id
      name
      startsAt
      endsAt
      priority
      maxViewsPerNpi
      maxViewsPerSession
      isApproved
      createdAt
      updatedAt
    }
  }
}
    `;
export type CreateLeadGenCampaignMutationFn = Apollo.MutationFunction<CreateLeadGenCampaignMutation, CreateLeadGenCampaignMutationVariables>;

/**
 * __useCreateLeadGenCampaignMutation__
 *
 * To run a mutation, you first call `useCreateLeadGenCampaignMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateLeadGenCampaignMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createLeadGenCampaignMutation, { data, loading, error }] = useCreateLeadGenCampaignMutation({
 *   variables: {
 *      name: // value for 'name'
 *      startsAt: // value for 'startsAt'
 *      endsAt: // value for 'endsAt'
 *      priority: // value for 'priority'
 *      maxViewsPerNpi: // value for 'maxViewsPerNpi'
 *      maxViewsPerSession: // value for 'maxViewsPerSession'
 *      isApproved: // value for 'isApproved'
 *   },
 * });
 */
export function useCreateLeadGenCampaignMutation(baseOptions?: Apollo.MutationHookOptions<CreateLeadGenCampaignMutation, CreateLeadGenCampaignMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateLeadGenCampaignMutation, CreateLeadGenCampaignMutationVariables>(CreateLeadGenCampaignDocument, options);
      }
export type CreateLeadGenCampaignMutationHookResult = ReturnType<typeof useCreateLeadGenCampaignMutation>;
export type CreateLeadGenCampaignMutationResult = Apollo.MutationResult<CreateLeadGenCampaignMutation>;
export type CreateLeadGenCampaignMutationOptions = Apollo.BaseMutationOptions<CreateLeadGenCampaignMutation, CreateLeadGenCampaignMutationVariables>;
export const UpdateEndemicDriverDocument = gql`
    mutation UpdateEndemicDriver($input: UpdateEndemicDriverInput!) {
  updateEndemicDriver(input: $input) {
    clientMutationId
    endemicDriver {
      id
      contentfulId
      driverContentType
      name
      priority
      isApproved
      startsAt
      endsAt
    }
  }
}
    `;
export type UpdateEndemicDriverMutationFn = Apollo.MutationFunction<UpdateEndemicDriverMutation, UpdateEndemicDriverMutationVariables>;

/**
 * __useUpdateEndemicDriverMutation__
 *
 * To run a mutation, you first call `useUpdateEndemicDriverMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEndemicDriverMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEndemicDriverMutation, { data, loading, error }] = useUpdateEndemicDriverMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateEndemicDriverMutation(baseOptions?: Apollo.MutationHookOptions<UpdateEndemicDriverMutation, UpdateEndemicDriverMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateEndemicDriverMutation, UpdateEndemicDriverMutationVariables>(UpdateEndemicDriverDocument, options);
      }
export type UpdateEndemicDriverMutationHookResult = ReturnType<typeof useUpdateEndemicDriverMutation>;
export type UpdateEndemicDriverMutationResult = Apollo.MutationResult<UpdateEndemicDriverMutation>;
export type UpdateEndemicDriverMutationOptions = Apollo.BaseMutationOptions<UpdateEndemicDriverMutation, UpdateEndemicDriverMutationVariables>;
export const SetEndemicDriverTargetListsDocument = gql`
    mutation SetEndemicDriverTargetLists($input: SetEndemicDriverTargetListsInput!) {
  setEndemicDriverTargetLists(input: $input) {
    clientMutationId
  }
}
    `;
export type SetEndemicDriverTargetListsMutationFn = Apollo.MutationFunction<SetEndemicDriverTargetListsMutation, SetEndemicDriverTargetListsMutationVariables>;

/**
 * __useSetEndemicDriverTargetListsMutation__
 *
 * To run a mutation, you first call `useSetEndemicDriverTargetListsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetEndemicDriverTargetListsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setEndemicDriverTargetListsMutation, { data, loading, error }] = useSetEndemicDriverTargetListsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetEndemicDriverTargetListsMutation(baseOptions?: Apollo.MutationHookOptions<SetEndemicDriverTargetListsMutation, SetEndemicDriverTargetListsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetEndemicDriverTargetListsMutation, SetEndemicDriverTargetListsMutationVariables>(SetEndemicDriverTargetListsDocument, options);
      }
export type SetEndemicDriverTargetListsMutationHookResult = ReturnType<typeof useSetEndemicDriverTargetListsMutation>;
export type SetEndemicDriverTargetListsMutationResult = Apollo.MutationResult<SetEndemicDriverTargetListsMutation>;
export type SetEndemicDriverTargetListsMutationOptions = Apollo.BaseMutationOptions<SetEndemicDriverTargetListsMutation, SetEndemicDriverTargetListsMutationVariables>;
export const UpdateLeadGenCampaignDocument = gql`
    mutation UpdateLeadGenCampaign($id: Int!, $name: String, $startsAt: Datetime, $endsAt: Datetime, $priority: Int, $maxViewsPerNpi: Int, $maxViewsPerSession: Int, $isApproved: Boolean, $targetListIds: [Int]!) {
  updateLeadGenCampaign(
    input: {id: $id, patch: {name: $name, startsAt: $startsAt, endsAt: $endsAt, priority: $priority, maxViewsPerNpi: $maxViewsPerNpi, maxViewsPerSession: $maxViewsPerSession, isApproved: $isApproved}}
  ) {
    leadGenCampaign {
      id
      name
      startsAt
      endsAt
      priority
      maxViewsPerNpi
      maxViewsPerSession
      isApproved
      createdAt
      updatedAt
    }
  }
  setLeadGenCampaignTargetLists(
    input: {leadGenCampaignId: $id, targetListIds: $targetListIds}
  ) {
    clientMutationId
  }
}
    `;
export type UpdateLeadGenCampaignMutationFn = Apollo.MutationFunction<UpdateLeadGenCampaignMutation, UpdateLeadGenCampaignMutationVariables>;

/**
 * __useUpdateLeadGenCampaignMutation__
 *
 * To run a mutation, you first call `useUpdateLeadGenCampaignMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLeadGenCampaignMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLeadGenCampaignMutation, { data, loading, error }] = useUpdateLeadGenCampaignMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      startsAt: // value for 'startsAt'
 *      endsAt: // value for 'endsAt'
 *      priority: // value for 'priority'
 *      maxViewsPerNpi: // value for 'maxViewsPerNpi'
 *      maxViewsPerSession: // value for 'maxViewsPerSession'
 *      isApproved: // value for 'isApproved'
 *      targetListIds: // value for 'targetListIds'
 *   },
 * });
 */
export function useUpdateLeadGenCampaignMutation(baseOptions?: Apollo.MutationHookOptions<UpdateLeadGenCampaignMutation, UpdateLeadGenCampaignMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateLeadGenCampaignMutation, UpdateLeadGenCampaignMutationVariables>(UpdateLeadGenCampaignDocument, options);
      }
export type UpdateLeadGenCampaignMutationHookResult = ReturnType<typeof useUpdateLeadGenCampaignMutation>;
export type UpdateLeadGenCampaignMutationResult = Apollo.MutationResult<UpdateLeadGenCampaignMutation>;
export type UpdateLeadGenCampaignMutationOptions = Apollo.BaseMutationOptions<UpdateLeadGenCampaignMutation, UpdateLeadGenCampaignMutationVariables>;
export const SetEndemicDriverTopicTagsDocument = gql`
    mutation SetEndemicDriverTopicTags($input: SetEndemicDriverTopicTagsInput!) {
  setEndemicDriverTopicTags(input: $input) {
    clientMutationId
  }
}
    `;
export type SetEndemicDriverTopicTagsMutationFn = Apollo.MutationFunction<SetEndemicDriverTopicTagsMutation, SetEndemicDriverTopicTagsMutationVariables>;

/**
 * __useSetEndemicDriverTopicTagsMutation__
 *
 * To run a mutation, you first call `useSetEndemicDriverTopicTagsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetEndemicDriverTopicTagsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setEndemicDriverTopicTagsMutation, { data, loading, error }] = useSetEndemicDriverTopicTagsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetEndemicDriverTopicTagsMutation(baseOptions?: Apollo.MutationHookOptions<SetEndemicDriverTopicTagsMutation, SetEndemicDriverTopicTagsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetEndemicDriverTopicTagsMutation, SetEndemicDriverTopicTagsMutationVariables>(SetEndemicDriverTopicTagsDocument, options);
      }
export type SetEndemicDriverTopicTagsMutationHookResult = ReturnType<typeof useSetEndemicDriverTopicTagsMutation>;
export type SetEndemicDriverTopicTagsMutationResult = Apollo.MutationResult<SetEndemicDriverTopicTagsMutation>;
export type SetEndemicDriverTopicTagsMutationOptions = Apollo.BaseMutationOptions<SetEndemicDriverTopicTagsMutation, SetEndemicDriverTopicTagsMutationVariables>;
export const SetEndemicDriverSpecialtiesDocument = gql`
    mutation SetEndemicDriverSpecialties($input: SetEndemicDriverSpecialtiesInput!) {
  setEndemicDriverSpecialties(input: $input) {
    clientMutationId
  }
}
    `;
export type SetEndemicDriverSpecialtiesMutationFn = Apollo.MutationFunction<SetEndemicDriverSpecialtiesMutation, SetEndemicDriverSpecialtiesMutationVariables>;

/**
 * __useSetEndemicDriverSpecialtiesMutation__
 *
 * To run a mutation, you first call `useSetEndemicDriverSpecialtiesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetEndemicDriverSpecialtiesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setEndemicDriverSpecialtiesMutation, { data, loading, error }] = useSetEndemicDriverSpecialtiesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetEndemicDriverSpecialtiesMutation(baseOptions?: Apollo.MutationHookOptions<SetEndemicDriverSpecialtiesMutation, SetEndemicDriverSpecialtiesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetEndemicDriverSpecialtiesMutation, SetEndemicDriverSpecialtiesMutationVariables>(SetEndemicDriverSpecialtiesDocument, options);
      }
export type SetEndemicDriverSpecialtiesMutationHookResult = ReturnType<typeof useSetEndemicDriverSpecialtiesMutation>;
export type SetEndemicDriverSpecialtiesMutationResult = Apollo.MutationResult<SetEndemicDriverSpecialtiesMutation>;
export type SetEndemicDriverSpecialtiesMutationOptions = Apollo.BaseMutationOptions<SetEndemicDriverSpecialtiesMutation, SetEndemicDriverSpecialtiesMutationVariables>;
export const SetEndemicDriverProfessionsDocument = gql`
    mutation SetEndemicDriverProfessions($input: SetEndemicDriverProfessionsInput!) {
  setEndemicDriverProfessions(input: $input) {
    clientMutationId
  }
}
    `;
export type SetEndemicDriverProfessionsMutationFn = Apollo.MutationFunction<SetEndemicDriverProfessionsMutation, SetEndemicDriverProfessionsMutationVariables>;

/**
 * __useSetEndemicDriverProfessionsMutation__
 *
 * To run a mutation, you first call `useSetEndemicDriverProfessionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetEndemicDriverProfessionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setEndemicDriverProfessionsMutation, { data, loading, error }] = useSetEndemicDriverProfessionsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetEndemicDriverProfessionsMutation(baseOptions?: Apollo.MutationHookOptions<SetEndemicDriverProfessionsMutation, SetEndemicDriverProfessionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetEndemicDriverProfessionsMutation, SetEndemicDriverProfessionsMutationVariables>(SetEndemicDriverProfessionsDocument, options);
      }
export type SetEndemicDriverProfessionsMutationHookResult = ReturnType<typeof useSetEndemicDriverProfessionsMutation>;
export type SetEndemicDriverProfessionsMutationResult = Apollo.MutationResult<SetEndemicDriverProfessionsMutation>;
export type SetEndemicDriverProfessionsMutationOptions = Apollo.BaseMutationOptions<SetEndemicDriverProfessionsMutation, SetEndemicDriverProfessionsMutationVariables>;
export const DeleteLeadGenCampaignDocument = gql`
    mutation DeleteLeadGenCampaign($id: Int!) {
  deleteLeadGenCampaign(input: {id: $id}) {
    deletedLeadGenCampaignNodeId
  }
}
    `;
export type DeleteLeadGenCampaignMutationFn = Apollo.MutationFunction<DeleteLeadGenCampaignMutation, DeleteLeadGenCampaignMutationVariables>;

/**
 * __useDeleteLeadGenCampaignMutation__
 *
 * To run a mutation, you first call `useDeleteLeadGenCampaignMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteLeadGenCampaignMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteLeadGenCampaignMutation, { data, loading, error }] = useDeleteLeadGenCampaignMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteLeadGenCampaignMutation(baseOptions?: Apollo.MutationHookOptions<DeleteLeadGenCampaignMutation, DeleteLeadGenCampaignMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteLeadGenCampaignMutation, DeleteLeadGenCampaignMutationVariables>(DeleteLeadGenCampaignDocument, options);
      }
export type DeleteLeadGenCampaignMutationHookResult = ReturnType<typeof useDeleteLeadGenCampaignMutation>;
export type DeleteLeadGenCampaignMutationResult = Apollo.MutationResult<DeleteLeadGenCampaignMutation>;
export type DeleteLeadGenCampaignMutationOptions = Apollo.BaseMutationOptions<DeleteLeadGenCampaignMutation, DeleteLeadGenCampaignMutationVariables>;
export const SetLeadGenCampaignTargetListsDocument = gql`
    mutation SetLeadGenCampaignTargetLists($id: Int!, $targetListIds: [Int]!) {
  setLeadGenCampaignTargetLists(
    input: {leadGenCampaignId: $id, targetListIds: $targetListIds}
  ) {
    clientMutationId
  }
}
    `;
export type SetLeadGenCampaignTargetListsMutationFn = Apollo.MutationFunction<SetLeadGenCampaignTargetListsMutation, SetLeadGenCampaignTargetListsMutationVariables>;

/**
 * __useSetLeadGenCampaignTargetListsMutation__
 *
 * To run a mutation, you first call `useSetLeadGenCampaignTargetListsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetLeadGenCampaignTargetListsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setLeadGenCampaignTargetListsMutation, { data, loading, error }] = useSetLeadGenCampaignTargetListsMutation({
 *   variables: {
 *      id: // value for 'id'
 *      targetListIds: // value for 'targetListIds'
 *   },
 * });
 */
export function useSetLeadGenCampaignTargetListsMutation(baseOptions?: Apollo.MutationHookOptions<SetLeadGenCampaignTargetListsMutation, SetLeadGenCampaignTargetListsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetLeadGenCampaignTargetListsMutation, SetLeadGenCampaignTargetListsMutationVariables>(SetLeadGenCampaignTargetListsDocument, options);
      }
export type SetLeadGenCampaignTargetListsMutationHookResult = ReturnType<typeof useSetLeadGenCampaignTargetListsMutation>;
export type SetLeadGenCampaignTargetListsMutationResult = Apollo.MutationResult<SetLeadGenCampaignTargetListsMutation>;
export type SetLeadGenCampaignTargetListsMutationOptions = Apollo.BaseMutationOptions<SetLeadGenCampaignTargetListsMutation, SetLeadGenCampaignTargetListsMutationVariables>;
export const TargetListsPlacementLineItemIdsListDocument = gql`
    query TargetListsPlacementLineItemIdsList($includes: String!) {
  targetLists {
    nodes {
      id
      name
      description
      placementLineItemIdsList(filter: {includes: $includes})
    }
  }
}
    `;

/**
 * __useTargetListsPlacementLineItemIdsListQuery__
 *
 * To run a query within a React component, call `useTargetListsPlacementLineItemIdsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useTargetListsPlacementLineItemIdsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTargetListsPlacementLineItemIdsListQuery({
 *   variables: {
 *      includes: // value for 'includes'
 *   },
 * });
 */
export function useTargetListsPlacementLineItemIdsListQuery(baseOptions: Apollo.QueryHookOptions<TargetListsPlacementLineItemIdsListQuery, TargetListsPlacementLineItemIdsListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TargetListsPlacementLineItemIdsListQuery, TargetListsPlacementLineItemIdsListQueryVariables>(TargetListsPlacementLineItemIdsListDocument, options);
      }
export function useTargetListsPlacementLineItemIdsListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TargetListsPlacementLineItemIdsListQuery, TargetListsPlacementLineItemIdsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TargetListsPlacementLineItemIdsListQuery, TargetListsPlacementLineItemIdsListQueryVariables>(TargetListsPlacementLineItemIdsListDocument, options);
        }
export type TargetListsPlacementLineItemIdsListQueryHookResult = ReturnType<typeof useTargetListsPlacementLineItemIdsListQuery>;
export type TargetListsPlacementLineItemIdsListLazyQueryHookResult = ReturnType<typeof useTargetListsPlacementLineItemIdsListLazyQuery>;
export type TargetListsPlacementLineItemIdsListQueryResult = Apollo.QueryResult<TargetListsPlacementLineItemIdsListQuery, TargetListsPlacementLineItemIdsListQueryVariables>;
export const TargetListsLineItemIdsListDocument = gql`
    query TargetListsLineItemIdsList($lineItemIds: [String!]!) {
  targetLists {
    nodes {
      id
      name
      description
      lineItemIdsList(filter: {in: $lineItemIds})
    }
  }
}
    `;

/**
 * __useTargetListsLineItemIdsListQuery__
 *
 * To run a query within a React component, call `useTargetListsLineItemIdsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useTargetListsLineItemIdsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTargetListsLineItemIdsListQuery({
 *   variables: {
 *      lineItemIds: // value for 'lineItemIds'
 *   },
 * });
 */
export function useTargetListsLineItemIdsListQuery(baseOptions: Apollo.QueryHookOptions<TargetListsLineItemIdsListQuery, TargetListsLineItemIdsListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TargetListsLineItemIdsListQuery, TargetListsLineItemIdsListQueryVariables>(TargetListsLineItemIdsListDocument, options);
      }
export function useTargetListsLineItemIdsListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TargetListsLineItemIdsListQuery, TargetListsLineItemIdsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TargetListsLineItemIdsListQuery, TargetListsLineItemIdsListQueryVariables>(TargetListsLineItemIdsListDocument, options);
        }
export type TargetListsLineItemIdsListQueryHookResult = ReturnType<typeof useTargetListsLineItemIdsListQuery>;
export type TargetListsLineItemIdsListLazyQueryHookResult = ReturnType<typeof useTargetListsLineItemIdsListLazyQuery>;
export type TargetListsLineItemIdsListQueryResult = Apollo.QueryResult<TargetListsLineItemIdsListQuery, TargetListsLineItemIdsListQueryVariables>;
export const TargetListsForDropdownDocument = gql`
    query TargetListsForDropdown($first: Int, $offset: Int, $orderBy: [TargetListsOrderBy!], $filter: TargetListFilter) {
  targetLists(first: $first, offset: $offset, orderBy: $orderBy, filter: $filter) {
    totalCount
    nodes {
      id
      name
    }
  }
}
    `;

/**
 * __useTargetListsForDropdownQuery__
 *
 * To run a query within a React component, call `useTargetListsForDropdownQuery` and pass it any options that fit your needs.
 * When your component renders, `useTargetListsForDropdownQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTargetListsForDropdownQuery({
 *   variables: {
 *      first: // value for 'first'
 *      offset: // value for 'offset'
 *      orderBy: // value for 'orderBy'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useTargetListsForDropdownQuery(baseOptions?: Apollo.QueryHookOptions<TargetListsForDropdownQuery, TargetListsForDropdownQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TargetListsForDropdownQuery, TargetListsForDropdownQueryVariables>(TargetListsForDropdownDocument, options);
      }
export function useTargetListsForDropdownLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TargetListsForDropdownQuery, TargetListsForDropdownQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TargetListsForDropdownQuery, TargetListsForDropdownQueryVariables>(TargetListsForDropdownDocument, options);
        }
export type TargetListsForDropdownQueryHookResult = ReturnType<typeof useTargetListsForDropdownQuery>;
export type TargetListsForDropdownLazyQueryHookResult = ReturnType<typeof useTargetListsForDropdownLazyQuery>;
export type TargetListsForDropdownQueryResult = Apollo.QueryResult<TargetListsForDropdownQuery, TargetListsForDropdownQueryVariables>;
export const GetLabelsForLineItemByPlacementsLineItemIdDocument = gql`
    query GetLabelsForLineItemByPlacementsLineItemId($placementsLineItemId: String!) {
  lineItemLabels(filter: {placementsLineItemId: {equalTo: $placementsLineItemId}}) {
    nodes {
      placementsLineItemId
      lineItemId
      labelId
      label {
        id
        name
        isArchived
      }
    }
  }
}
    `;

/**
 * __useGetLabelsForLineItemByPlacementsLineItemIdQuery__
 *
 * To run a query within a React component, call `useGetLabelsForLineItemByPlacementsLineItemIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLabelsForLineItemByPlacementsLineItemIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLabelsForLineItemByPlacementsLineItemIdQuery({
 *   variables: {
 *      placementsLineItemId: // value for 'placementsLineItemId'
 *   },
 * });
 */
export function useGetLabelsForLineItemByPlacementsLineItemIdQuery(baseOptions: Apollo.QueryHookOptions<GetLabelsForLineItemByPlacementsLineItemIdQuery, GetLabelsForLineItemByPlacementsLineItemIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLabelsForLineItemByPlacementsLineItemIdQuery, GetLabelsForLineItemByPlacementsLineItemIdQueryVariables>(GetLabelsForLineItemByPlacementsLineItemIdDocument, options);
      }
export function useGetLabelsForLineItemByPlacementsLineItemIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLabelsForLineItemByPlacementsLineItemIdQuery, GetLabelsForLineItemByPlacementsLineItemIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLabelsForLineItemByPlacementsLineItemIdQuery, GetLabelsForLineItemByPlacementsLineItemIdQueryVariables>(GetLabelsForLineItemByPlacementsLineItemIdDocument, options);
        }
export type GetLabelsForLineItemByPlacementsLineItemIdQueryHookResult = ReturnType<typeof useGetLabelsForLineItemByPlacementsLineItemIdQuery>;
export type GetLabelsForLineItemByPlacementsLineItemIdLazyQueryHookResult = ReturnType<typeof useGetLabelsForLineItemByPlacementsLineItemIdLazyQuery>;
export type GetLabelsForLineItemByPlacementsLineItemIdQueryResult = Apollo.QueryResult<GetLabelsForLineItemByPlacementsLineItemIdQuery, GetLabelsForLineItemByPlacementsLineItemIdQueryVariables>;
export const GetLabelsForLineItemByNativeLineItemIdDocument = gql`
    query GetLabelsForLineItemByNativeLineItemId($lineItemId: UUID!) {
  lineItemLabels(filter: {lineItemId: {equalTo: $lineItemId}}) {
    nodes {
      placementsLineItemId
      lineItemId
      labelId
      label {
        id
        name
        isArchived
      }
    }
  }
}
    `;

/**
 * __useGetLabelsForLineItemByNativeLineItemIdQuery__
 *
 * To run a query within a React component, call `useGetLabelsForLineItemByNativeLineItemIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLabelsForLineItemByNativeLineItemIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLabelsForLineItemByNativeLineItemIdQuery({
 *   variables: {
 *      lineItemId: // value for 'lineItemId'
 *   },
 * });
 */
export function useGetLabelsForLineItemByNativeLineItemIdQuery(baseOptions: Apollo.QueryHookOptions<GetLabelsForLineItemByNativeLineItemIdQuery, GetLabelsForLineItemByNativeLineItemIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLabelsForLineItemByNativeLineItemIdQuery, GetLabelsForLineItemByNativeLineItemIdQueryVariables>(GetLabelsForLineItemByNativeLineItemIdDocument, options);
      }
export function useGetLabelsForLineItemByNativeLineItemIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLabelsForLineItemByNativeLineItemIdQuery, GetLabelsForLineItemByNativeLineItemIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLabelsForLineItemByNativeLineItemIdQuery, GetLabelsForLineItemByNativeLineItemIdQueryVariables>(GetLabelsForLineItemByNativeLineItemIdDocument, options);
        }
export type GetLabelsForLineItemByNativeLineItemIdQueryHookResult = ReturnType<typeof useGetLabelsForLineItemByNativeLineItemIdQuery>;
export type GetLabelsForLineItemByNativeLineItemIdLazyQueryHookResult = ReturnType<typeof useGetLabelsForLineItemByNativeLineItemIdLazyQuery>;
export type GetLabelsForLineItemByNativeLineItemIdQueryResult = Apollo.QueryResult<GetLabelsForLineItemByNativeLineItemIdQuery, GetLabelsForLineItemByNativeLineItemIdQueryVariables>;
export const GetLabelsForCampaignDocument = gql`
    query GetLabelsForCampaign($campaignId: String!) {
  campaignLabels(filter: {placementsCampaignId: {equalTo: $campaignId}}) {
    nodes {
      placementsCampaignId
      labelId
      label {
        id
        name
        isArchived
      }
    }
  }
}
    `;

/**
 * __useGetLabelsForCampaignQuery__
 *
 * To run a query within a React component, call `useGetLabelsForCampaignQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLabelsForCampaignQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLabelsForCampaignQuery({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *   },
 * });
 */
export function useGetLabelsForCampaignQuery(baseOptions: Apollo.QueryHookOptions<GetLabelsForCampaignQuery, GetLabelsForCampaignQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLabelsForCampaignQuery, GetLabelsForCampaignQueryVariables>(GetLabelsForCampaignDocument, options);
      }
export function useGetLabelsForCampaignLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLabelsForCampaignQuery, GetLabelsForCampaignQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLabelsForCampaignQuery, GetLabelsForCampaignQueryVariables>(GetLabelsForCampaignDocument, options);
        }
export type GetLabelsForCampaignQueryHookResult = ReturnType<typeof useGetLabelsForCampaignQuery>;
export type GetLabelsForCampaignLazyQueryHookResult = ReturnType<typeof useGetLabelsForCampaignLazyQuery>;
export type GetLabelsForCampaignQueryResult = Apollo.QueryResult<GetLabelsForCampaignQuery, GetLabelsForCampaignQueryVariables>;
export const GetLeadGenCampaignsDocument = gql`
    query GetLeadGenCampaigns($first: Int, $last: Int, $offset: Int, $before: Cursor, $after: Cursor, $orderBy: [LeadGenCampaignsOrderBy!], $filter: LeadGenCampaignFilter) {
  leadGenCampaigns(
    first: $first
    last: $last
    offset: $offset
    before: $before
    after: $after
    orderBy: $orderBy
    filter: $filter
  ) {
    totalCount
    nodes {
      id
      name
      startsAt
      endsAt
      targetListIdsList
      targetListsList {
        id
        name
      }
      isApproved
      createdAt
      updatedAt
    }
  }
}
    `;

/**
 * __useGetLeadGenCampaignsQuery__
 *
 * To run a query within a React component, call `useGetLeadGenCampaignsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLeadGenCampaignsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLeadGenCampaignsQuery({
 *   variables: {
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      offset: // value for 'offset'
 *      before: // value for 'before'
 *      after: // value for 'after'
 *      orderBy: // value for 'orderBy'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetLeadGenCampaignsQuery(baseOptions?: Apollo.QueryHookOptions<GetLeadGenCampaignsQuery, GetLeadGenCampaignsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLeadGenCampaignsQuery, GetLeadGenCampaignsQueryVariables>(GetLeadGenCampaignsDocument, options);
      }
export function useGetLeadGenCampaignsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLeadGenCampaignsQuery, GetLeadGenCampaignsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLeadGenCampaignsQuery, GetLeadGenCampaignsQueryVariables>(GetLeadGenCampaignsDocument, options);
        }
export type GetLeadGenCampaignsQueryHookResult = ReturnType<typeof useGetLeadGenCampaignsQuery>;
export type GetLeadGenCampaignsLazyQueryHookResult = ReturnType<typeof useGetLeadGenCampaignsLazyQuery>;
export type GetLeadGenCampaignsQueryResult = Apollo.QueryResult<GetLeadGenCampaignsQuery, GetLeadGenCampaignsQueryVariables>;
export const GetLeadGenCampaignDocument = gql`
    query GetLeadGenCampaign($id: Int!) {
  leadGenCampaign(id: $id) {
    id
    name
    startsAt
    endsAt
    targetListIdsList
    priority
    maxViewsPerNpi
    maxViewsPerSession
    isApproved
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useGetLeadGenCampaignQuery__
 *
 * To run a query within a React component, call `useGetLeadGenCampaignQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLeadGenCampaignQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLeadGenCampaignQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetLeadGenCampaignQuery(baseOptions: Apollo.QueryHookOptions<GetLeadGenCampaignQuery, GetLeadGenCampaignQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLeadGenCampaignQuery, GetLeadGenCampaignQueryVariables>(GetLeadGenCampaignDocument, options);
      }
export function useGetLeadGenCampaignLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLeadGenCampaignQuery, GetLeadGenCampaignQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLeadGenCampaignQuery, GetLeadGenCampaignQueryVariables>(GetLeadGenCampaignDocument, options);
        }
export type GetLeadGenCampaignQueryHookResult = ReturnType<typeof useGetLeadGenCampaignQuery>;
export type GetLeadGenCampaignLazyQueryHookResult = ReturnType<typeof useGetLeadGenCampaignLazyQuery>;
export type GetLeadGenCampaignQueryResult = Apollo.QueryResult<GetLeadGenCampaignQuery, GetLeadGenCampaignQueryVariables>;